import {
  App,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Descriptions,
  Divider,
  Dropdown,
  Flex,
  Form,
  Input,
  Menu,
  Modal,
  Popover,
  Radio,
  Row,
  Segmented,
  Select,
  Space,
  Spin,
  Switch,
  Table,
  Tag,
  TimePicker,
} from 'antd';
import { memo, useEffect, useRef, useState } from 'react';
import { MdDelete, MdLanguage, MdModeEditOutline } from 'react-icons/md';
import { CheckOutlined, PlusOutlined } from '@ant-design/icons';
import {
  addDepartments,
  addPractitionerSchedule,
  getDepartmentInfo,
  getPatientCareTypes,
  getPractitionerScheduleInfo,
  updateDepartments,
  updatePractitionerSchedule,
} from '../../../network/Departments';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  addServiceUnits,
  getItemGroups,
  getServiceUnitTypes,
  getWarehouses,
} from '../../../network/serviceUnits';
import {
  addMaterials,
  getMaterialsDetails,
  updateMaterials,
} from '../../../network/materials';
import {
  addEligibilityPlan,
  getEligibilityPlanById,
  getEligibilityPlans,
  getInsurancePayors,
  getSellingPriceList,
  updateEligibilityPlan,
} from '../../../network/eligibilityPlan';
// import { addPayorContract} from "../../../network/PayorContract";
import {
  addPayorContract,
  getPayorContractsById,
  updatePayorContract,
} from '../../../network/PatientInsurancePolicy';
import {
  addFiscalYear,
  getFiscalYearById,
  updateFiscalYear,
} from '../../../network/FiscalYear';
import {
  addDiagnosis,
  getDiagnosisDetails,
  updateDiagnosis,
} from '../../../network/Diagnosis';
import {
  getAppointmentsDetails,
  getAvailableTimeSlots,
  getListTimeSlots,
  getSearchApiIsStock,
  getSearchPatients,
  updateAppointments,
} from '../../../network/appointment';
import { useSelector } from 'react-redux';
import {
  addAppointmentTypes,
  getAppointmentTypesDetails,
  updateAppointmentTypes,
} from '../../../network/AppointmentDuration';
import {
  addIllnesses,
  getIllnessesDetails,
  updateIllnesses,
} from '../../../network/illnesses';
import { addBnpi, getIBnpiDetails, updateBnpi } from '../../../network/bnpi';
import {
  getExpenseAccounts,
  getReceivableAccounts,
} from '../../../network/insurancePayor';
import {
  addCostCenter,
  getCostCenterDetails,
  getCostCenterParties,
  getCostCenters,
  updateCostCenter,
} from '../../../network/costCenter';
import {
  getPractitioners,
  getPractitionersDetails,
} from '../../../network/practitioners';
import { colorPrimary, getTimeFormat } from '../../../utils/utils';
import { getAccounts, getModeOfPayments } from '../../../network/PaymentEntry';
import {
  createPaymentEntryQuick,
  getLastInvoices,
  getLinkedEntries,
  getPrintFormat,
  getSalesInvoiceDetails,
  getVatTax,
  unlinkEntries,
} from '../../../network/salesInvoice';
import DynamicTableAnt from '../../../hooks/DynamicTableAnt';
import { getLastEncounters } from '../../../network/encounters';
import {
  addItemInsuranceEligibility,
  getAllItems,
  getItemInsuranceEligibilityById,
  updateItemInsuranceEligibility,
} from '../../../network/ItemEligibility';
import dayjs from 'dayjs';
import {
  addComplaint,
  getComplaintById,
  updateComplaint,
} from '../../../network/complaint';
import PhoneInputWithCountrySelect, {
  isValidPhoneNumber,
} from 'react-phone-number-input';
import { addReconcillation } from '../../../network/reconcillation';
import {
  addAccount,
  getBankAccount,
  getBankAccountDetails,
  updateAccount,
} from '../../../network/bankAccount';
import {
  addBank,
  getBank,
  getBankDetails,
  updateBank,
} from '../../../network/bank';
import {
  addCostCenterAllocation,
  getCostCenterAllocationDetails,
  updateCostCenterAllocation,
} from '../../../network/CostCenterAllocation';
import {
  addSupplierGroup,
  getSupplierGroup,
  getSupplierGroupDetails,
  updateSupplierGroup,
} from '../../../network/supplierGroup';
import { getCountriesWithLanguages } from '../../../network/patients';
import {
  getAllServicesAndItem,
  getPriceLists,
  getStockUoms,
} from '../../../network/Item';
import {
  addSupplier,
  getPriceListsSupplier,
  getSupplier,
  getSupplierDetails,
  updateSupplier,
} from '../../../network/supplier';
import {
  addWarehouse,
  getWarehouse,
  getWarehouseDetails,
  updateWarehouse,
} from '../../../network/warehouse';
import {
  addMaterialRequest,
  getItemDetails,
  getMaterialRequestDetails,
  getStockItems,
  submitMaterialRequest,
  updateMaterialRequest,
} from '../../../network/materialRequest';
import {
  addPriceList,
  getPriceList,
  getPriceListDetails,
  updatePriceList,
} from '../../../network/priceList';
import {
  addUnitMeasure,
  getUnitMeasureDetails,
  updateUnitMeasure,
} from '../../../network/unitMeasure';
import {
  addItemPrice,
  getItemPriceDetails,
  updateItemPrice,
} from '../../../network/itemPrice';
import {
  getSearchApi,
  getSearchApiAcount,
  getSearchApiSearchText,
} from '../../../network/itemList';
import {
  addLeavePolicy,
  getLeavePolicyDetails,
  updateLeavePolicy,
} from '../../../network/LeavePolicy';
import { getEmployee } from '../../../network/employee';
import {
  addLeavePolicyAssign,
  getLeavePolicyAssignDetails,
  updateLeavePolicyAssign,
} from '../../../network/leavePolicyAssign';
import {
  addHolidayList,
  getHolidayListDetails,
  updateHolidayList,
} from '../../../network/holidayList';
import {
  addExpenseClaim,
  getExpenseClaimDetails,
  updateExpenseClaim,
} from '../../../network/expenseClaim';
import {
  addDesignationHr,
  getDesignationHrDetails,
  updateDesignationHr,
} from '../../../network/designationHr';
import {
  addBranchHr,
  getBranchHrDetails,
  updateBranchHr,
} from '../../../network/branchHr';
import { FaCheckCircle } from 'react-icons/fa';
import { addBankTransfer } from '../../../network/bankTransfer';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  addStatementOfAccount,
  getStatementOfAccountById,
  updateStatementOfAccount,
} from '../../../network/statementOfAccount';
import {
  addItemGroup,
  getItemGroupById,
  updateItemGroup,
} from '../../../network/ItemGroup';
import { editUser, getUserDetails } from '../../../network/dashboard';
import { addToDo, getToDoDetails } from '../../../network/todoList';
import {
  addAddress,
  getAddressDetails,
  updateAddress,
} from '../../../network/Address';
import { getCustomer } from '../../../network/customer';
export const ModalAppDepartments = memo(
  ({ t, edit, record, open, setOpen }) => {
    // console.log(edit, 'edit');
    const client = useQueryClient();
    const [form] = Form.useForm();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const { message } = App.useApp();
    // const [open, setOpen] = useState(false);

    const { mutate: onAddDepartments } = useMutation({
      mutationKey: ['addDepartments'],
      mutationFn: (body) =>
        edit ? updateDepartments(body) : addDepartments(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        client.invalidateQueries({
          queryKey: [queryKeys.getDepartmentsList],
        });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
        // message.error(error);
      },
    });

    const { data: patientCareTypes } = useQuery({
      queryKey: [queryKeys.getPatientCareTypes],
      queryFn: () => getPatientCareTypes(),
      keepPreviousData: true,
    });
    const {
      data: departmentInfo,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: ['getDepartmentInfoData', record],
      queryFn: () => getDepartmentInfo(record),
      enabled: !!edit && !!record,
    });

    const onFinish = (values) => {
      // console.log('Finish:', values);
      setLoadingAdd(true);
      if (edit) {
        onAddDepartments({
          departmentData: JSON.stringify({
            ...values,
            name: record,
          }),
        });
      } else {
        onAddDepartments({
          departmentData: JSON.stringify({
            ...values,
          }),
        });
      }
    };
    useEffect(() => {
      if (record) {
        refetch();
      }
    }, [record, refetch]);
    useEffect(() => {
      if (edit) {
        form.setFieldsValue({
          ...departmentInfo?.message?.message,
        });
      } else {
        form.resetFields();
      }
    }, [departmentInfo, edit, form]);
    useEffect(() => {
      if (!open) {
        console.log(open, 'open');
        form.resetFields();
      }
    }, [form, open]);

    return (
      <div>
        <Modal
          title={t.ENTERDEPARTMENTINFORMATION}
          centered
          open={open}
          onOk={() => {
            setOpen(false);
            form.resetFields();
          }}
          onCancel={() => {
            setOpen(false);
            form.resetFields();
          }}
          footer={null}
          destroyOnClose
        >
          {isLoading ? (
            <div
              className="loading"
              style={{
                width: '100%',
                height: '20vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              style={{
                marginTop: '20px',
              }}
            >
              <Form.Item
                name="department"
                label={t.medicalDepartment}
                rules={[
                  { required: true, message: t.requiredMedicalDepartment },
                ]}
              >
                <Input placeholder={t.medicalDepartment} />
              </Form.Item>
              <Form.Item
                name="patient_care_type"
                label={t.patientCareType}
                rules={[{ required: true, message: t.requiredPatientCareType }]}
              >
                <Select
                  placeholder={t.patientCareType}
                  options={patientCareTypes?.message?.care_types?.map(
                    (item) => ({
                      value: item?.name,
                      label: item?.name,
                    })
                  )}
                />
              </Form.Item>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => setOpen(false)}>
                  {t.Cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Form>
          )}
        </Modal>
      </div>
    );
  }
);

export const ModalPractitionerSchedule = memo(
  ({ t, edit, record, open, setOpen }) => {
    // console.log(edit, 'edit');
    const client = useQueryClient();
    const [form] = Form.useForm();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const { message } = App.useApp();

    const weekDays = [
      { name: 'Sunday', value: 0 },
      { name: 'Monday', value: 1 },
      { name: 'Tuesday', value: 2 },
      { name: 'Wednesday', value: 3 },
      { name: 'Thursday', value: 4 },
      { name: 'Friday', value: 5 },
      { name: 'Saturday', value: 6 },
    ];

    // const [open, setOpen] = useState(false);

    const { mutate: onAddPractitionerSchedule } = useMutation({
      mutationKey: ['addPractitionerSchedule'],
      mutationFn: (body) =>
        edit
          ? updatePractitionerSchedule({ body, id: record })
          : addPractitionerSchedule(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(edit ? 'Updated successfully' : 'Added successfully');
        client.invalidateQueries({
          queryKey: [queryKeys.getDepartmentsList],
        });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
        // message.error(error);
      },
    });

    // const { data: patientCareTypes } = useQuery({
    //   queryKey: [queryKeys.getPatientCareTypes],
    //   queryFn: () => getPatientCareTypes(),
    //   keepPreviousData: true,
    // });
    const {
      data: practitionerScheduleInfo,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getPractitionerScheduleInfo, record],
      queryFn: () => getPractitionerScheduleInfo(record),
      enabled: !!edit && !!record,
    });

    const onFinish = (values) => {
      console.log('Finish:', values);
      const result = [];
      // Iterate through the time slots
      for (const day of values?.time_slots) {
        // Get the time slot data for the current day
        const timeSlotData = values?.[day];
        console.log(day, 'timeSlotData');
        // Convert the time slot data to dayjs objects
        const fromTime = dayjs(timeSlotData[0]);
        const toTime = dayjs(timeSlotData[1]);

        // Calculate the time difference in minutes
        const timeDiffMinutes = toTime.diff(fromTime, 'minute');
        const sessionTime = values?.custom_session_time;
        const intervalCount = Math.ceil(timeDiffMinutes / sessionTime);

        for (let i = 0; i < intervalCount; i++) {
          const intervalStart = fromTime.add(i * sessionTime, 'minutes');
          const intervalEnd = intervalStart.add(sessionTime, 'minutes');

          result?.push({
            day: day,
            from_time: intervalStart.format('HH:mm:ss'),
            to_time: intervalEnd.format('HH:mm:ss'),
          });
        }
      }
      console.log('result:', result);
      // setLoadingAdd(true);
      onAddPractitionerSchedule({
        schedule_name: values?.schedule_name,
        custom_session_time: values?.custom_session_time,
        time_slots: result,
      });
    };
    useEffect(() => {
      if (record) {
        refetch();
      }
    }, [record, refetch]);
    useEffect(() => {
      if (edit && practitionerScheduleInfo?.data) {
        const time_slots = practitionerScheduleInfo?.data?.time_slots?.reduce(
          (acc, slot) => {
            const day = slot?.day;
            const fromTime = dayjs(slot?.from_time, 'HH:mm:ss');
            const toTime = dayjs(slot?.to_time, 'HH:mm:ss');
            if (!acc[day]) {
              acc[day] = { earliest: fromTime, latest: toTime };
            } else {
              if (fromTime.isBefore(acc[day]?.earliest)) {
                acc[day].earliest = fromTime;
              }
              if (toTime.isAfter(acc[day]?.latest)) {
                acc[day].latest = toTime;
              }
            }

            return acc;
          },
          {}
        );

        const formattedTimeSlots = Object.keys(time_slots).reduce(
          (acc, day) => {
            acc[day] = [time_slots[day]?.earliest, time_slots[day]?.latest];
            return acc;
          },
          {}
        );
        console.log(
          formattedTimeSlots,
          'formattedTimeSlotsformattedTimeSlotsformattedTimeSlotsformattedTimeSlotsformattedTimeSlots'
        );

        form.setFieldsValue({
          schedule_name: practitionerScheduleInfo?.data?.schedule_name,
          custom_session_time:
            practitionerScheduleInfo?.data?.custom_session_time,
          // time_slots: practitionerScheduleInfo?.data?.time_slots?.map(
          //   (slot) => slot?.day
          // ),
          time_slots: Array.from(
            new Set(
              practitionerScheduleInfo?.data?.time_slots?.map(
                (slot) => slot?.day
              )
            )
          ),
          ...formattedTimeSlots,
          //  Friday:['10:00:00','11:00:00'],
        });
      } else {
        form.resetFields();
      }
    }, [practitionerScheduleInfo, edit, form]);

    useEffect(() => {
      if (!open) {
        console.log(open, 'open');
        form.resetFields();
      }
    }, [form, open]);

    const onChange = (checkedValues) => {
      console.log('checked = ', checkedValues);
    };
    const weekDaySelect = Form.useWatch('time_slots', form);
    return (
      <div>
        <Modal
          title={t.ENTERPractitionerScheduleFORMATION}
          centered
          open={open}
          onOk={() => {
            setOpen(false);
            form.resetFields();
          }}
          onCancel={() => {
            setOpen(false);
            form.resetFields();
          }}
          footer={null}
          destroyOnClose
          width={'70%'}
        >
          {isLoading ? (
            <div
              className="loading"
              style={{
                width: '100%',
                height: '50vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              style={{
                marginTop: '20px',
              }}
            >
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="schedule_name"
                    label={t.schedule_name}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.schedule_name} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="custom_session_time"
                    label={t.SessionTime}
                    rules={[{ required: edit ? false : true }]}
                  >
                    <Select placeholder={t.SessionTime}>
                      <Select.Option value="15">15</Select.Option>
                      <Select.Option value="30">30</Select.Option>
                      <Select.Option value="45">45</Select.Option>
                      <Select.Option value="60">60</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                name="time_slots"
                label={t.time_slots}
                // rules={[
                //   { required: true, message: t.requiredMedicalDepartment },
                // ]}
              >
                <Checkbox.Group style={{ width: '100%' }} onChange={onChange}>
                  <Row gutter={16}>
                    {weekDays?.map((day) => (
                      <Col xs={24} md={12}>
                        <Checkbox value={day?.name}>
                          <p
                            style={{
                              marginBottom: 10,
                              // color: '#ab268d',
                              fontSize: 16,
                              fontWeight: '500',
                            }}
                          >
                            {day?.name}
                          </p>
                          <Form.Item required={false} name={day?.name}>
                            <TimePicker.RangePicker
                              format={'h:mm A'}
                              // needConfirm={false}
                              minuteStep={15}
                              use12Hours
                              disabled={
                                !weekDaySelect?.some((s) => s === day?.name)
                              }
                            />
                          </Form.Item>
                        </Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              </Form.Item>

              <div className="form-btns">
                <Button type="primary" ghost onClick={() => setOpen(false)}>
                  {t.Cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Form>
          )}
        </Modal>
      </div>
    );
  }
);

export const ModalAppServices = memo(({ t, edit, record, open, setOpen }) => {
  const client = useQueryClient();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [form] = Form.useForm();
  const { message } = App.useApp();
  console.log('render modal');
  const { mutate: onAddServices } = useMutation({
    mutationKey: ['addServices'],
    mutationFn: (body) =>
      edit ? addServiceUnits(body) : addServiceUnits(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getServiceUnits],
      });
      form.resetFields();
      setOpen(false);
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      // message.error(error);
    },
  });
  // const [open, setOpen] = useState(false);
  const { data: serviceUnitTypes } = useQuery({
    queryKey: [queryKeys.getServiceUnitTypes],
    queryFn: () => getServiceUnitTypes(),
    keepPreviousData: true,
  });
  const { data: warehouses } = useQuery({
    queryKey: [queryKeys.getWarehouses],
    queryFn: () => getWarehouses(),
    keepPreviousData: true,
  });
  const { data: itemGroups } = useQuery({
    queryKey: [queryKeys.getItemGroups],
    queryFn: () => getItemGroups(),
    keepPreviousData: true,
  });
  // const { data: departmentInfo, isLoading } = useQuery({
  //   queryKey: ['serviceUnitInfo', record],
  //   queryFn: () => getDepartmentInfo(record),
  //   keepPreviousData: true,
  //   enabled: edit,
  // });
  const onFinish = (values) => {
    // console.log('Success:', values);
    setLoadingAdd(true);
    onAddServices({
      serviceUnitData: JSON.stringify({
        ...values,
      }),
    });
  };
  // useEffect(() => {
  //   if (edit) {
  //     form.setFieldsValue({
  //       // ...departmentInfo?.message?.message,
  //     });
  //   } else {
  //     form.resetFields();
  //   }
  // }, [edit, form]);

  return (
    <Modal
      title={t.ENTERSERVICEUNITINFORMATION}
      centered
      open={open}
      onOk={() => {
        setOpen(false);
      }}
      onCancel={() => {
        setOpen(false);
      }}
      footer={null}
    >
      <Form
        layout="vertical"
        form={form}
        name={`${edit ? 'edit' : 'add'}-department-form `}
        onFinish={onFinish}
        style={{
          marginTop: '20px',
        }}
      >
        <Form.Item
          name="healthcare_service_unit_name"
          label={t.serviceUnit}
          rules={[
            {
              required: true,
              message: t.requiredServiceUnit,
            },
          ]}
        >
          <Input placeholder={t.serviceUnit} />
        </Form.Item>
        <Form.Item
          name="service_unit_type"
          label={t.serviceUnitType}
          rules={[
            {
              required: true,
              message: t.requiredServiceUnit,
            },
          ]}
        >
          <Select
            placeholder={t.serviceUnitType}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? '').toLocaleLowerCase().includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={serviceUnitTypes?.message?.service_unit_types?.map(
              (item) => ({
                value: item?.name,
                label: item?.name,
              })
            )}
          />
        </Form.Item>
        <Form.Item
          name="warehouse"
          label={t.warehouse}
          // rules={[
          //   {
          //     required: true,
          //     message: t.requiredWarehouse,
          //   },
          // ]}
        >
          <Select
            placeholder={t.warehouse}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? '').toLocaleLowerCase().includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={warehouses?.message?.warehouses?.map((item) => ({
              value: item?.name,
              label: item?.name,
            }))}
          />
        </Form.Item>
        <Form.Item
          name="custom_item_groups"
          label={t.itemGroups}
          // rules={[
          //   {
          //     required: true,
          //     message: t.requiredItemGroup,
          //   },
          // ]}
        >
          <Select
            placeholder={t.itemGroups}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? '').toLocaleLowerCase().includes(input)
            }
            mode="multiple"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={itemGroups?.message?.item_groups?.map((item) => ({
              value: item?.name,
              label: item?.name,
            }))}
          />
        </Form.Item>
        <div className="form-btns">
          <Button type="primary" ghost onClick={() => setOpen(false)}>
            {t.Cancel}
          </Button>
          <Button type="primary" htmlType="submit" loading={loadingAdd}>
            {edit ? t.edit : t.submit}
          </Button>
        </div>
      </Form>
    </Modal>
  );
});

export const ModalAppMaterials = memo(({ t, edit, record, open, setOpen }) => {
  const client = useQueryClient();
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  console.log('render modal');
  const { mutate: onAddMaterials } = useMutation({
    mutationKey: ['addMaterials'],
    mutationFn: (body) =>
      edit ? updateMaterials(body, record) : addMaterials(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getMaterialsList] });
      form.resetFields();
      setOpen(false);
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      // message.error(error);
    },
  });
  // getMaterialsDetails
  const {
    data: materialsDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['getMaterialsDetails', record],
    queryFn: () => getMaterialsDetails(record),
    enabled: !!edit && !!record,
  });
  const onFinish = (values) => {
    console.log('Success:', values);
    setLoadingAdd(true);
    onAddMaterials({
      material: values.material,
    });
  };
  useEffect(() => {
    if (record) {
      refetch();
    }
  }, [record, refetch]);
  useEffect(() => {
    if (edit) {
      form.setFieldsValue({
        material: materialsDetails?.data?.material,
      });
    } else {
      form.resetFields();
    }
  }, [materialsDetails, edit, form]);
  return (
    <Modal
      title={t.ENTERMATERIALINFORMATION}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      centered
    >
      {isLoading ? (
        <div
          className="loading"
          style={{
            width: '100%',
            height: '20vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <Form
          form={form}
          name="basic"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          <Form.Item
            name="material"
            label={t.material}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input placeholder={t.material} />
          </Form.Item>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => setOpen(false)}>
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      )}
    </Modal>
  );
});

export const ModalAppEligibilityPlan = memo(
  ({ t, edit, record, open, setOpen }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    console.log('render modal');
    const { mutate: onAddMaterials } = useMutation({
      mutationKey: ['addEligibilityPlan'],
      mutationFn: (body) =>
        edit
          ? updateEligibilityPlan({ body, id: record })
          : addEligibilityPlan(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getEligibilityPlans] });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
        // message.error(error);
      },
    });
    const onFinish = (values) => {
      // console.log('Success:', values);
      setLoadingAdd(true);
      onAddMaterials({
        insurance_plan_name: values.insurance_plan_name,
        insurance_payor: values.insurance_payor,
        price_list: values.price_list,
        is_active: values.is_active ? 1 : 0,
      });
    };
    const { data: insurancePayors } = useQuery({
      queryKey: [queryKeys.getInsurancePayors],
      queryFn: () => getInsurancePayors(),
      keepPreviousData: true,
    });
    const { data: sellingPriceList } = useQuery({
      queryKey: [queryKeys.getSellingPriceLists],
      queryFn: () => getSellingPriceList(),
      keepPreviousData: true,
    });
    const { data: getEligibilityPlanDetails, isLoading } = useQuery({
      queryKey: [queryKeys.getEligibilityPlanById, record],
      queryFn: () => getEligibilityPlanById(record),
      enabled: !!edit && !!record,
    });
    useEffect(() => {
      if (edit && getEligibilityPlanDetails) {
        form.setFieldsValue({
          ...getEligibilityPlanDetails?.data,
          is_active:
            getEligibilityPlanDetails?.data?.is_active === 1 ? true : false,
        });
      } else {
        form.resetFields();
      }
    });
    return (
      <Modal
        title={`${t.InsurancePayorEligibilityPlanInformation} `}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
      >
        {isLoading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '40vh',
            }}
          >
            {' '}
            <Spin size="large" />{' '}
          </div>
        ) : (
          <Form
            form={form}
            name="add-eligibility-plan-form"
            layout="vertical"
            onFinish={onFinish}
            style={{
              marginTop: '20px',
            }}
          >
            <Form.Item
              name="insurance_plan_name"
              label={t.InsurancePlanName}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder={t.InsurancePlanName} />
            </Form.Item>
            <Form.Item
              name="insurance_payor"
              label={t.InsurancePayor}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                placeholder={t.InsurancePayor}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLocaleLowerCase().includes(input)
                }
                // mode="multiple"
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? '')
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? '').toLowerCase())
                }
                options={insurancePayors?.message?.insurance_payors?.map(
                  (item) => ({
                    value: item?.name,
                    label: item?.name,
                  })
                )}
              />
            </Form.Item>
            <Form.Item
              name="price_list"
              label={t.PriceList}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                placeholder={t.PriceList}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLocaleLowerCase().includes(input)
                }
                // mode="multiple"
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? '')
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? '').toLowerCase())
                }
                options={sellingPriceList?.message?.selling_price_list?.map(
                  (item) => ({
                    value: item?.name,
                    label: item?.name,
                  })
                )}
              />
            </Form.Item>
            <Form.Item
              name="is_active"
              label={t.status}
              valuePropName="checked"
              layout="horizontal"
              initialValue={true}
            >
              <Switch
                defaultChecked
                checkedChildren="active"
                unCheckedChildren="inactive"
              />
            </Form.Item>
            <div className="form-btns">
              <Button type="primary" ghost onClick={() => setOpen(false)}>
                {t.Cancel}
              </Button>
              <Button type="primary" htmlType="submit" loading={loadingAdd}>
                {edit ? t.edit : t.submit}
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    );
  }
);

export const ModalAppPayorContract = memo(
  ({ t, edit, record, open, setOpen }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    // console.log('render modal');
    const { mutate: onAddMaterials } = useMutation({
      mutationKey: ['addPayorContract'],
      mutationFn: (body) =>
        edit
          ? updatePayorContract({ body, id: record })
          : addPayorContract(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getPayorContracts] });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
        // message.error(error);
      },
    });
    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddMaterials({
        data: JSON.stringify({
          ...values,
          posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
          start_date: dayjs(values?.start_date).format('YYYY-MM-DD'),
          end_date: dayjs(values?.end_date).format('YYYY-MM-DD'),
          is_active: values.is_active ? 1 : 0,
        }),
      });
    };
    const { data: insurancePayors } = useQuery({
      queryKey: [queryKeys.getInsurancePayors],
      queryFn: () => getInsurancePayors(),
      keepPreviousData: true,
    });
    const { data: sellingPriceList } = useQuery({
      queryKey: [queryKeys.getSellingPriceLists],
      queryFn: () => getSellingPriceList(),
      keepPreviousData: true,
    });
    const { data: getPayorContractsDateils, isLoading: loadingPayorContract } =
      useQuery({
        queryKey: [queryKeys.getPayorContractsById, record],
        queryFn: () => getPayorContractsById(record),
        keepPreviousData: true,
        enabled: !!edit && !!record,
      });
    useEffect(() => {
      if (edit && getPayorContractsDateils) {
        form.setFieldsValue({
          ...getPayorContractsDateils?.data,
          posting_date: dayjs(getPayorContractsDateils?.data?.posting_date),
          start_date: dayjs(getPayorContractsDateils?.data?.start_date),
          end_date: dayjs(getPayorContractsDateils?.data?.end_date),
          is_active:
            getPayorContractsDateils?.data?.is_active === 1 ? true : false,
        });
      } else {
        form.resetFields();
      }
    }, [getPayorContractsDateils, edit, form]);
    return (
      <Modal
        title={`${t.InsurancePayorEligibilityPlanInformation} `}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
      >
        {loadingPayorContract ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '50vh',
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <Form
            form={form}
            name="add-payor-contract-form"
            layout="vertical"
            onFinish={onFinish}
            style={{
              marginTop: '20px',
            }}
          >
            <Form.Item
              name="insurance_payor"
              label={t.InsurancePayor}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                placeholder={t.InsurancePayor}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLocaleLowerCase().includes(input)
                }
                // mode="multiple"
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? '')
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? '').toLowerCase())
                }
                // onChange={
                //   (value, option) => {
                //     console.log(option, 'option');
                //   }
                // }
                options={insurancePayors?.message?.insurance_payors?.map(
                  (item) => ({
                    value: item?.name,
                    label: item?.name,
                    option: item,
                  })
                )}
              />
            </Form.Item>
            <Form.Item
              name="posting_date"
              label={t.postingDate}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                placeholder={t.postingDate}
                format="YYYY-MM-DD"
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item
              name="start_date"
              label={t.startDate}
              rules={[
                {
                  required: true,
                },
              ]}
              initialValue={dayjs()}
            >
              <DatePicker
                placeholder={t.startDate}
                format="YYYY-MM-DD"
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item
              name="end_date"
              label={t.dateEnd}
              rules={[
                {
                  required: true,
                },
              ]}
              initialValue={dayjs()}
            >
              <DatePicker
                placeholder={t.dateEnd}
                format="YYYY-MM-DD"
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item
              name="default_price_list"
              label={t.DefaultPriceList}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                placeholder={t.DefaultPriceList}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLocaleLowerCase().includes(input)
                }
                // mode="multiple"
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? '')
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? '').toLowerCase())
                }
                // onChange={
                //   (value, option) => {
                //     console.log('option:', option);
                //   }
                // }
                options={sellingPriceList?.message?.selling_price_list?.map(
                  (item) => ({
                    value: item?.name,
                    label: item?.name,
                    option: item,
                  })
                )}
              />
            </Form.Item>
            <Form.Item
              name="is_active"
              label={t.status}
              valuePropName="checked"
              layout="horizontal"
              initialValue={true}
            >
              <Switch
                defaultChecked
                checkedChildren="active"
                unCheckedChildren="inactive"
              />
            </Form.Item>
            <div className="form-btns">
              <Button type="primary" ghost onClick={() => setOpen(false)}>
                {t.Cancel}
              </Button>
              <Button type="primary" htmlType="submit" loading={loadingAdd}>
                {edit ? t.edit : t.submit}
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    );
  }
);

export const ModalAppGeneralLedger = memo(
  ({ t, edit, record, open, setOpen }) => {
    const [form] = Form.useForm();

    const onFinish = (values) => {
      console.log('Success:', values);
    };

    return (
      <Modal
        title={`${t.generalLedger} ${
          edit ? t.editGeneralLedger : t.addGeneralLedger
        }`}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
      >
        <Form
          form={form}
          name="addGeneralLedger"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '25px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                name="from_date"
                label={t.FromDate}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.FromDate} />
              </Form.Item>
            </Col>
            <Col sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                name="to_date"
                label={t.ToDate}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.ToDate} />
              </Form.Item>
            </Col>
            <Col sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                name="accounts"
                label={t.Accounts}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.Accounts} />
              </Form.Item>
            </Col>
            <Col sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                name="party_type"
                label={t.PartyType}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.PartyType} />
              </Form.Item>
            </Col>
            <Col sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                name="party"
                label={t.Party}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.Party} />
              </Form.Item>
            </Col>
            <Col sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                name="currency"
                label={t.currency}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.currency} />
              </Form.Item>
            </Col>
          </Row>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => setOpen(false)}>
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={false}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalAppFiscalYear = memo(
  ({ t, edit, record, open, setOpen, setEdit, setEditId }) => {
    const [form] = Form.useForm();
    const client = useQueryClient();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const watchYeer = Form.useWatch('year', form);
    // console.log('render modal');
    const { mutate: onAddFiscalYear } = useMutation({
      mutationKey: ['addFiscalYear'],
      mutationFn: (body) =>
        edit ? updateFiscalYear(body, record) : addFiscalYear(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        // console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getFiscalYear] });
        form.resetFields();
        setOpen(false);
        setEdit(false);
        setEditId(null);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
        // message.error(error);
      },
    });
    const { data: fiscalDetails, isLoading: loadingDetailsFiscal } = useQuery({
      queryKey: [queryKeys.getFiscalYearById, record],
      queryFn: () => getFiscalYearById(record),
      keepPreviousData: true,
      enabled: !!edit && !!record,
    });
    useEffect(() => {
      if (fiscalDetails?.data) {
        form.setFieldsValue({
          year: dayjs(fiscalDetails?.data?.year),
          year_start_date: dayjs(fiscalDetails?.data?.year_start_date),
          year_end_date: dayjs(fiscalDetails?.data?.year_end_date),
          disabled: fiscalDetails?.data?.disabled,
        });
      }
    }, [fiscalDetails, form]);
    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddFiscalYear({
        year: dayjs(values.year).format('YYYY'),
        year_start_date: dayjs(values.year_start_date).format('YYYY-MM-DD'),
        year_end_date: dayjs(values.year_end_date).format('YYYY-MM-DD'),
        disabled: values.disabled ? 1 : 0,
      });
    };

    return (
      <Modal
        title={t.ENTERFISCALYEARINFORMATION}
        open={open}
        onCancel={() => {
          setOpen(false);
          form.resetFields();
          setEdit(false);
          setEditId(null);
        }}
        footer={null}
      >
        {loadingDetailsFiscal ? (
          <div className="h-[400px] flex justify-center items-center">
            <Spin size="large" />
          </div>
        ) : (
          <Form
            form={form}
            name="addGeneralLedger"
            layout="vertical"
            onFinish={onFinish}
            style={{
              marginTop: '25px',
            }}
          >
            <Form.Item
              name="year"
              label={t.FiscalYear}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                placeholder={t.FiscalYear}
                format="YYYY"
                style={{ width: '100%' }}
                picker="year"
                onChange={(value, dateString) => {
                  form.setFieldsValue({
                    year_start_date: dayjs(`${dateString}`).startOf('year'),
                    year_end_date: dayjs(`${dateString}`).endOf('year'),
                    // year_start_date: dayjs(`${dateString}-01-01`),
                    // year_end_date: dayjs(`${dateString}-12-31`),
                  });
                }}
              />
            </Form.Item>
            <Form.Item
              name="year_start_date"
              label={t.YearStartDate}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                placeholder={t.YearStartDate}
                format="YYYY-MM-DD"
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item
              name="year_end_date"
              label={t.YearEndDate}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                placeholder={t.YearEndDate}
                format="YYYY-MM-DD"
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item
              name="disabled"
              // label={t.disabled}

              valuePropName="checked"
            >
              <Checkbox>{t.disabled}</Checkbox>
            </Form.Item>
            <div className="form-btns">
              <Button
                type="primary"
                ghost
                onClick={() => {
                  setOpen(false);
                  form.resetFields();
                  setEdit(false);
                  setEditId(null);
                }}
              >
                {t.Cancel}
              </Button>
              <Button type="primary" htmlType="submit" loading={loadingAdd}>
                {edit ? t.edit : t.submit}
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    );
  }
);

export const ModalAppDiagnosis = memo(({ t, open, setOpen, editId, edit }) => {
  const client = useQueryClient();
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  console.log('render modal');
  const { mutate: onAddDiagnosis } = useMutation({
    mutationKey: ['addDiagnosis'],
    mutationFn: (body) =>
      edit ? updateDiagnosis(body, editId) : addDiagnosis(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getDiagnosis] });
      form.resetFields();
      setOpen(false);
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      // message.error(error);
    },
  });
  const {
    data: diagnosisDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.getDiagnosis, editId],
    queryFn: () => getDiagnosisDetails(editId),
    enabled: !!edit && !!editId,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (edit) {
      refetch();
    }
  }, [edit, refetch]);

  useEffect(() => {
    const { diagnosis } = diagnosisDetails?.data || {};
    if (edit && diagnosisDetails) {
      form.setFieldsValue({
        diagnosis,
      });
    } else {
      form.resetFields();
    }
  }, [edit, diagnosisDetails, form]);
  const onFinish = (values) => {
    console.log('Success:', values);
    setLoadingAdd(true);
    if (edit) {
      onAddDiagnosis(
        JSON.stringify({
          diagnosis: values.diagnosis,
        })
      );
    } else {
      onAddDiagnosis(
        JSON.stringify({
          diagnosis: values.diagnosis,
        })
      );
    }
  };

  return (
    <Modal
      title={edit ? t.editDiagnosis : t.AddDiagnosis}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
    >
      <Form
        form={form}
        name="add-Diagnosis"
        layout="vertical"
        onFinish={onFinish}
        style={{
          marginTop: '20px',
        }}
      >
        {isLoading ? (
          <div
            style={{
              width: '100%',
              height: '20vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <Form.Item
            name="diagnosis"
            label={t.diagnosis}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input placeholder={t.diagnosis} />
          </Form.Item>
        )}
        <div className="form-btns">
          <Button type="primary" ghost onClick={() => setOpen(false)}>
            {t.Cancel}
          </Button>
          <Button type="primary" htmlType="submit" loading={loadingAdd}>
            {edit ? t.edit : t.submit}
          </Button>
        </div>
      </Form>
    </Modal>
  );
});

export const ModalAppRescheduleAppointment = memo(
  ({ t, open, setOpen, editId, edit }) => {
    // const [valueTime, setValueTime] = useState();
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [selectTimeSlots, setSelectTimeSlots] = useState([]);
    const [selectTimesNoAvailable, setSelectTimesNoAvailable] = useState([]);
    const [disabledDays, setDisabledDays] = useState([]);
    const darkMode = useSelector((state) => state.user.darkMode);
    const [loadingAdd, setLoadingAdd] = useState(false);
    const watchApointmentDate = Form.useWatch('appointment_date', form);
    const { mutate: onAddAppointments } = useMutation({
      mutationKey: ['addAppointments'],
      mutationFn: (body) => updateAppointments(editId, body),
      onSuccess: (data) => {
        console.log(data, 'datawwww');
        setLoadingAdd(false);
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        client.invalidateQueries({ queryKey: [queryKeys.getAppointments] });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
      },
    });
    console.log('render modal');
    const {
      mutate: onGetAvailableTimeSlots,
      isLoading,
      data: timeSlots,
    } = useMutation({
      mutationFn: (body) => getListTimeSlots(body),
      onSuccess: (data) => {
        console.log(data, 'data');
        const slotDetails = data?.message?.slot_details;

        if (
          !slotDetails ||
          slotDetails.length === 0 ||
          !slotDetails[0]?.avail_slot?.length
        ) {
          message.error('No time slot available');
          setSelectTimeSlots([]);
          setDisabledDays((prev) => [
            ...prev,
            dayjs(watchApointmentDate).format('YYYY-MM-DD'),
          ]);
        } else if (
          dayjs().format('YYYY-MM-DD') ===
          dayjs(watchApointmentDate).format('YYYY-MM-DD')
        ) {
          const filterTime = slotDetails[0]?.avail_slot?.filter(
            (item) => getTimeFormat(item?.from_time) >= dayjs().format('h:mm A')
          );
          setSelectTimeSlots(filterTime);
        } else {
          const listTime = slotDetails[0]?.avail_slot;
          setSelectTimeSlots(listTime);
        }
        const selectTimes = slotDetails[0]?.appointments?.map((item) => {
          const fromTime = dayjs(item?.appointment_time, 'HH:mm:ss');
          const duration = Number(item?.duration) - 1;
          const toTime = fromTime.add(duration, 'minute');
          return {
            from_time: fromTime.format('HH:mm:ss'),
            to_time: toTime.format('HH:mm:ss'),
          };
        });

        setSelectTimesNoAvailable(selectTimes);
      },

      onError: (error) => {
        message.error('No time slot available');
        console.log(error, 'error');
        setSelectTimeSlots([]);
        setDisabledDays((prev) => [
          ...prev,
          dayjs(watchApointmentDate).format('YYYY-MM-DD'),
        ]);
      },
    });
    const { data: getAppointmentsInfo, isLoading: isLoadingAppointments } =
      useQuery({
        queryKey: [queryKeys.practitioners, editId],
        queryFn: () => getAppointmentsDetails(editId),
        keepPreviousData: true,
        enabled: !!edit && !!editId,
      });
    // const { data: practitioners } = useQuery({
    //   queryKey: [queryKeys.practitioners],
    //   queryFn: () => getPractitioners({key:"",value:""}),
    //   keepPreviousData: true,
    // });
    // const {mutate:  onGetPractitionersDetails} = useMutation({
    //   mutationFn: (id) => getPractitionersDetails(id),
    //   onSuccess: (data) => {
    //     form.setFieldsValue({
    //       // department: data?.data?.department,
    //       // service_unit: data?.data?.practitioner_schedules[0]?.service_unit,
    //       schedule: data?.data?.practitioner_schedules[0]?.schedule,
    //     });
    //   },
    // })
    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddAppointments({
        ...getAppointmentsInfo?.data,
        appointment_date: values.appointment_date.format('YYYY-MM-DD'),
        appointment_time: values.appointment_time,
        name: editId,
      });
    };
    const handleChangeTime = async ({ value, option }) => {
      onGetAvailableTimeSlots({
        // appointment_date: dayjs(value).format('YYYY-MM-DD'),
        date: dayjs(value).format('YYYY-MM-DD'),
        practitioner: getAppointmentsInfo?.data?.practitioner,
        service_unit: getAppointmentsInfo?.data?.service_unit,
        // schedule: practitioners?.data?.filter(
        //   (item) =>
        //     item?.name === getAppointmentsInfo?.data?.practitioner
        // )[0]?.schedule,
        schedule: getAppointmentsInfo?.data?.custom_schedule,
        // schedule:form.getFieldValue('schedule'),
      });
    };
    useEffect(() => {
      // console.log(getAppointmentsInfo, 'getAppointmentsInfo .................. ');
      if (getAppointmentsInfo?.data) {
        // onGetPractitionersDetails(getAppointmentsInfo?.data?.practitioner)
        onGetAvailableTimeSlots({
          practitioner: getAppointmentsInfo?.data?.practitioner,
          date: dayjs(getAppointmentsInfo?.data?.appointment_date).format(
            'YYYY-MM-DD'
          ),
          // appointment_date: dayjs(
          //   getAppointmentsInfo?.data?.appointment_date
          // ).format('YYYY-MM-DD'),
          service_unit: getAppointmentsInfo?.data?.service_unit,
          schedule: getAppointmentsInfo?.data?.custom_schedule,
          // schedule: practitioners?.message?.message?.filter(
          //   (item) =>
          //     item?.name === getAppointmentsInfo?.data?.practitioner
          // )[0]?.schedule,
        });
        form.setFieldsValue({
          appointment_date: dayjs(getAppointmentsInfo?.data?.appointment_date),
        });
      }
    }, [getAppointmentsInfo, onGetAvailableTimeSlots]);
    return (
      <Modal
        title={t.RescheduleAppointment}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
      >
        {isLoadingAppointments ? (
          <div
            style={{
              width: '100%',
              height: '20vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <Form
            form={form}
            name="add-Reschedule-Appointment"
            layout="vertical"
            onFinish={onFinish}
            style={{
              marginTop: '20px',
            }}
          >
            <Form.Item
              name="appointment_date"
              label={t.appointmentDate}
              rules={[
                {
                  required: true,
                  message: t.requiredServiceUnit,
                },
              ]}
            >
              <DatePicker
                format="YYYY-MM-DD"
                placeholder={t.appointmentDate}
                style={{ width: '100%' }}
                onChange={(date, option) =>
                  handleChangeTime({ value: date, option })
                }
                // disabledDate={(current) =>
                //   current.endOf('d').valueOf() < dayjs().endOf('d').valueOf()
                // }
                disabledDate={(current) => {
                  const isPast =
                    current.endOf('d').valueOf() < dayjs().endOf('d').valueOf();
                  const isDisabledDay = disabledDays.includes(
                    current.format('YYYY-MM-DD')
                  );
                  return isPast || isDisabledDay;
                }}
              />
            </Form.Item>

            <Form.Item
              name="appointment_time"
              className="hours"
              label={t.appointmentTime}
              rules={[
                {
                  required: true,
                  message: t.requiredAppointmentTime,
                },
              ]}
            >
              <Radio.Group
                defaultValue={[1]}
                style={{ width: '100%' }}
                className={`radio-hours ${
                  darkMode ? 'dark-radio' : 'light-radio'
                }`}
                // onChange={(e) => setValueHours(e.target.value)}
              >
                {isLoading ? (
                  <Spin />
                ) : (
                  // selectTimeSlots?.map((item) => (
                  //   <Radio
                  //     value={item?.from_time}
                  //     style={{ position: 'relative' }}
                  //     key={item?.from_time}
                  //   >
                  //     {getTimeFormat(item?.from_time)}
                  //   </Radio>
                  // ))
                  selectTimeSlots?.map((item) => {
                    const isDisabled = selectTimesNoAvailable?.some((time) => {
                      const fromTime = dayjs(time.from_time, 'HH:mm:ss');
                      const toTime = dayjs(time.to_time, 'HH:mm:ss');
                      const currentTime = dayjs(item?.from_time, 'HH:mm:ss');
                      return currentTime.isBetween(
                        fromTime,
                        toTime,
                        null,
                        '[]'
                      );
                    });
                    return (
                      <Radio
                        value={item?.from_time}
                        style={{ position: 'relative' }}
                        key={item?.from_time}
                        disabled={isDisabled}
                        className={isDisabled ? 'disabled-radio-time' : ''}
                      >
                        {getTimeFormat(item?.from_time)}
                      </Radio>
                    );
                  })
                  // timeSlots?.message?.time_slots
                  //   ?.filter(
                  //     (item) =>
                  //       dayjs(form.getFieldValue('appointment_date') + ' ' + item?.time).format('YYYY-MM-DD HH:mm A') >= dayjs().format('YYYY-MM-DD HH:mm A')
                  //   )
                  //   ?.map((item) => (
                  //     <Radio
                  //       value={item.time}
                  //       style={{ position: 'relative' }}
                  //       key={item.time}
                  //     >
                  //       {getTimeFormat(item.time)}
                  //     </Radio>
                  //   ))
                )}
              </Radio.Group>
            </Form.Item>
            <div className="form-btns">
              <Button type="primary" ghost onClick={() => setOpen(false)}>
                {t.Cancel}
              </Button>
              <Button type="primary" htmlType="submit" loading={loadingAdd}>
                {t.edit}
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    );
  }
);

export const ModalLastEncounter = memo(({ t, open, setOpen, patientId }) => {
  const client = useQueryClient();
  const darkMode = useSelector((state) => state.user.darkMode);
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getLastEncounter, patientId],
    queryFn: () => getLastEncounters(patientId),
    keepPreviousData: true,
    enabled: !!patientId,
  });
  const dataTable = data?.message?.message?.map((item, index) => {
    // console.log('item:', item);
    return {
      key: index,
      ...item,
    };
  });

  const columns = [
    {
      title: t.encounterID,
      dataIndex: 'name',
    },
    {
      title: t.EncounterComment,
      dataIndex: 'encounter_comment',
    },
    {
      title: t.encounterDate,
      dataIndex: 'encounter_date',
    },
    {
      title: t.healthcarePractitioner,
      dataIndex: 'practitioner_name',
    },
  ];

  return (
    <Modal
      title={t.Last5Encounter}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      centered
      width={'70%'}
    >
      {isLoading ? (
        <div
          style={{
            width: '100%',
            height: '20vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
        />
      )}
    </Modal>
  );
});

export const ModalLastInvoices = memo(
  ({ t, open, setOpen, patientId, practitionerId }) => {
    const client = useQueryClient();
    const darkMode = useSelector((state) => state.user.darkMode);
    const { data, isLoading } = useQuery({
      queryKey: [queryKeys.getLastInvoice, patientId, practitionerId],
      queryFn: () => getLastInvoices(patientId, practitionerId),
      keepPreviousData: true,
      enabled: !!patientId,
    });
    const dataTable = data?.message?.message?.map((item, index) => {
      // console.log('item:', item);
      return {
        key: index,
        ...item,
      };
    });
    const currentLang = 'en';
    const columns = [
      {
        title: currentLang === 'en' ? 'Invoice Number' : 'رقم الفاتورة',
        dataIndex: 'name',
      },
      {
        title: currentLang === 'en' ? 'Date' : 'تاريخ',
        dataIndex: 'posting_date',
      },
      {
        title: t.status,
        dataIndex: 'status',
        render: (order) => {
          let color = '';
          let background = '';
          switch (order) {
            case 'Draft':
              background = '#e6f4ff';
              color = '#0958d9';
              break;
            case 'Paid':
            case 'Completed':
              background = '#40C1AC1A';
              color = '#167767';
              break;
            case 'Unpaid':
              background = '#f9f0ff';
              color = '#531dab';
              break;
            case 'Overdue':
            case 'Cancelled':
              background = '#EB59591A';
              color = '#EB5959';
              break;
            default:
              break;
          }

          return (
            <Tag
              style={{
                color: color,
                background: background,
                padding: '7px 12px 8px 12px',
                border: 'none',
              }}
            >
              {order || 'Draft'}
            </Tag>
          );
        },
      },
      {
        title: currentLang === 'en' ? 'Total' : 'المجموع',
        dataIndex: 'grand_total',
      },
    ];

    return (
      <Modal
        title={t.Last5Invoices}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
        width={'70%'}
      >
        {isLoading ? (
          <div
            style={{
              width: '100%',
              height: '20vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <DynamicTableAnt
            columns={columns}
            data={dataTable}
            loading={isLoading}
          />
        )}
      </Modal>
    );
  }
);

export const ModalAppAppointmentDuration = memo(
  ({ t, open, setOpen, edit, editId, setEditId }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    console.log('render modal');
    const { mutate: onAddappointmentDuration } = useMutation({
      mutationKey: ['addappointmentDuration'],
      mutationFn: (body) =>
        edit
          ? updateAppointmentTypes({
              oldName: appointmentTypes?.data?.appointment_type,
              ...body,
            })
          : addAppointmentTypes(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getAppointmentTypes] });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
        // message.error(error);
      },
    });
    const {
      data: appointmentTypes,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getAppointmentTypes, editId],
      queryFn: () => getAppointmentTypesDetails(editId),
      enabled: !!edit && !!editId,
      refetchOnWindowFocus: false,
    });

    useEffect(() => {
      if (editId) {
        refetch();
      }
    }, [editId, refetch]);

    useEffect(() => {
      if (appointmentTypes && edit) {
        const { default_duration, appointment_type } =
          appointmentTypes?.data || {};
        form.setFieldsValue({
          appointment_type: appointment_type,
          default_duration: default_duration,
        });
      } else {
        form.resetFields();
      }
    }, [appointmentTypes, edit, form]);

    // console.log('appointmentTypes:', appointmentTypes);

    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddappointmentDuration({
        appointment_type: values?.appointment_type,
        default_duration: values?.default_duration,
        allow_booking_for: 'Practitioner',
      });
    };
    const handalClose = () => {
      setOpen(false);
      setEditId(null);
    };
    return (
      <Modal
        title={t.AddAppointmentDuration}
        open={open}
        onCancel={handalClose}
        footer={null}
      >
        {isLoading ? (
          <div
            style={{
              width: '100%',
              height: '35vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <Form
            form={form}
            name="add-appointment-duration-form"
            layout="vertical"
            onFinish={onFinish}
            style={{
              marginTop: '20px',
            }}
            initialValues={{
              allow_booking_for: 'Practitioner',
              // appointment_type: appointment_type,
              // default_duration: default_duration
            }}
          >
            <Form.Item
              name="appointment_type"
              // label={t.appointmentType}
              label={t.Name}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder={t.Name} disabled={edit} />
            </Form.Item>
            <Form.Item
              name="default_duration"
              label={t.Duration}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder={t.Duration} type="number" min={1} />
            </Form.Item>
            {/* <Form.Item
            name="allow_booking_for"
            initialValue="Practitioner"
            label={t.allowbookingfor}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input value="Practitioner" placeholder={t.allowbookingfor} disabled />
          </Form.Item> */}
            <div className="form-btns">
              <Button type="primary" ghost onClick={handalClose}>
                {t.Cancel}
              </Button>
              <Button type="primary" htmlType="submit" loading={loadingAdd}>
                {edit ? t.edit : t.submit}
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    );
  }
);

export const ModalAppIllness = memo(({ t, edit, editId, open, setOpen }) => {
  const client = useQueryClient();
  const { currentLang } = useSelector((state) => state.user);
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  // console.log('render modal');
  const { mutate: onAddIllnesses } = useMutation({
    mutationKey: ['addIllnesses'],
    mutationFn: (body) =>
      edit ? updateIllnesses(body, editId) : addIllnesses(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message
          ? data?.message
          : edit
          ? 'Updated successfully'
          : 'Added successfully'
      );
      client.invalidateQueries({
        queryKey: [queryKeys.getIllnesses, currentLang],
      });
      form.resetFields();
      setOpen(false);
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
    },
  });
  const {
    data: IllnessesDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['getIllnessesDetails', editId],
    queryFn: () => getIllnessesDetails(editId),
    enabled: !!edit && !!editId,
  });
  const onFinish = (values) => {
    console.log('Success:', values);
    setLoadingAdd(true);
    onAddIllnesses({
      en: values.en,
      ar: values.ar,
    });
  };
  useEffect(() => {
    if (editId) {
      refetch();
    }
  }, [editId, refetch]);
  useEffect(() => {
    if (edit) {
      form.setFieldsValue({
        en: IllnessesDetails?.data?.en,
        ar: IllnessesDetails?.data?.ar,
      });
    } else {
      form.resetFields();
    }
  }, [IllnessesDetails, edit, form]);
  return (
    <Modal
      title={edit ? t.EditIllnessInformation : t.EnterIllnessInformation}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      centered
    >
      {isLoading ? (
        <div
          className="loading"
          style={{
            width: '100%',
            height: '20vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <Form
          form={form}
          name="basic"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          <Form.Item
            name="en"
            label={t.NameEnglish}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input placeholder={t.NameEnglish} />
          </Form.Item>
          <Form.Item
            name="ar"
            label={t.NameArabic}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input placeholder={t.NameArabic} />
          </Form.Item>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => setOpen(false)}>
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      )}
    </Modal>
  );
});

export const ModalAppBnpi = memo(({ t, open, setOpen, editId, edit }) => {
  const client = useQueryClient();
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [searchTxt, setSearchTxt] = useState('');
  const [loadingAdd, setLoadingAdd] = useState(false);
  console.log('render modal');
  const { mutate: onAddBnpi } = useMutation({
    mutationKey: ['addBnpi'],
    mutationFn: (body) => (edit ? updateBnpi(body, editId) : addBnpi(body)),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getIBnpi] });
      form.resetFields();
      setOpen(false);
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
    },
  });
  const {
    data: bnpiDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.getIBnpi, editId],
    queryFn: () => getIBnpiDetails(editId),
    enabled: !!edit && !!editId,
  });
  const { data: account } = useQuery({
    queryKey: [queryKeys.getSearchApiAccount, searchTxt],
    queryFn: () =>
      getSearchApiAcount({ type: 'Account', searchTxt: searchTxt }),
    enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
    keepPreviousData: true,
  });

  // const { data: receivableAccounts, isLoading: isLoadingReceivable } = useQuery(
  //   {
  //     queryKey: [queryKeys.getReceivableAccounts],
  //     queryFn: () => getReceivableAccounts(),
  //   }
  // );

  useEffect(() => {
    if (edit) {
      refetch();
    }
  }, [edit, refetch]);

  useEffect(() => {
    const { custom_account, name1, custom_percentage, custom_plus_riyal } =
      bnpiDetails?.data || {};
    if (edit && bnpiDetails) {
      form.setFieldsValue({
        name1,
        custom_account,
        custom_percentage,
        custom_plus_riyal,
      });
    } else {
      form.resetFields();
    }
  }, [edit, bnpiDetails, form]);
  const onFinish = (values) => {
    console.log('Success:', values);
    setLoadingAdd(true);
    onAddBnpi({
      name1: values.name1,
      custom_account: values.custom_account,
      custom_percentage: values.custom_percentage,
      custom_plus_riyal: values.custom_plus_riyal,
      // custom_plus_riyal: 0,
    });
  };

  return (
    <Modal
      title={edit ? t.EditBNPI : t.AddBNPI}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
    >
      <Form
        form={form}
        name="add-bnpi"
        layout="vertical"
        onFinish={onFinish}
        style={{
          marginTop: '20px',
        }}
      >
        {isLoading ? (
          <div
            style={{
              width: '100%',
              height: '20vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <>
            <Form.Item
              name="name1"
              label={t.Name}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder={t.Name} />
            </Form.Item>
            <Form.Item
              name="custom_account"
              label={t.Account}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                placeholder={t.Account}
                style={{ width: '100%' }}
                onSearch={(value) => {
                  setSearchTxt(value);
                }}
                showSearch
                filterOption={false}
                allowClear
                onClear={() => {
                  setSearchTxt('');
                }}
                onChange={() => {
                  setSearchTxt('');
                }}
                options={account?.message?.map((item) => ({
                  value: item?.value,
                  label: item?.value,
                }))}
              />
            </Form.Item>
            <Form.Item
              name="custom_percentage"
              label={t.percentage}
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <Input
                placeholder={t.percentage}
                type="number"
                min={0}
                max={100}
              />
            </Form.Item>
            <Form.Item
              name="custom_plus_riyal"
              label={t.plusRiyal}
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
              className="custom_plus_riyal"
              initialValue={0}
            >
              <Radio.Group defaultValue={0}>
                <Radio value={1}>{t.yes}</Radio>
                <Radio value={0}>{t.no}</Radio>
              </Radio.Group>
            </Form.Item>
          </>
        )}
        <div className="form-btns">
          <Button type="primary" ghost onClick={() => setOpen(false)}>
            {t.Cancel}
          </Button>
          <Button type="primary" htmlType="submit" loading={loadingAdd}>
            {edit ? t.edit : t.submit}
          </Button>
        </div>
      </Form>
    </Modal>
  );
});
export const ModalAppCostCenter = memo(
  ({ t, open, setOpen, editId, edit, setEditId, setEdit }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    // console.log('render modal');
    const { mutate: onAddCostCenter } = useMutation({
      mutationKey: ['addCostCenter'],
      mutationFn: (body) => (edit ? updateCostCenter(editId, body) : addCostCenter(body)),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getCostCenters] });
        form.resetFields();
        setOpen(false);
        setEditId(null);
        setEdit(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
      },
    });
    const { data: costCenter, isLoading } = useQuery({
      queryKey: [queryKeys.getCostCenterDetails, editId],
      queryFn: () => getCostCenterDetails(editId),
      enabled: !!edit && !!editId,
    });
    const { data: costCenterParties } = useQuery({
      queryKey: [queryKeys.getCostCenterParties],
      queryFn: () => getCostCenterParties(),
      keepPreviousData: true,
    });

    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddCostCenter({
        is_group: values?.is_group,
        cost_center_number: values?.cost_center_number,
        cost_center_name: values?.cost_center_name,
        parent_cost_center: values?.parent_cost_center,
      });
    };
    // useEffect(() => {
    //   if (edit) {
    //     refetch();
    //   }
    // }, [edit]);

    useEffect(() => {
      if (edit && costCenter) {
        form.setFieldsValue({
          cost_center_name: costCenter?.data?.cost_center_name,
          cost_center_number: costCenter?.data?.cost_center_number,
          parent_cost_center: costCenter?.data?.parent_cost_center,
          is_group: costCenter?.data?.is_group,
        });
      } else {
        form.resetFields();
      }
    }, [edit, costCenter, form]);

    return (
      <Modal
        title={edit ? t.EditCostCenter : t.addCostCenter}
        open={open}
        onCancel={() => {
          setOpen(false);
          setEditId(null);
          setEdit(false);
        }}
        footer={null}
      >
        <Form
          form={form}
          name="add-cost-center"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '50vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Form.Item
                name="cost_center_name"
                label={t.CostCenterName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.CostCenterName} />
              </Form.Item>
              <Form.Item
                name="cost_center_number"
                label={t.CostCenterNumber}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input type="number" min={0} placeholder={t.CostCenterNumber} />
              </Form.Item>

              <Form.Item
                name="parent_cost_center"
                label={t.parentcostcenter}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={t.parentcostcenter}
                  style={{ width: '100%' }}
                  options={costCenterParties?.data?.map((item) => ({
                    value: item?.name,
                    label: item?.cost_center_name,
                  }))}
                />
              </Form.Item>

              <Form.Item
                name="is_group"
                label={t.isgroup}
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={0}
                className="custom_plus_riyal"
              >
                <Radio.Group>
                  <Radio value={1}>{t.yes}</Radio>
                  <Radio value={0}>{t.no}</Radio>
                </Radio.Group>
              </Form.Item>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEditId(null);
                setEdit(false);
              }}
            >
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalAppPayment = memo(
  ({ t, type, open, setOpen, editId, total }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [searchTxt, setSearchTxt] = useState('');
    // const { data: salesInvoice, isLoading: loadingSales } = useQuery({
    //   queryKey: [queryKeys.getSalesInvoiceDetails, editId],
    //   queryFn: () => getSalesInvoiceDetails(editId),
    //   keepPreviousData: true,
    //   enabled: !!editId,
    // });
    const { data: modeOfPayments } = useQuery({
      queryKey: [queryKeys.getModeOfPayments, searchTxt],
      queryFn: () =>
        getSearchApiSearchText({
          type: 'Mode of Payment',
          searchTxt: searchTxt,
        }),
      keepPreviousData: true,
    });

    const { mutate: onCreatePaymentEntryQuick } = useMutation({
      mutationKey: ['paymentEntryQuick'],
      mutationFn: (body) => createPaymentEntryQuick(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        client.invalidateQueries({
          queryKey: [queryKeys.getSalesInvoices],
        });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
      },
    });
    const watchPayments = Form.useWatch('payments', form) || [];
    const onFinish = async (values) => {
      console.log('Success:', values);
      // onCreatePaymentEntryQuick(values);
      const payments = values.payments;
      // if (payments?.length) {
      //   setLoadingAdd(true);
      //   Promise.all(
      //     payments?.map((payment) =>
      //       new Promise((resolve, reject) => {
      //         onCreatePaymentEntryQuick(payment);
      //         // onCreatePaymentEntryQuick(payment, {
      //         //   onSuccess: () => resolve(),
      //         //   onError: (error) => reject(error),
      //         // });
      //       })
      //     )
      //   )
      //     // .then(() => {
      //     //   message.success("تمت العملية بنجاح");
      //     //   setLoadingAdd(false);
      //     //   setOpen(false);
      //     // })
      //     // .catch((error) => {
      //     //   console.error('Error in sending payments:', error);
      //     //   message.error('حدث خطأ أثناء إرسال البيانات.');
      //     //   setLoadingAdd(false);
      //     // })
      //     // .finally(() => {
      //     //   client.invalidateQueries({
      //     //     queryKey: [queryKeys.getSalesInvoices],
      //     //   });
      //     // });
      // }
      if (payments?.length) {
        setLoadingAdd(true);
        try {
          await Promise.all(
            payments?.map((payment) => onCreatePaymentEntryQuick(payment))
          );
        } catch (error) {
          console.error('Error in sending payments:', error);
          // message.error(t.PleaseEnterValidData);
        }
        // finally {
        //   setLoadingAdd(false);
        //   setOpen(false);
        // }
      } else {
        setLoadingAdd(false);
        message.error('');
      }
    };

    useEffect(() => {
      if (editId) {
        form.setFieldsValue({
          payments: [
            {
              // sales_invoice: salesInvoice?.message?.message?.name,
              sales_invoice: editId,
            },
          ],
        });
      } else {
        form.resetFields();
      }
    }, [editId, form]);

    const validateTotalAmount = (rule, value) => {
      const fieldsValue = form.getFieldsValue();
      // const totalAmount = salesInvoice?.message?.message?.grand_total || 0;
      const totalAmount = total || 0;
      const payments = fieldsValue.payments || [];

      const totalPaidAmount = payments.reduce(
        (sum, payment) => sum + (parseFloat(payment.amount) || 0),
        0
      );

      if (totalPaidAmount > totalAmount) {
        return Promise.reject(
          new Error(`Total amount should not exceed ${totalAmount}`)
        );
      }
      return Promise.resolve();
    };

    return (
      <Modal
        title={editId ? t.EditPaymentMethod : t.addPaymentMethod}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width="820px"
      >
        <Form
          form={form}
          name="add-cost-center"
          layout="vertical"
          style={{
            marginTop: '20px',
            width: '100%',
          }}
          initialValues={{
            payments: [{}],
          }}
          onFinish={onFinish}
        >
          {!editId ? (
            <div
              style={{
                width: '100%',
                height: '50vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Col span={24} className="payment-form">
              {/* <h4 className="title-card">Total: {salesInvoice?.message?.message?.grand_total}</h4> */}
              <h4 className="title-card">
                {' '}
                {t.Total} : {total}
              </h4>
              <Form.List name="payments" style={{ width: '100%' }}>
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field, index) => (
                      <Space
                        key={field.key}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <Form.Item
                          name={[field.name, 'sales_invoice']}
                          initialValue={editId}
                          // initialValue={salesInvoice?.message?.message?.name}
                          style={{ width: '100%', marginBottom: '0px' }}
                          rules={[{ required: true }]}
                          label={t.salesInvoice}
                        >
                          <Input
                            placeholder={t.salesInvoice}
                            style={{ width: '100%' }}
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'mode_of_payment']}
                          label={t.ModeofPayment}
                          style={{ width: '100%', marginBottom: '0px' }}
                          rules={[{ required: true }]}
                        >
                          <Select
                            placeholder={t.ModeofPayment}
                            style={{ width: '100%' }}
                            showSearch
                            optionFilterProp="children"
                            filterOption={false}
                            allowClear
                            onSearch={(value) => {
                              setSearchTxt(value);
                            }}
                            options={modeOfPayments?.message?.map(
                              (appointment) => ({
                                value: appointment?.value,
                                label: appointment?.value,
                              })
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[field.name, 'amount']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          label={t.amount}
                          rules={[
                            { required: true },
                            { validator: validateTotalAmount },
                            {
                              pattern: /^[-+]?[0-9]*\.?[0-9]+$/,
                              message: 'Please input a valid number',
                            },
                            // {
                            //   pattern: /^[0-9]+$/,
                            //   message: t.Pleaseinputaninteger,
                            // },
                          ]}
                        >
                          <Input
                            placeholder={t.amount}
                            style={{ width: '100%' }}
                            type="number"
                            // min={0}
                          />
                        </Form.Item>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '15px',
                            margin: '0 10px',
                          }}
                        >
                          {fields.length > 1 && (
                            <Button
                              type="text"
                              onClick={() => remove(field.name)}
                              danger
                              icon={<MdDelete color="red" />}
                            />
                          )}
                          <Button
                            type="text"
                            onClick={() => add()}
                            icon={<PlusOutlined color="#1890ff" />}
                          />
                        </div>
                      </Space>
                    ))}
                  </>
                )}
              </Form.List>
              {/* <Form.List name="payments" style={{ width: '100%' }}>
              {(fields, { add, remove }) => {
                return (
                  <>
                    {fields.map((field, index) => {
                      const currentPayment = watchPayments[index] || {};
                      console.log('currentPayment', currentPayment);
                      return (
                        <Space
                          key={field.key}
                          style={{ display: 'flex', width: '100%' }}
                        >
                          <Form.Item
                            name={[field.name, 'sales_invoice']}
                            initialValue={editId}
                            style={{ width: '100%', marginBottom: '0px' }}
                            rules={[{ required: true }]}
                            label={t.salesInvoice}
                          >
                            <Input placeholder={t.salesInvoice} disabled />
                          </Form.Item>
                          <Form.Item
                            name={[field.name, 'mode_of_payment']}
                            label={t.ModeofPayment}
                            style={{ width: '100%', marginBottom: '0px' }}
                            rules={[{ required: true }]}
                          >
                            <Select
                              placeholder={t.ModeofPayment}
                              options={modeOfPayments?.map((appointment) => ({
                                value: appointment?.name,
                                label: appointment?.mode_of_payment,
                              }))}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[field.name, 'amount']}
                            style={{ width: '100%', marginBottom: '0px' }}
                            label={t.amount}
                            rules={[
                              { required: true, message: t.requiredAmount },
                              { validator: validateTotalAmount },
                            ]}
                          >
                            <Input
                              type="number"
                              min={0}
                              placeholder={t.amount}
                            />
                          </Form.Item>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              fontSize: '15px',
                              gap: '10px',
                              margin: '0 10px',
                            }}
                          >
                            {fields.length > 1 && (
                              <Button
                                type="text"
                                onClick={() => remove(field.name)}
                                danger
                                icon={<MdDelete color="red" />}
                              />
                            )}
                            <Button
                              type="text"
                              onClick={() => add({ sales_invoice: editId })}
                              icon={<PlusOutlined color="#1890ff" />}
                            />
                            {currentPayment?.amount > 0 && (
                              <Button
                                type="text"
                                onClick={() =>
                                  onCreatePaymentEntryQuick(
                                    watchPayments[index]
                                  )
                                }
                                icon={<FaCheckCircle color="green" />}
                              />
                            )}
                          </div>
                        </Space>
                      );
                    })}
                  </>
                );
              }}
            </Form.List> */}
            </Col>
          )}
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => setOpen(false)}>
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);

export const ModalAppItemEligibility = memo(
  ({ t, edit, record, open, setOpen }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    // console.log('render modal');
    const { mutate: onAddItemInsurance } = useMutation({
      mutationKey: ['addItemInsuranceEligibility'],
      mutationFn: (body) =>
        edit
          ? updateItemInsuranceEligibility({ body, id: record })
          : addItemInsuranceEligibility(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({
          queryKey: [queryKeys.getItemInsuranceEligibility],
        });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
        // message.error(error);
      },
    });
    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddItemInsurance({
        eligibility_for: 'Item',
        item_code: values?.item_code,
        mode_of_approval: values?.mode_of_approval,
        coverage: values?.coverage,
        discount: values?.discount,
        valid_from: dayjs(values?.valid_from).format('YYYY-MM-DD'),
        insurance_plan: values?.insurance_plan,
        is_active: values.is_active ? 1 : 0,
        // template_dt: values?.template_dt,
        // template_dn: values?.template_dn,
      });
    };
    const { data: eligibilityPlans } = useQuery({
      queryKey: [queryKeys.getEligibilityPlans],
      queryFn: () => getEligibilityPlans(),
      keepPreviousData: true,
    });
    const { data: allItems } = useQuery({
      queryKey: [queryKeys.getAllItems],
      queryFn: () => getAllItems(),
      keepPreviousData: true,
    });
    const {
      data: getItemInsuranceEligibility,
      isLoading: loadingPayorContract,
    } = useQuery({
      queryKey: [queryKeys.getItemInsuranceEligibilityById, record],
      queryFn: () => getItemInsuranceEligibilityById(record),
      keepPreviousData: true,
      enabled: !!edit && !!record,
    });
    useEffect(() => {
      if (edit && getItemInsuranceEligibility) {
        form.setFieldsValue({
          ...getItemInsuranceEligibility?.data,
          valid_from: dayjs(getItemInsuranceEligibility?.data?.valid_from),
          is_active:
            getItemInsuranceEligibility?.data?.is_active === 1 ? true : false,
        });
      } else {
        form.resetFields();
      }
    }, [getItemInsuranceEligibility, edit, form]);
    return (
      <Modal
        title={`${t.ItemEligibilityInformation} `}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
        width={'600px'}
      >
        {loadingPayorContract ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '55vh',
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <Form
            form={form}
            name="add-Item-Insurance-elig-form"
            layout="vertical"
            onFinish={onFinish}
            style={{
              marginTop: '20px',
            }}
          >
            <Row gutter={[10, 0]}>
              <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item
                  name="insurance_plan"
                  label={t.InsurancePlan}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    placeholder={t.InsurancePlan}
                    options={eligibilityPlans?.data?.map((item) => ({
                      value: item?.name,
                      label: item?.insurance_plan_name,
                      option: item,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item
                  name="item_code"
                  label={t.itemCode}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    placeholder={t.itemCode}
                    options={allItems?.message?.items?.map((item) => ({
                      value: item?.name,
                      label: item?.item_code,
                      option: item,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item
                  name="mode_of_approval"
                  label={t.modeOfApproval}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    placeholder={t.modeOfApproval}
                    options={[
                      {
                        value: 'Manual',
                        label: t.Manual,
                      },
                      {
                        value: 'Automatic',
                        label: t.Automatic,
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item
                  name="coverage"
                  label={t.coverage}
                  rules={[
                    {
                      required: true,
                    },
                    {
                      max: 100,
                      message: 'Coverage cannot be greater than 100',
                    },
                    {
                      min: 0,
                      message: 'Coverage cannot be less than 0',
                    },
                  ]}
                >
                  <Input
                    prefix="%"
                    style={{ width: '100%' }}
                    max={100}
                    min={0}
                    type="number"
                    placeholder={t.coverage}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item
                  name="discount"
                  label={t.discount}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input
                    style={{ width: '100%' }}
                    min={0}
                    type="number"
                    placeholder={t.discount}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item
                  name="valid_from"
                  label={t.validFrom}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                  initialValue={dayjs()}
                >
                  <DatePicker
                    placeholder={t.validFrom}
                    format="YYYY-MM-DD"
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              {/* <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item
            name="template_dt"
            label={t.templateDt}
          >
            <Input placeholder={t.templateDt} />
          </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item
            name="template_dn"
            label={t.templateDn}
          >
            <Input placeholder={t.templateDn} />
          </Form.Item>
          </Col> */}
              <Col span={24}>
                <Form.Item
                  name="is_active"
                  label={t.isActive}
                  valuePropName="checked"
                  layout="horizontal"
                  initialValue={true}
                >
                  <Switch
                    defaultChecked
                    checkedChildren="active"
                    unCheckedChildren="inactive"
                  />
                </Form.Item>
              </Col>
            </Row>
            <div className="form-btns">
              <Button type="primary" ghost onClick={() => setOpen(false)}>
                {t.Cancel}
              </Button>
              <Button type="primary" htmlType="submit" loading={loadingAdd}>
                {edit ? t.edit : t.submit}
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    );
  }
);

export const ModalAppComplaint = memo(({ t, edit, record, open, setOpen }) => {
  const client = useQueryClient();
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  console.log('render modal');
  const { mutate: onAddComplaint } = useMutation({
    mutationKey: ['addComplaint'],
    mutationFn: (body) =>
      edit ? updateComplaint({ body, id: record }) : addComplaint(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getComplaint] });
      form.resetFields();
      setOpen(false);
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      // message.error(error);
    },
  });
  // getMaterialsDetails
  const {
    data: complaintDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.getComplaint, record],
    queryFn: () => getComplaintById(record),
    enabled: !!edit && !!record,
  });
  const onFinish = (values) => {
    console.log('Success:', values);
    setLoadingAdd(true);
    onAddComplaint({
      complaint: values.complaints,
    });
  };
  useEffect(() => {
    if (record) {
      refetch();
    }
  }, [record, refetch]);
  useEffect(() => {
    if (edit) {
      form.setFieldsValue({
        complaints: complaintDetails?.data?.complaints,
      });
    } else {
      form.resetFields();
    }
  }, [complaintDetails, edit, form]);
  return (
    <Modal
      title={t.ENTERCOMPLAINT}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      centered
    >
      {isLoading ? (
        <div
          className="loading"
          style={{
            width: '100%',
            height: '20vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <Form
          form={form}
          name="basic"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          <Form.Item
            name="complaints"
            label={t.complaints}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input placeholder={t.complaints} />
          </Form.Item>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => setOpen(false)}>
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      )}
    </Modal>
  );
});
export const ModalAppReconciliation = memo(
  ({
    setSelectedParty,
    reset,
    setSelectPayment,
    setSelectInvoice,
    t,
    dataParty,
    selectInvoice,
    selectPayment,
    open,
    setOpen,
    handleFetchReconciliation,
  }) => {
    const client = useQueryClient();
    const { companyName } = useSelector((state) => state.user);
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [selectedReferences, setSelectedReferences] = useState([]);
    // console.log('render modal');
    const { mutate: onAddReconcillation } = useMutation({
      mutationKey: ['addReconcillation'],
      mutationFn: (body) => addReconcillation(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message
            ? data?.message?.message
            : 'Reconciled added successfully'
        );
        // client.invalidateQueries({ queryKey: [queryKeys.getReconcillation] });
        form.resetFields();
        handleFetchReconciliation();
        // reset();
        setSelectPayment([]);
        setSelectInvoice([]);
        // setSelectedParty(null);
        setOpen(false);
        setSelectedReferences([]);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
        message.error(t.messageErorrReconcile);
      },
    });
    const onFinish = (values) => {
      // console.log('Success:', values);
      // testt
      // {
      //   reference_type: payment.reference_type || 'Payment Entry',
      //   reference_name: payment.reference_name,
      //   unallocated_amount: payment.amount,
      //   amount: payment.amount,
      // }
      setLoadingAdd(true);

      onAddReconcillation({
        method: 'reconcile',
        docs: {
          doctype: 'Payment Reconciliation',
          allocation: values.allocation,
          payments: selectPayment,
          invoices: selectInvoice,
          party_type: 'Customer',
          party: dataParty.party,
          receivable_payable_account: dataParty.receivable_payable_account,
          company: companyName,
        },
      });
    };
    const onCancel = () => {
      setOpen(false);
      setSelectedReferences([]);
      setSelectPayment([]);
      setSelectInvoice([]);
      // setSelectedParty(null);
      form.resetFields();
    };

    return (
      <Modal
        title={t.ENTERRECONCILIATION}
        open={open}
        onCancel={onCancel}
        footer={null}
        centered
        width={'70%'}
        destroyOnClose
      >
        <Form
          form={form}
          name="basic"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
          initialValues={{
            allocation: [{}],
          }}
        >
          <Row gutter={[10, 0]}>
            <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
              <Form.Item label={t.Party} initialValue={dataParty.party}>
                <Input placeholder={t.Party} disabled value={dataParty.party} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
              <Form.Item
                label={t.AccountsPayable}
                initialValue={dataParty.receivable_payable_account}
              >
                <Input
                  placeholder={t.AccountsPayable}
                  disabled
                  value={dataParty.receivable_payable_account}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.List name="allocation" style={{ width: '100%' }}>
            {(fields, { add, remove }) => (
              <>
                {fields?.map(({ key, name, ...restField }) => (
                  <>
                    <h5 style={{ margin: ' 0 5px 5px' }}>
                      Amount : {form.getFieldValue('allocation')[name]?.amount}
                    </h5>
                    <Flex
                      key={key}
                      items="center"
                      gap="10px"
                      justify="space-between"
                    >
                      <Form.Item
                        name={[name, 'reference_name']}
                        label={t.Payment}
                        style={{ width: '100%', marginBottom: '0px' }}
                        rules={[{ required: true }]}
                        {...restField}
                      >
                        <Select
                          placeholder={t.Payment}
                          style={{ width: '100%' }}
                          popupMatchSelectWidth={false}
                          onChange={(value, option) => {
                            console.log(option, 'option');
                            setSelectedReferences((prev) => [...prev, value]);
                            form.setFieldsValue({
                              allocation: {
                                ...form.getFieldValue('allocation'),
                                [name]: {
                                  ...form.getFieldValue('allocation')[name],
                                  amount: option?.option?.amount,
                                  unallocated_amount: option?.option?.amount,
                                  reference_type:
                                    option?.option?.reference_type,
                                },
                              },
                            });
                          }}
                          options={selectPayment?.map((item) => ({
                            value: item?.reference_name,
                            label: item?.reference_name,
                            option: item,
                            // disabled: selectedReferences.includes(item.reference_name),
                          }))}
                        />
                      </Form.Item>
                      <Form.Item
                        name={[name, 'invoice_number']}
                        style={{ width: '100%', marginBottom: '0px' }}
                        {...restField}
                        label={t.Invoices}
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder={t.Invoices}
                          style={{ width: '100%' }}
                          popupMatchSelectWidth={false}
                          onChange={(value, option) => {
                            console.log(option, 'option');
                            form.setFieldsValue({
                              allocation: {
                                ...form.getFieldValue('allocation'),
                                [name]: {
                                  ...form.getFieldValue('allocation')[name],
                                  outstanding_amount:
                                    option?.option?.outstanding_amount,
                                  allocated_amount:
                                    option?.option?.outstanding_amount <=
                                    form.getFieldValue('allocation')[name]
                                      ?.amount
                                      ? option?.option?.outstanding_amount
                                      : form.getFieldValue('allocation')[name]
                                          ?.amount,
                                  invoice_type: option?.option?.invoice_type,
                                },
                              },
                              // outstanding_amount: option?.option?.outstanding_amount
                            });
                          }}
                          options={selectInvoice?.map((item) => ({
                            value: item?.invoice_number,
                            label: item?.invoice_number,
                            option: item,
                          }))}
                        />
                      </Form.Item>

                      <Form.Item
                        name={[name, 'outstanding_amount']}
                        style={{ width: '100%', marginBottom: '0px' }}
                        {...restField}
                        label={t.Outstanding}
                      >
                        <Input
                          placeholder={t.Outstanding}
                          style={{ width: '100%' }}
                          type="number"
                          disabled
                        />
                      </Form.Item>
                      <Form.Item
                        name={[name, 'allocated_amount']}
                        style={{ width: '100%', marginBottom: '0px' }}
                        {...restField}
                        label={t.Allocated}
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                getFieldValue([
                                  'allocation',
                                  name,
                                  'outstanding_amount',
                                ]) < value
                              ) {
                                return Promise.reject(
                                  new Error(
                                    t.allocatedAmountGreaterThanOutstanding
                                  )
                                );
                              } else if (
                                getFieldValue(['allocation', name, 'amount']) <
                                value
                              ) {
                                return Promise.reject(
                                  new Error(t.messageErorrReconcile)
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input
                          placeholder={t.Allocated}
                          style={{ width: '100%' }}
                          type="number"
                          min={0}
                          max={
                            form.getFieldValue([
                              'allocation',
                              name,
                              'outstanding_amount',
                            ]) <= form.getFieldValue('allocation')[name]?.amount
                              ? form.getFieldValue([
                                  'allocation',
                                  name,
                                  'outstanding_amount',
                                ])
                              : form.getFieldValue('allocation')[name]?.amount
                          }
                        />
                      </Form.Item>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          fontSize: '15px',
                          margin: '0 10px',
                        }}
                      >
                        {fields.length > 1 && (
                          <Button
                            type="text"
                            onClick={() => remove(name)}
                            danger
                            icon={<MdDelete color="red" />}
                          />
                        )}
                        <Button
                          type="text"
                          onClick={() => add()}
                          icon={<PlusOutlined color="#1890ff" />}
                        />
                      </div>
                    </Flex>
                  </>
                ))}
              </>
            )}
          </Form.List>
          <div className="form-btns">
            <Button type="primary" ghost onClick={onCancel}>
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);

export const ModalGetLinkedDocs = memo(
  ({ t, open, setOpen, name, setName }) => {
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [selectDocs, setSelectDocs] = useState([]);
    console.log('selectDocs', selectDocs);

    const { message } = App.useApp();
    const { mutate: onUnlink } = useMutation({
      mutationKey: ['unlinkEntries'],
      mutationFn: (body) => unlinkEntries(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message
            ? data?.message?.message
            : 'UnLinked Successfully'
        );
        setOpen(false);
        setName(null);
        setSelectDocs([]);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
        // message.error(t.messageErorrReconcile);
      },
    });
    const { data, isLoading } = useQuery({
      queryKey: [queryKeys.getLinkedEntries, name],
      queryFn: () => getLinkedEntries(name),
      keepPreviousData: true,
      enabled: !!name,
    });
    const dataTable = data?.message?.map((item, index) => {
      return {
        key: item?.voucher_no,
        ...item,
      };
    });

    const columns = [
      {
        title: t.VoucherNo,
        dataIndex: 'voucher_no',
      },
      {
        title: t.allocatedAmount,
        dataIndex: 'allocated_amount',
      },
      {
        title: t.company,
        dataIndex: 'company',
      },
      {
        title: t.voucherType,
        dataIndex: 'voucher_type',
      },
    ];
    const onFinish = (values) => {
      setLoadingAdd(true);

      const selections = selectDocs?.map((item) => {
        return {
          voucher_no: item?.voucher_no,
          allocated_amount: item?.allocated_amount,
          company: item?.company,
          voucher_type: item?.voucher_type,
          against_voucher_type: 'Sales Invoice',
          against_voucher_no: name,
        };
      });

      onUnlink({
        selections: JSON.stringify(selections),
      });
    };

    const handalClose = () => {
      setOpen(false);
      setName(null);
      setSelectDocs([]);
    };
    return (
      <Modal
        title={t.LinkedPayments}
        open={open}
        onCancel={handalClose}
        footer={null}
        centered
        width={'70%'}
      >
        {isLoading ? (
          <div
            style={{
              width: '100%',
              height: '20vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <>
            <Table
              className="table_custom"
              columns={columns}
              dataSource={dataTable}
              scroll={{ x: 'max-content' }}
              // className="table"
              style={{ margin: '15px 0' }}
              pagination={{
                hideOnSinglePage: true,
              }}
              loading={isLoading}
              rowKey="key"
              rowSelection={{
                selectedRowKeys: selectDocs?.map((item) => item?.key),
                type: 'checkbox',
                onChange: (selectedRowKeys, selectedRows) => {
                  setSelectDocs(selectedRows);
                },
              }}
            />
            {/* <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          /> */}
            <div className="form-btns">
              <Button type="primary" ghost onClick={() => setOpen(false)}>
                {t.Cancel}
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loadingAdd}
                onClick={() => {
                  onFinish();
                }}
                disabled={!selectDocs?.length}
              >
                {t.Unlink}
              </Button>
            </div>
          </>
        )}
      </Modal>
    );
  }
);

export const ModalAppBank = memo(
  ({ t, open, setOpen, editId, edit, setEditId, setEdit }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    console.log('render modal');
    const { mutate: onAddBank } = useMutation({
      mutationKey: ['addBank'],
      mutationFn: (body) => (edit ? updateBank(body, editId) : addBank(body)),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getBank] });
        form.resetFields();
        setEdit(false);
        setEditId(null);
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
      },
    });
    const {
      data: bankDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getBank, editId],
      queryFn: () => getBankDetails(editId),
      enabled: !!edit && !!editId,
    });

    useEffect(() => {
      if (edit && bankDetails) {
        form.setFieldsValue({
          bank_name: bankDetails?.data?.bank_name,
          swift_number: bankDetails?.data?.swift_number,
        });
      } else {
        form.resetFields();
      }
    }, [edit, bankDetails, form]);
    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddBank({
        bank_name: values.bank_name,
        swift_number: values.swift_number,
      });
    };

    return (
      <Modal
        title={edit ? t.EditBank : t.AddBank}
        open={open}
        onCancel={() => {
          form.resetFields();
          setOpen(false);
          setEdit(false);
          setEditId(null);
        }}
        footer={null}
      >
        <Form
          form={form}
          name="basic-form"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '20vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Form.Item
                name="bank_name"
                label={t.Name}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.Name} />
              </Form.Item>
              <Form.Item
                name="swift_number"
                label={t.swiftNumber}
                rules={[
                  {
                    required: true,
                  },
                  {
                    regex: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
                  },
                ]}
              >
                <Input
                  placeholder={t.swiftNumber}
                  // type="number"
                  // min={0}
                  // max={100}
                />
              </Form.Item>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                form.resetFields();
                setOpen(false);
                setEdit(false);
                setEditId(null);
              }}
            >
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalAppBankAccount = memo(
  ({ t, open, setOpen, editId, edit, setEditId, setEdit }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [searchTxtBank, setSearchTxtBank] = useState('');
    const [searchTxt, setSearchTxt] = useState('');
    const [loadingAdd, setLoadingAdd] = useState(false);
    const validateIBAN = (iban) => {
      const regex = /^[A-Z0-9]{15,34}$/;
      return regex.test(iban);
    };
    // console.log('render modal');

    const { mutate: onAddAccount } = useMutation({
      mutationKey: ['addAccount'],
      mutationFn: (body) =>
        edit ? updateAccount(body, editId) : addAccount(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return;
        }
        message.success(data?.message?.message || 'Added successfully');
        client.invalidateQueries({ queryKey: [queryKeys.getBankAccount] });
        form.resetFields();
        setOpen(false);
        setEdit(false);
        setEditId(null);
      },
      onError: (error) => {
        setLoadingAdd(false);
        const errorMessage = error?.response?.data?._server_messages
          ? JSON.parse(error.response.data._server_messages)[0]?.message
          : 'Something went wrong';
        message.error(errorMessage || 'IBAN is not valid');
      },
    });

    const {
      data: accountDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getBankAccount, editId],
      queryFn: () => getBankAccountDetails(editId),
      enabled: !!edit && !!editId,
    });

    const { data: account } = useQuery({
      queryKey: [queryKeys.getSearchApiAccount, searchTxt],
      queryFn: () =>
        getSearchApiAcount({ type: 'Account', searchTxt: searchTxt }),
      enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
      keepPreviousData: true,
    });
    const { data: banks } = useQuery({
      queryKey: [queryKeys.getBank, searchTxt],
      queryFn: () =>
        getSearchApiSearchText({ type: 'Bank', searchTxt: searchTxtBank }),
      enabled: searchTxtBank?.length >= 3 || searchTxtBank?.length === 0,
      keepPreviousData: true,
    });
    // const { data: banks } = useQuery({
    //   queryKey: [queryKeys.getBank],
    //   queryFn: () => getBank(),
    //   keepPreviousData: true,
    // });

    // useEffect(() => {
    //   if (edit) {
    //     refetch();
    //   }
    // }, [edit, refetch]);

    useEffect(() => {
      if (edit && accountDetails) {
        form.setFieldsValue({
          account_name: accountDetails?.data?.account_name,
          account: accountDetails?.data?.account,
          bank: accountDetails?.data?.bank,
          iban: accountDetails?.data?.iban,
          branch_code: accountDetails?.data?.branch_code,
          bank_account_no: accountDetails?.data?.bank_account_no,
        });
      } else {
        form.resetFields();
      }
    }, [edit, accountDetails, form]);

    const onFinish = (values) => {
      if (!validateIBAN(values.iban)) {
        message.error('IBAN is not valid. Please check the format.');
        return;
      }
      setLoadingAdd(true);
      onAddAccount({
        account_name: values.account_name,
        account: values.account,
        bank: values.bank,
        is_company_account: 1,
        iban: values.iban,
        branch_code: values.branch_code,
        bank_account_no: values.bank_account_no,
      });
    };

    return (
      <Modal
        title={edit ? t.EditBankAccount : t.AddBankAccount}
        open={open}
        onCancel={() => {
          setOpen(false);
          setEdit(false);
          setEditId(null);
        }}
        footer={null}
        centered
        width="600px"
      >
        <Form
          form={form}
          name="add-bnpi"
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: '20px' }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '20vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Row gutter={[10, 0]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="account_name"
                    label={t.AccountName}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.AccountName} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="account"
                    label={t.Account}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Account}
                      style={{ width: '100%' }}
                      onSearch={(value) => {
                        setSearchTxt(value);
                      }}
                      showSearch
                      filterOption={false}
                      allowClear
                      onClear={() => {
                        setSearchTxt('');
                      }}
                      onChange={() => {
                        setSearchTxt('');
                      }}
                      options={account?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="bank"
                    label={t.Bank}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Bank}
                      style={{ width: '100%' }}
                      onSearch={(value) => {
                        setSearchTxtBank(value);
                      }}
                      showSearch
                      filterOption={false}
                      allowClear
                      onClear={() => {
                        setSearchTxtBank('');
                      }}
                      onChange={() => {
                        setSearchTxtBank('');
                      }}
                      // options={banks?.data?.map((item) => ({
                      //   value: item?.name,
                      //   label: item?.name,
                      // }))}
                      options={banks?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="iban"
                    label={t.IBAN}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.IBAN} type="text" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="branch_code"
                    label={t.BranchCode}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.BranchCode} type="text" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="bank_account_no"
                    label={t.BankAccountNo}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.BankAccountNo} type="text" />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
                setEditId(null);
              }}
            >
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);

export const ModalAppCostCenterAllocation = memo(
  ({ t, open, setOpen, editId, edit, setEditId, setEdit }) => {
    const client = useQueryClient();
    const { companyName } = useSelector((state) => state.user);
    const [selectCost, setSelectCost] = useState([]);
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    console.log('render modal');
    const { mutate: onAddCostCenterAllocation } = useMutation({
      mutationKey: ['addCostCenterAllocation'],
      mutationFn: (body) =>
        edit
          ? updateCostCenterAllocation(body, editId)
          : addCostCenterAllocation(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({
          queryKey: [queryKeys.getCostCenterAllocation],
        });
        form.resetFields();
        setOpen(false);
        setEdit(false);
        setEditId(null);
        setSelectCost([]);
      },
      onError: (error) => {
        setLoadingAdd(false);
        message.error(error?.response?.data?.exception || 'حدث خطأ ما');
      },
    });
    const {
      data: CostCenterAllocation,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getCostCenterAllocation, editId],
      queryFn: () => getCostCenterAllocationDetails(editId),
      enabled: !!edit && !!editId,
    });
    // useEffect(() => {
    //   if (edit) {
    //     refetch();
    //   }
    // }, [edit, refetch]);

    useEffect(() => {
      if (edit && CostCenterAllocation) {
        form.setFieldsValue({
          ...CostCenterAllocation?.data,
          valid_from: dayjs(CostCenterAllocation?.data?.valid_from),
        });
      } else {
        form.resetFields();
      }
    }, [edit, CostCenterAllocation, form]);
    const onFinish = (values) => {
      console.log('Success:', values);
      const totalPercentage = values.allocation_percentages.reduce(
        (total, item) => total + Number(item.percentage),
        0
      );

      if (totalPercentage !== 100) {
        message.error('The total percentage must equal 100%!');
        return;
      }

      setLoadingAdd(true);
      onAddCostCenterAllocation({
        main_cost_center: values.main_cost_center,
        company: companyName,
        valid_from: dayjs(values.valid_from).format('YYYY-MM-DD'),
        allocation_percentages: values.allocation_percentages?.map((item) => {
          return {
            cost_center: item?.cost_center,
            percentage: Number(item?.percentage),
          };
        }),
      });
    };
    const { data: costCenters } = useQuery({
      queryKey: [queryKeys.getCostCenters],
      queryFn: () => getCostCenters(),
      keepPreviousData: true,
    });
    const handalClose = () => {
      form.resetFields();
      setSelectCost([]);
      setOpen(false);
      setEdit(false);
      setEditId(null);
    };
    return (
      <Modal
        title={edit ? t.EditCostCenterAllocation : t.addCostCenterAllocation}
        open={open}
        onCancel={handalClose}
        footer={null}
      >
        <Form
          form={form}
          name="basic-form"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
          initialValues={{
            allocation_percentages: [{}],
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '20vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Form.Item
                name="main_cost_center"
                label={t.mainCostCenter}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={t.mainCostCenter}
                  onChange={(value) => {
                    // console.log(option, 'option');
                    setSelectCost((prev) => [...prev, value]);
                  }}
                  options={costCenters?.data?.map((item) => ({
                    value: item?.name,
                    label: item?.cost_center_name,
                    option: item,
                    disabled: selectCost?.includes(item?.name),
                  }))}
                />
              </Form.Item>
              <Form.Item
                name="valid_from"
                label={t.validFrom}
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={dayjs()}
              >
                <DatePicker
                  format="YYYY-MM-DD"
                  placeholder={t.validFrom}
                  style={{ width: '100%' }}
                  // disabledDate={disabledDate}
                />
              </Form.Item>
              <Form.List
                name="allocation_percentages"
                style={{ width: '100%' }}
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field, index) => (
                      <Flex
                        key={field.key}
                        align="center"
                        justify="space-between"
                        gap="5px"
                        style={{
                          width: '100%',
                        }}
                      >
                        <Form.Item
                          name={[field.name, 'cost_center']}
                          label={t.mainCostCenter}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                          style={{ width: '100%', marginBottom: '0px' }}
                        >
                          <Select
                            placeholder={t.mainCostCenter}
                            onChange={(value) => {
                              setSelectCost((prev) => [...prev, value]);
                            }}
                            options={costCenters?.data?.map((item) => ({
                              value: item?.name,
                              label: item?.cost_center_name,
                              option: item,
                              disabled: selectCost?.includes(item?.name),
                            }))}
                          />
                        </Form.Item>

                        <Form.Item
                          name={[field.name, 'percentage']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          rules={[
                            { required: true },
                            {
                              validator: (_, value) => {
                                if (value > 100) {
                                  return Promise.reject(t.percentageError);
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                          label={t.percentage}
                        >
                          <Input
                            placeholder={t.percentage}
                            style={{ width: '100%' }}
                            type="number"
                            min={0}
                            max={100}
                          />
                        </Form.Item>

                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '15px',
                            margin: '0 10px',
                          }}
                        >
                          {fields.length > 1 && (
                            <Button
                              type="text"
                              onClick={() => remove(field.name)}
                              danger
                              icon={<MdDelete color="red" />}
                            />
                          )}
                          <Button
                            type="text"
                            onClick={() => add()}
                            icon={<PlusOutlined color="#1890ff" />}
                          />
                        </div>
                      </Flex>
                    ))}
                  </>
                )}
              </Form.List>
            </>
          )}
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => handalClose()}>
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);

export const ModalSupplierGroup = memo(
  ({ t, open, setOpen, editId, edit, setEdit, setEditId }) => {
    const { companyName } = useSelector((state) => state.user);
    const client = useQueryClient();
    const [form] = Form.useForm();
    const [setTextAccount, setSetTextAccount] = useState('');
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    console.log('render modal');
    const { mutate: onAddSupplierGroup } = useMutation({
      mutationKey: ['addSupplierGroup'],
      mutationFn: (body) =>
        edit ? updateSupplierGroup(body, editId) : addSupplierGroup(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getSupplierGroup] });
        form.resetFields();
        setOpen(false);
        setEditId(null);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
      },
    });
    const {
      data: supplierGroupDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getSupplierGroup, editId],
      queryFn: () => getSupplierGroupDetails(editId),
      enabled: !!edit && !!editId,
    });
    const { data: supplierGroup } = useQuery({
      queryKey: [queryKeys.getSupplierGroup],
      queryFn: () =>
        getSupplierGroup({
          key: '',
          value: '',
        }),
      keepPreviousData: true,
      select: (data) => data?.data?.filter((item) => item?.is_group === 1),
    });
    // console.log(supplierGroup,"supplierGroupsupplierGroup");
    const accountFilter = '{"account_type":"Payable"}';
    // const { data: accounts } = useQuery({
    //   queryKey: [queryKeys.getAccounts],
    //   queryFn: () => getAccounts(accountFilter),
    //   keepPreviousData: true,
    // });
    const { data: accounts } = useQuery({
      queryKey: [queryKeys.getAccountSearch, setTextAccount],
      queryFn: () =>
        getSearchApiSearchText({
          type: 'Account',
          searchTxt: setTextAccount,
        }),
      keepPreviousData: true,
    });
    const PayableAccounts = accounts?.message;
    // useEffect(() => {
    //   if (edit) {
    //     refetch();
    //   }
    // }, [edit, refetch]);

    useEffect(() => {
      const { supplier_group_name, accounts, parent_supplier_group } =
        supplierGroupDetails?.data || {};
      if (edit && supplierGroupDetails) {
        form.setFieldsValue({
          supplier_group_name,
          parent_supplier_group,
          accounts: accounts?.length ? accounts : [{}],
        });
      } else {
        form.resetFields();
      }
    }, [edit, supplierGroupDetails, form]);
    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddSupplierGroup({
        supplier_group_name: values.supplier_group_name,
        parent_supplier_group: values.parent_supplier_group,
        is_group: 0,
        accounts: values.accounts?.map((account) => ({
          account: account.account,
          company: companyName,
        })),
      });
    };

    return (
      <Modal
        title={edit ? t.editSupplierGroup : t.AddSupplierGroup}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
          setEditId(null);
        }}
        footer={null}
        // width={600}
      >
        <Form
          form={form}
          name="add-supplier-group"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            accounts: [{}],
          }}
          style={{
            marginTop: '20px',
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '20vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Form.Item
                name="supplier_group_name"
                label={t.Name}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.Name} />
              </Form.Item>
              <Form.Item
                name="parent_supplier_group"
                label={t.ParentGroup}
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Select
                  placeholder={t.ParentGroup}
                  options={supplierGroup?.map((item) => ({
                    value: item?.name,
                    label: item?.name,
                  }))}
                />
              </Form.Item>
              <Form.List name="accounts" style={{ width: '100%' }}>
                {(fields, { add, remove }) => (
                  <>
                    {fields?.map(({ key, name, ...restField }) => (
                      <Flex
                        gap={5}
                        key={key}
                        style={{
                          width: '100%',
                        }}
                      >
                        <Form.Item
                          name={[name, 'account']}
                          label={t.Accounts}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          // rules={[{ required: true }]}
                        >
                          <Select
                            placeholder={t.Accounts}
                            style={{ width: '100%' }}
                            popupMatchSelectWidth={false}
                            allowClear
                            showSearch
                            onSearch={(value) => {
                              setSetTextAccount(value);
                            }}
                            filterOption={false}
                            onChange={(value, option) => {
                              console.log(option, 'option');
                            }}
                            options={PayableAccounts?.map((item) => ({
                              value: item?.value,
                              label: item?.value,
                              data: { ...item, key },
                            }))}
                          />
                        </Form.Item>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '15px',
                            margin: '0 10px',
                          }}
                        >
                          {fields.length > 1 && (
                            <Button
                              type="text"
                              onClick={() => remove(name)}
                              danger
                              icon={<MdDelete color="red" />}
                            />
                          )}
                          <Button
                            type="text"
                            onClick={() => add()}
                            icon={<PlusOutlined color="#1890ff" />}
                          />
                        </div>
                      </Flex>
                    ))}
                  </>
                )}
              </Form.List>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
                setEditId(null);
              }}
            >
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalSupplier = memo(
  ({ t, open, setOpen, editId, edit, setEdit }) => {
    const { companyName, currentLang } = useSelector((state) => state.user);
    const [searchTxtBankAccount, setSearchTxtBankAccount] = useState('');
    const [setTextAccount, setSetTextAccount] = useState('');
    const [searchTxtPricelist, setSearchTxtPricelist] = useState('');
    const client = useQueryClient();
    const [form] = Form.useForm();
    const [searchTxtAddress, setSearchTxtAddress] = useState('');
    const watchHoldType = Form.useWatch('hold_type', form);
    const watchSupplierType = Form.useWatch('supplier_type', form);
    const watchSOnHold = Form.useWatch('on_hold', form);
    // console.log(watchHoldType, 'watchHoldType');

    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    console.log('render modal');
    const { mutate: onAddSupplier } = useMutation({
      mutationKey: ['addSupplierGroup'],
      mutationFn: (body) =>
        edit ? updateSupplier(body, editId) : addSupplier(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getSuppliers] });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
      },
    });
    const {
      data: supplierDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getSuppliers, editId],
      queryFn: () => getSupplierDetails(editId),
      enabled: !!edit && !!editId,
    });
    const { data: bankAccount } = useQuery({
      queryKey: [queryKeys.getSearchBankAccount, searchTxtBankAccount],
      queryFn: () => getSearchPatients('Bank Account', searchTxtBankAccount),
      enabled:
        searchTxtBankAccount?.length >= 2 || searchTxtBankAccount?.length === 0,
      keepPreviousData: true,
    });
    const { data: addressList, isLoading: isLoadingAddress } = useQuery({
      queryKey: [queryKeys.getSearchAddress, searchTxtAddress],
      queryFn: () => getSearchPatients('Address', searchTxtAddress),
      enabled: searchTxtAddress?.length >= 2 || searchTxtAddress?.length === 0,
      keepPreviousData: true,
    });
    const { data: supplier } = useQuery({
      queryKey: [queryKeys.getSupplierGroup],
      queryFn: () =>
        getSupplierGroup({
          key: '',
          value: '',
        }),
      keepPreviousData: true,
      select: (data) => data?.data?.filter((item) => item?.is_group === 0),
    });
    const { data: pricelist, isLoading: isLoadingPricelist } = useQuery({
      queryKey: [queryKeys.getSearchPricelist, searchTxtPricelist],
      queryFn: () => getSearchPatients('Price List', searchTxtPricelist),
      enabled:
        searchTxtPricelist?.length >= 2 || searchTxtPricelist?.length === 0,
      keepPreviousData: true,
    });
    const { data: accounts } = useQuery({
      queryKey: [queryKeys.getAccountSearch, setTextAccount],
      queryFn: () =>
        getSearchApiAcount({ type: 'Account', searchTxt: setTextAccount }),
      keepPreviousData: true,
    });
    const PayableAccounts = accounts?.message;
    useEffect(() => {
      if (edit) {
        refetch();
      }
    }, [edit, refetch]);

    useEffect(() => {
      if (edit && supplierDetails) {
        form.setFieldsValue({
          ...supplierDetails?.data,
          release_date: dayjs(supplierDetails?.data?.release_date),
          on_hold: supplierDetails?.data?.on_hold ? true : false,
          accounts: supplierDetails?.data?.accounts?.length
            ? supplierDetails?.data?.accounts
            : [{}],
        });
      } else {
        form.resetFields();
      }
    }, [edit, supplierDetails, form]);
    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddSupplier({
        ...values,
        release_date: dayjs(values.release_date).format('YYYY-MM-DD'),
        is_frozen: 0,
        disabled: 0,
        // on_hold: 0,
        // hold_type: values?.hold_type === '' ? null : values?.hold_type,
        companies: [],
        accounts: values?.accounts[0]?.account
          ? values?.accounts?.map((account) => ({
              account: account?.account,
              company: companyName,
            }))
          : [],
      });
    };

    return (
      <Modal
        title={edit ? t.editSupplier : t.addSupplier}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
        }}
        footer={null}
        width={800}
      >
        <Form
          form={form}
          name="add-supplier"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            accounts: [{}],
            country: 'Saudi Arabia',
            supplier_type: 'Company',
          }}
          style={{
            marginTop: '20px',
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '20vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Row gutter={[16, 0]}>
              <Col xs={24} md={12} lg={8} xl={8}>
                <Form.Item
                  name="supplier_name"
                  label={t.NameInEnglish}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input placeholder={t.NameInEnglish} />
                </Form.Item>
              </Col>
              {/* <Col xs={24} md={12} lg={8} xl={8}>
                <Form.Item
                  name="supplier_name_in_arabic"
                  label={t.NameInArabic}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input placeholder={t.NameInArabic} />
                </Form.Item>
              </Col> */}

              <Col xs={24} sm={12} md={8} lg={8}>
                <Form.Item
                  name="custom_email"
                  label={t.email}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: t.requiredEmail,
                  //   },
                  // ]}
                >
                  <Input type="email" placeholder={t.email} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <Form.Item
                  name="custom_mobile"
                  label={t.mobile}
                  className="w-full"

                  // hasFeedback
                >
                  <PhoneInputWithCountrySelect
                    defaultCountry="SA"
                    className="w-full"
                    name="phone"
                    label={t.mobile}
                    international
                    // hasFeedback
                    limitMaxLength={true}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={8} xl={8}>
                <Form.Item
                  name="supplier_group"
                  label={t.SupplierGroup}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    placeholder={t.SupplierGroup}
                    options={supplier?.map((item) => ({
                      value: item?.name,
                      label: item?.name,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={8} xl={8}>
                <Form.Item
                  name="supplier_type"
                  // name="country"
                  label={t.supplierType}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Select
                    placeholder={t.supplierType}
                    options={[
                      {
                        value: 'Company',
                        label: t.company,
                      },
                      {
                        value: 'Individual',
                        label: t.Individual,
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={8} xl={8}>
                <Form.Item
                  name="custom_crid"
                  label={
                    watchSupplierType === 'Company' ? t.CRNumber : t.IdNumber
                  }
                >
                  <Input placeholder={t.CRNumber} type="number" min={0} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={8} xl={8}>
                <Form.Item
                  name="tax_id"
                  label={t.taxId}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input placeholder={t.taxId} type="number" min={0} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={8} xl={8}>
                <Form.Item
                  name="default_bank_account"
                  label={t.bankAccount}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Select
                    placeholder={t.bankAccount}
                    // loading={isLoadingBankAccount}
                    onSearch={(value) => {
                      setSearchTxtBankAccount(value);
                    }}
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    filterOption={false}
                    options={bankAccount?.result?.map((item) => ({
                      value: item?.value,
                      label: item?.value,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={8} xl={8}>
                <Form.Item name="default_price_list" label={t.priceList}>
                  {/* <Select
                    showSearch
                    placeholder={t.priceList}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(value, option) => {
                      form.setFieldsValue({
                        default_currency: option?.option?.currency,
                      });
                    }}
                    options={priceLists?.message?.price_lists?.map((item) => ({
                      value: item.name,
                      label: item.name,
                      option: item,
                    }))}
                  /> */}
                  <Select
                    placeholder={t.priceList}
                    showSearch
                    popupMatchSelectWidth={false}
                    onSearch={(value) => {
                      setSearchTxtPricelist(value);
                    }}
                    filterOption={false}
                    loading={isLoadingPricelist}
                  >
                    {pricelist?.message?.map((item) => (
                      <Select.Option key={item?.value} value={item?.value}>
                        <Flex gap={1} vertical>
                          <span>{item?.value}</span>
                          <span
                            className="item-description"
                            style={{ fontSize: '11px', color: 'gray' }}
                          >
                            {item?.description}
                          </span>
                        </Flex>
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={8}>
                <Form.Item
                  name="supplier_primary_address"
                  label={t.supplier_primary_address}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Select
                    placeholder={t.supplier_primary_address}
                    showSearch
                    popupMatchSelectWidth={false}
                    onSearch={(value) => {
                      setSearchTxtAddress(value);
                    }}
                    filterOption={false}
                    loading={isLoadingAddress}
                  >
                    {addressList?.message?.map((item) => (
                      <Select.Option key={item?.value} value={item?.value}>
                        <Flex gap={1} vertical>
                          <span>{item?.value}</span>
                          <span
                            className="item-description"
                            style={{ fontSize: '11px', color: 'gray' }}
                          >
                            {item?.description}
                          </span>
                        </Flex>
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={24}
                md={12}
                lg={8}
                xl={8}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  // justifyContent: 'end',
                }}
              >
                <Form.Item
                  name="on_hold"
                  label={t.blockSupplier}
                  valuePropName="checked"
                  layout="horizontal"
                  className="margin-bottom-0"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              {watchSOnHold === true ? (
                <>
                  <Col xs={24} md={12} lg={8} xl={8}>
                    <Form.Item name="hold_type" label={t.holdType}>
                      <Select
                        placeholder={t.holdType}
                        initialValue=""
                        options={[
                          {
                            value: '',
                            label: '',
                          },
                          {
                            value: 'All',
                            label: t.All,
                          },
                          {
                            value: 'Invoices',
                            label: t.Invoices,
                          },
                          {
                            value: 'Payments',
                            label: t.Payments,
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  {!watchHoldType
                    ? ''
                    : watchHoldType !== 'undefined' && (
                        <Col xs={24} md={12} lg={8} xl={8}>
                          <Form.Item
                            name="release_date"
                            label={t.releaseDate}
                            // initialValue={dayjs()}
                          >
                            <DatePicker
                              placeholder={t.releaseDate}
                              style={{ width: '100%' }}
                              format="YYYY-MM-DD"
                              disabledDate={(current) =>
                                current && current < dayjs().startOf('d')
                              }
                            />
                          </Form.Item>
                        </Col>
                      )}
                </>
              ) : null}
              <Col sm={24} xs={24} md={24} lg={24} xl={24}>
                <Form.List name="accounts" style={{ width: '100%' }}>
                  {(fields, { add, remove }) => (
                    <>
                      {fields?.map(({ key, name, ...restField }) => (
                        <Flex
                          gap={5}
                          key={key}
                          style={{
                            width: '100%',
                          }}
                        >
                          <Form.Item
                            name={[name, 'account']}
                            label={t.Accounts}
                            style={{ width: '100%', marginBottom: '0px' }}
                            {...restField}
                            // rules={[{ required: true }]}
                          >
                            <Select
                              placeholder={t.Accounts}
                              style={{ width: '100%' }}
                              popupMatchSelectWidth={false}
                              showSearch
                              filterOption={false}
                              allowClear
                              onSearch={(value) => {
                                setSetTextAccount(value);
                              }}
                              onChange={(value, option) => {
                                console.log(option, 'option');
                              }}
                              options={PayableAccounts?.map((item) => ({
                                value: item?.value,
                                label: item?.value,
                                data: { ...item, key },
                              }))}
                            />
                          </Form.Item>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              fontSize: '15px',
                              margin: '0 10px',
                            }}
                          >
                            {fields.length > 1 && (
                              <Button
                                type="text"
                                onClick={() => remove(name)}
                                danger
                                icon={<MdDelete color="red" />}
                              />
                            )}
                            <Button
                              type="text"
                              onClick={() => add()}
                              icon={<PlusOutlined color="#1890ff" />}
                            />
                          </div>
                        </Flex>
                      ))}
                    </>
                  )}
                </Form.List>
              </Col>
              <Col sm={24} xs={24} md={24} lg={24} xl={24}>
                <Form.Item
                  name="custom_address"
                  label={t.address}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input.TextArea
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    placeholder={t.address}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
              }}
            >
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalWarehouse = memo(
  ({ t, open, setOpen, editId, edit, setEdit, setEditId }) => {
    const { companyName, currentLang } = useSelector((state) => state.user);
    const client = useQueryClient();
    const [setTextAccount, setSetTextAccount] = useState('');
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    console.log('render modal');
    const { mutate: onAddWarehouse } = useMutation({
      mutationKey: ['addWarehouse'],
      mutationFn: (body) =>
        edit ? updateWarehouse(body, editId) : addWarehouse(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getWarehouse] });
        form.resetFields();
        setOpen(false);
        setEditId(null);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
      },
    });
    const {
      data: warehouseDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getWarehouse, editId],
      queryFn: () => getWarehouseDetails(editId),
      enabled: !!edit && !!editId,
    });
    const { data: parentWarehouses } = useQuery({
      queryKey: [queryKeys.getWarehouse],
      queryFn: () =>
        getWarehouse({
          key: '',
          value: '',
        }),
      keepPreviousData: true,
      select: (data) => data?.data.filter((item) => item?.is_group === 1),
    });
    const accountFilter = '{"is_group":0,"account_type":"Stock"}';
    // const { data: accounts } = useQuery({
    //   queryKey: [queryKeys.getAccounts],
    //   queryFn: () => getAccounts(accountFilter),
    //   keepPreviousData: true,
    // });
    const { data: accounts } = useQuery({
      queryKey: [queryKeys.getAccountSearch, setTextAccount],
      queryFn: () =>
        getSearchApiSearchText({ type: 'Account', searchTxt: setTextAccount }),
      keepPreviousData: true,
    });
    // const PayableAccounts = accounts?.message?.accounts;
    const PayableAccounts = accounts?.message;
    // useEffect(() => {
    //   if (edit) {
    //     refetch();
    //   }
    // }, [edit, refetch]);

    useEffect(() => {
      if (edit && warehouseDetails) {
        form.setFieldsValue({
          ...warehouseDetails?.data,
        });
      } else {
        form.resetFields();
      }
    }, [edit, warehouseDetails, form]);
    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddWarehouse({
        ...values,
        // is_group: values.is_group,
        disabled: values?.disabled ? 1 : 0,
        is_group: values?.is_group ? 1 : 0,
        is_rejected_warehouse: 0,
        company: companyName,
      });
    };

    return (
      <Modal
        title={edit ? t.editWarehouse : t.addWarehouse}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEditId(null);
          setEdit(false);
        }}
        footer={null}
        width={800}
      >
        <Form
          form={form}
          name="add-supplier"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            accounts: [{}],
          }}
          style={{
            marginTop: '20px',
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '20vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Row gutter={[16, 0]}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="warehouse_name"
                  label={t.warehouseName}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input placeholder={t.warehouseName} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="parent_warehouse"
                  label={t.ParentWarehouse}
                  // rules={[{ required: true }]}
                >
                  <Select
                    placeholder={t.ParentWarehouse}
                    style={{ width: '100%' }}
                    popupMatchSelectWidth={false}
                    onChange={(value, option) => {
                      console.log(option, 'option');
                    }}
                    options={parentWarehouses?.map((item) => ({
                      value: item?.name,
                      label: item?.warehouse_name,
                      data: item,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="account"
                  label={t.Accounts}
                  // rules={[{ required: true }]}
                >
                  <Select
                    placeholder={t.Accounts}
                    style={{ width: '100%' }}
                    popupMatchSelectWidth={false}
                    onChange={(value, option) => {
                      console.log(option, 'option');
                    }}
                    options={PayableAccounts?.map((item) => ({
                      value: item?.value,
                      label: item?.value,
                      data: item,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="phone_no"
                  label={t.phoneNumber}
                  className="w-full"
                  rules={[
                    {
                      validator: (rule, value) => {
                        console.log(value, 'value');
                        if (isValidPhoneNumber(value)) {
                          return Promise.resolve();
                        }
                        return Promise.reject('رقم الجوال غير صالح');
                      },
                    },
                  ]}
                  hasFeedback
                >
                  <PhoneInputWithCountrySelect
                    defaultCountry="SA"
                    className="w-full"
                    name="phone"
                    label={t.phoneNumber}
                    international
                    hasFeedback
                    limitMaxLength={true}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="mobile_no"
                  label={t.mobile}
                  className="w-full"
                  // rules={[
                  //   {
                  //     validator: (rule, value) => {
                  //       console.log(value, 'value');
                  //       if (isValidPhoneNumber(value)) {
                  //         return Promise.resolve();
                  //       }
                  //       return Promise.reject('رقم الجوال غير صالح');
                  //     },
                  //   },
                  // ]}
                  hasFeedback
                >
                  <PhoneInputWithCountrySelect
                    defaultCountry="SA"
                    className="w-full"
                    name="phone"
                    label={t.mobile}
                    international
                    hasFeedback
                    limitMaxLength={true}
                  />
                </Form.Item>
              </Col>
              <Col
                xs={24}
                md={12}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                }}
              >
                <Form.Item
                  name="disabled"
                  label={t.disabled}
                  valuePropName="checked"
                  layout="horizontal"
                  className="margin-bottom-0"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col
                xs={24}
                md={12}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                }}
              >
                <Form.Item
                  name="is_group"
                  label={t.isgroup}
                  valuePropName="checked"
                  layout="horizontal"
                  // className='margin-bottom-0'
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              {/* <Col span={6}>
            <Form.Item
              name="is_group"
              label={t.isgroup}
              rules={[
                {
                  required: true,
                },
              ]}
              initialValue={0}
              className="custom_plus_riyal"
            >
              <Radio.Group>
                <Radio value={1}>{t.yes}</Radio>
                <Radio value={0}>{t.no}</Radio>
              </Radio.Group>
            </Form.Item>
            </Col> */}
              <Col span={24}>
                <Form.Item
                  name="address_line_1"
                  label={t.address}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input.TextArea
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    placeholder={t.address}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
                setEditId(null);
              }}
            >
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalPriceList = memo(
  ({ t, open, setOpen, editId, edit, setEdit, setEditId }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);

    const { mutate: onAddPriceList } = useMutation({
      mutationKey: ['addPriceList'],
      mutationFn: (body) =>
        edit ? updatePriceList(body, editId) : addPriceList(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getPriceList] });
        form.resetFields();
        setOpen(false);
        setEditId(null);
      },
      onError: (error) => {
        setLoadingAdd(false);
        // message.error(error.response.data._server_messages);
        const serverMessages = JSON.parse(error.response.data._server_messages);
        const messageData = JSON.parse(serverMessages[0]);
        const title = messageData.title || 'Error';
        const messageContent = messageData.message || 'An error occurred';
        message.error({
          content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
          duration: 5,
        });
      },
    });

    const {
      data: priceListDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getPriceList, editId],
      queryFn: () => getPriceListDetails(editId),
      enabled: !!edit && !!editId,
    });
    const { data: currency } = useQuery({
      queryKey: [queryKeys.getCurrencsearch],
      queryFn: () => getSearchApi('Currency'),
      keepPreviousData: true,
    });
    // useEffect(() => {
    //   if (edit) {
    //     refetch();
    //   }
    // }, [edit, refetch]);

    useEffect(() => {
      if (edit && priceListDetails) {
        form.setFieldsValue({
          ...priceListDetails?.data,
          enabled: priceListDetails?.data?.enabled,
        });
      } else {
        form.resetFields();
      }
    }, [edit, priceListDetails, form]);

    const onFinish = (values) => {
      setLoadingAdd(true);
      onAddPriceList({
        ...values,
        enabled: values.enabled ? 1 : 0,
        selling: values.selling ? 1 : 0,
        buying: values.buying ? 1 : 0,
      });
    };

    return (
      <Modal
        title={edit ? t.editPriceList : t.addPriceList}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
          setEditId(null);
        }}
        footer={null}
        width={700}
      >
        <Form
          form={form}
          name="add-PriceList"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '40vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Row gutter={[16, 0]}>
              {/* Price List Name */}
              <Col xs={24} md={12}>
                <Form.Item
                  name="price_list_name"
                  label={t.priceListName}
                  rules={[{ required: true }]}
                >
                  <Input placeholder={t.priceListName} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="currency"
                  label={t.currency}
                  rules={[{ required: true }]}
                  initialValue="SAR"
                >
                  <Select
                    placeholder={t.currency}
                    // currency
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLocaleLowerCase().includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? '')
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                    options={currency?.message?.map((item) => ({
                      value: item?.value,
                      label: item?.value,
                    }))}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                {/* <Form.Item
                  name="buying"
                  label={t.buying}
                  rules={[{ required: true }]}
                  initialValue={0}
                >
                  <Select
                    onChange={(value) => {
                      form.setFieldsValue({
                        selling: value === 0 ? 1 : 0,
                      });
                    }}
                  >
                    <Select.Option value={1}>{t.yes}</Select.Option>
                    <Select.Option value={0}>{t.no}</Select.Option>
                  </Select>
                </Form.Item> */}
                <Form.Item
                  name="buying"
                  label={t.buying}
                  valuePropName="checked"
                  layout="horizontal"
                  // className='margin-bottom-0'
                >
                  <Checkbox />
                </Form.Item>
              </Col>

              <Col span={8}>
                {/* <Form.Item
                  name="selling"
                  label={t.selling}
                  rules={[{ required: true }]}
                  initialValue={1}
                >
                  <Select disabled>
                    <Select.Option value={1}>{t.yes}</Select.Option>
                    <Select.Option value={0}>{t.no}</Select.Option>
                  </Select>
                </Form.Item> */}
                <Form.Item
                  name="selling"
                  label={t.selling}
                  valuePropName="checked"
                  layout="horizontal"
                  // className='margin-bottom-0'
                >
                  <Checkbox />
                </Form.Item>
              </Col>

              <Col span={8}>
                {/* <Form.Item
                  name="enabled"
                  label={t.enabled}
                  rules={[{ required: true }]}
                  className="custom_plus_riyal"
                  initialValue={1}
                >
                  <Radio.Group>
                    <Radio value={1}>{t.Yes}</Radio>
                    <Radio value={0}>{t.No}</Radio>
                  </Radio.Group>
                </Form.Item> */}
                <Form.Item
                  name="enabled"
                  label={t.enabled}
                  valuePropName="checked"
                  layout="horizontal"
                  // className='margin-bottom-0'
                >
                  <Checkbox />
                </Form.Item>
              </Col>
            </Row>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
                setEditId(null);
              }}
            >
              {t.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalUnitMeasure = memo(
  ({ t, open, setOpen, editId, edit, setEdit, setEditId }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);

    const { mutate: onAddUnitMeasure } = useMutation({
      mutationKey: ['addUnitMeasure'],
      mutationFn: (body) =>
        edit ? updateUnitMeasure(body, editId) : addUnitMeasure(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getUnitMeasure] });
        form.resetFields();
        setOpen(false);
        setEditId(null);
      },
      onError: (error) => {
        setLoadingAdd(false);
        // message.error(error.response.data._server_messages);
        const serverMessages = JSON.parse(error.response.data._server_messages);
        const messageData = JSON.parse(serverMessages[0]);
        const title = messageData.title || 'Error';
        const messageContent = messageData.message || 'An error occurred';
        message.error({
          content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
          duration: 5,
        });
      },
    });

    const {
      data: unitMeasureDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getUnitMeasure, editId],
      queryFn: () => getUnitMeasureDetails(editId),
      enabled: !!edit && !!editId,
    });

    // useEffect(() => {
    //   if (edit) {
    //     refetch();
    //   }
    // }, [edit, refetch]);

    useEffect(() => {
      if (edit && unitMeasureDetails) {
        form.setFieldsValue({
          ...unitMeasureDetails?.data,
          enabled: unitMeasureDetails?.data?.enabled,
          must_be_whole_number: unitMeasureDetails?.data?.must_be_whole_number,
        });
      } else {
        form.resetFields();
      }
    }, [edit, unitMeasureDetails, form]);

    const onFinish = (values) => {
      setLoadingAdd(true);
      onAddUnitMeasure({
        ...values,
        enabled: values.enabled,
        must_be_whole_number: values.must_be_whole_number,
      });
    };

    return (
      <Modal
        title={edit ? t.editUnitMeasure : t.addUnitMeasure}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
          setEditId(null);
        }}
        footer={null}
        // width={600}
      >
        <Form
          form={form}
          name="add-unit-measure"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '40vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Form.Item
                name="uom_name"
                label={t.unitMeasureName}
                rules={[{ required: true }]}
              >
                <Input placeholder={t.unitMeasureName} />
              </Form.Item>
              <Form.Item
                name="must_be_whole_number"
                label={t.mustBeWholeNumber}
                rules={[{ required: true }]}
                className="custom_plus_riyal"
                initialValue={1}
              >
                <Radio.Group>
                  <Radio value={1}>{t.Yes}</Radio>
                  <Radio value={0}>{t.No}</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="enabled"
                label={t.enabled}
                rules={[{ required: true }]}
                className="custom_plus_riyal"
                initialValue={1}
              >
                <Radio.Group>
                  <Radio value={1}>{t.Yes}</Radio>
                  <Radio value={0}>{t.No}</Radio>
                </Radio.Group>
              </Form.Item>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
                setEditId(null);
              }}
            >
              {t.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalItemPrice = memo(
  ({ t, open, setOpen, editId, edit, setEdit, setEditId }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [searchTextItems, setSearchTextItems] = useState('');
    const { mutate: onAddItemPrice } = useMutation({
      mutationKey: ['addItemPrice'],
      mutationFn: (body) =>
        edit ? updateItemPrice(body, editId) : addItemPrice(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getItemPrice] });
        form.resetFields();
        setOpen(false);
        setEditId(null);
      },
      onError: (error) => {
        setLoadingAdd(false);
        // message.error(error.response.data._server_messages);
        const serverMessages = JSON.parse(error.response.data._server_messages);
        const messageData = JSON.parse(serverMessages[0]);
        const title = messageData.title || 'Error';
        const messageContent = messageData.message || 'An error occurred';
        message.error({
          content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
          duration: 5,
        });
      },
    });

    const {
      data: itemPriceDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getItemPrice, editId],
      queryFn: () => getItemPriceDetails(editId),
      enabled: !!edit && !!editId,
    });
    // const { data: AllItems } = useQuery({
    //   queryKey: [queryKeys.getAllServicesAndItem],
    //   queryFn: () => getAllServicesAndItem(),
    //   keepPreviousData: true,
    // });
    const { data: itemsList } = useQuery({
      queryKey: [queryKeys.getSearcApiItemCode, searchTextItems],
      queryFn: () =>
        getSearchApiIsStock({
          type: 'Item',
          text: searchTextItems,
          stock: 1,
        }),
      keepPreviousData: true,
      enabled: searchTextItems?.length >= 3 || searchTextItems?.length === 0,
    });
    const { data: priceList } = useQuery({
      queryKey: [queryKeys.getPriceList],
      queryFn: () =>
        getPriceList({
          key: '',
          value: '',
        }),
      keepPreviousData: true,
    });
    // useEffect(() => {
    //   if (edit) {
    //     refetch();
    //   }
    // }, [edit, refetch]);

    useEffect(() => {
      if (edit && itemPriceDetails) {
        form.setFieldsValue({
          ...itemPriceDetails?.data,
          valid_from: dayjs(itemPriceDetails?.data?.valid_from),
          valid_upto: dayjs(itemPriceDetails?.data?.valid_upto),
        });
      } else {
        form.resetFields();
      }
    }, [edit, itemPriceDetails, form]);

    const onFinish = (values) => {
      setLoadingAdd(true);
      onAddItemPrice({
        ...values,
        valid_from: dayjs(values.valid_from).format('YYYY-MM-DD'),
        valid_upto: dayjs(values.valid_upto).format('YYYY-MM-DD'),
      });
    };

    return (
      <Modal
        title={edit ? t.editItemPrice : t.addItemPrice}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
          setEditId(null);
        }}
        footer={null}
        width={'60%'}
      >
        <Form
          form={form}
          name="add-Item-Price"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '40vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="item_code"
                    label={t.itemCode}
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      popupMatchSelectWidth={false}
                      placeholder={t.itemCode}
                      filterOption={false}
                      onSearch={(value) => setSearchTextItems(value)}
                      // onChange={(value, option) => {
                      //   console.log(option, 'option');
                      //   form.setFieldsValue({
                      //     item_code: value,
                      //     item_name: option?.option?.item_name,
                      //     description: option?.option?.description,
                      //     item_description: option?.option?.description,
                      //     item_group: option?.option?.item_group,
                      //     rate: option?.option?.rate,
                      //     shelf_life_in_days:
                      //       option?.option?.shelf_life_in_days,
                      //     stock_uom: option?.option?.stock_uom,
                      //   });
                      // }}
                      // options={AllItems?.message?.items?.map((item) => ({
                      //   value: item?.item_code,
                      //   label: item?.item_code,
                      //   option: item,
                      // }))}
                    >
                      {itemsList?.message?.map((item) => (
                        <Select.Option key={item?.value} value={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="price_list"
                    label={t.PriceList}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.PriceList}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      // mode="multiple"
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      onChange={(value, option) => {
                        console.log(option, 'option');
                        form.setFieldsValue({
                          buying: option?.option?.buying,
                          selling: option?.option?.selling,
                          currency: option?.option?.currency,
                        });
                      }}
                      options={priceList?.data?.map((item) => ({
                        value: item?.name,
                        label: item?.price_list_name,
                        option: item,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="price_list_rate"
                    label={t.priceListRate}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.priceListRate} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="valid_from"
                    label={t.validFrom}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      format="YYYY-MM-DD"
                      placeholder={t.validFrom}
                      style={{ width: '100%' }}
                      // disabledDate={disabledDate}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="valid_upto"
                    label={t.validUpto}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    // initialValue={dayjs()}
                  >
                    <DatePicker
                      format="YYYY-MM-DD"
                      placeholder={t.validUpto}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="currency"
                    label={t.currency}
                    // initialValue="SAR"
                  >
                    <Input placeholder={t.currency} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item name="buying" label={t.buying}>
                    <Select disabled placeholder={t.buying}>
                      <Select.Option value={1}>{t.yes}</Select.Option>
                      <Select.Option value={0}>{t.no}</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item name="selling" label={t.selling}>
                    <Select disabled placeholder={t.selling}>
                      <Select.Option value={1}>{t.yes}</Select.Option>
                      <Select.Option value={0}>{t.no}</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
                setEditId(null);
              }}
            >
              {t.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);

export const ModalAppItemDetails = memo(
  ({ t, open, setOpen, dataSource, selectedIndex, setDataSource, type }) => {
    // console.log(dataSource, 'dataSource');
    const [searchTextCostCenter, setSearchTextCostCenter] = useState('');
    const [searchTextIncomeAccount, setSearchTextIncomeAccount] = useState('');
    const [selectData, setSelectData] = useState(null);
    // console.log(selectData, 'selectData');

    const [searchText, setSearchText] = useState('');
    const [searchTextUOM, setSearchTextUOM] = useState('');
    const { data: costCenter } = useQuery({
      queryKey: [queryKeys.getSearchCostCenter, searchTextCostCenter],
      queryFn: () => getSearchPatients('Cost Center', searchTextUOM),
      keepPreviousData: true,
      enabled:
        searchTextCostCenter?.length >= 3 || searchTextCostCenter?.length === 0,
    });
    const { data: Warehouse } = useQuery({
      queryKey: [queryKeys.getSearchWarehouse, searchText],
      queryFn: () => getSearchPatients('Warehouse', searchText),
      keepPreviousData: true,
      enabled: searchText?.length >= 3 || searchText?.length === 0,
    });
    const { data: uom } = useQuery({
      queryKey: [queryKeys.getSearchuom, searchTextUOM],
      queryFn: () => getSearchPatients('UOM', searchTextUOM),
      keepPreviousData: true,
      enabled: searchTextUOM?.length >= 3 || searchTextUOM?.length === 0,
    });
    const { data: incomeAccount } = useQuery({
      queryKey: [queryKeys.getSearchIncomeAccount, searchTextIncomeAccount],
      queryFn: () => getSearchPatients('Account', searchTextIncomeAccount),
      keepPreviousData: true,
      enabled:
        searchTextIncomeAccount?.length >= 3 ||
        searchTextIncomeAccount?.length === 0,
    });
    useEffect(() => {
      if (open && dataSource) {
        setSelectData(dataSource[selectedIndex]);
      } else {
        setSelectData(null);
      }
    }, [dataSource, selectedIndex, open, selectData]);
    return (
      <Modal
        title={t.itemDetails}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
        }}
        footer={null}
        width={900}
      >
        <>
          <Descriptions column={2} bordered style={{ marginTop: '20px' }}>
            {type === 'Material Request' ? (
              <>
                <Descriptions.Item label={t.itemCode}>
                  {selectData?.item_code}
                </Descriptions.Item>
                <Descriptions.Item label={t.itemName}>
                  {selectData?.item_name}
                </Descriptions.Item>
                <Descriptions.Item label={t.scheduleDate}>
                  {selectData?.schedule_date}
                </Descriptions.Item>
                <Descriptions.Item label={t.description}>
                  {selectData?.description}
                </Descriptions.Item>
                <Descriptions.Item label={t.itemGroup}>
                  {selectData?.item_group}
                </Descriptions.Item>
                <Descriptions.Item label={t.quantity}>
                  {selectData?.qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.warehouse}>
                  <Select
                    placeholder={t.warehouse}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.warehouse}
                    onSearch={(value) => setSearchText(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        warehouse: value,
                      };
                      setDataSource(newDataSource);
                    }}
                    options={Warehouse?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.uom}>
                  {' '}
                  {/* {selectData?.uom}{' '} */}
                  <Select
                    placeholder={t.uom}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.uom}
                    onSearch={(value) => setSearchTextUOM(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        uom: value,
                      };
                      setDataSource(newDataSource);
                    }}
                    options={uom?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.stockQty}>
                  {selectData?.stock_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.projectedQty}>
                  {selectData?.projected_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.actualQty}>
                  {selectData?.actual_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.orderedQty}>
                  {selectData?.ordered_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.receivedQty}>
                  {selectData?.received_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.expenseAccount}>
                  <Select
                    placeholder={t.expenseAccount}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.expense_account}
                    onSearch={(value) => setSearchTextIncomeAccount(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        expense_account: value,
                      };
                      setDataSource(newDataSource);
                      setSearchTextIncomeAccount('');
                    }}
                    options={incomeAccount?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.costCenter}>
                  <Select
                    placeholder={t.costCenter}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.cost_center}
                    onSearch={(value) => setSearchTextCostCenter(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        cost_center: value,
                      };
                      setDataSource(newDataSource);
                    }}
                    options={costCenter?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
              </>
            ) : type === 'Purchase Order' ? (
              <>
                <Descriptions.Item label={t.itemCode}>
                  {selectData?.item_code}
                </Descriptions.Item>
                <Descriptions.Item label={t.itemName}>
                  {selectData?.item_name}
                </Descriptions.Item>
                <Descriptions.Item label={t.fgItemQty}>
                  {selectData?.fg_item_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.scheduleDate}>
                  {selectData?.schedule_date}
                </Descriptions.Item>
                <Descriptions.Item label={t.itemGroup}>
                  {selectData?.item_group}
                </Descriptions.Item>
                <Descriptions.Item label={t.description}>
                  {selectData?.description}
                </Descriptions.Item>
                <Descriptions.Item label={t.isZeroRated}>
                  {selectData?.is_zero_rated}
                </Descriptions.Item>
                <Descriptions.Item label={t.isExempt}>
                  {selectData?.is_exempt}
                </Descriptions.Item>
                {/* <Descriptions.Item label={t.image}>
                  {selectData?.image}
                </Descriptions.Item> */}
                <Descriptions.Item label={t.quantity}>
                  {selectData?.qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.uom}>
                  {' '}
                  {/* {selectData?.uom}{' '} */}
                  <Select
                    placeholder={t.uom}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.uom}
                    onSearch={(value) => setSearchTextUOM(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        uom: value,
                      };
                      setDataSource(newDataSource);
                    }}
                    options={uom?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.stockQty}>
                  {selectData?.stock_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.priceListRate}>
                  {selectData?.price_list_rate}
                </Descriptions.Item>
                <Descriptions.Item label={t.discountPercentage}>
                  <Input
                    value={selectData?.discount_percentage}
                    type="number"
                    onChange={(e) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        discount_percentage: e.target.value,
                      };
                      setDataSource(newDataSource);
                    }}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.discountAmount}>
                  <Input
                    value={selectData?.discount_amount}
                    type="number"
                    onChange={(e) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        discount_amount: e.target.value,
                      };
                      setDataSource(newDataSource);
                    }}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.rate}>
                  {selectData?.rate}
                </Descriptions.Item>
                <Descriptions.Item label={t.amount}>
                  {selectData?.amount}
                </Descriptions.Item>
                <Descriptions.Item label={t.warehouse}>
                  <Select
                    placeholder={t.warehouse}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.warehouse}
                    onSearch={(value) => setSearchText(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        warehouse: value,
                      };
                      setDataSource(newDataSource);
                    }}
                    options={Warehouse?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.actualQty}>
                  {selectData?.actual_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.returnedQty}>
                  {selectData?.returned_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.landedCostVoucherAmount}>
                  {selectData?.landed_cost_voucher_amount}
                </Descriptions.Item>
                <Descriptions.Item label={t.billedAmt}>
                  {selectData?.billed_amt}
                </Descriptions.Item>
                <Descriptions.Item label={t.valuationRate}>
                  {selectData?.valuation_rate}
                </Descriptions.Item>
              </>
            ) : type === 'Purchase Reciept' ? (
              <>
                <Descriptions.Item label={t.itemCode}>
                  {selectData?.item_code}
                </Descriptions.Item>
                <Descriptions.Item label={t.itemName}>
                  {selectData?.item_name}
                </Descriptions.Item>
                <Descriptions.Item label={t.description}>
                  {selectData?.description}
                </Descriptions.Item>
                <Descriptions.Item label={t.itemGroup}>
                  {selectData?.item_group}
                </Descriptions.Item>
                <Descriptions.Item label={t.receivedQty}>
                  {selectData?.received_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.qty}>
                  {selectData?.qty}
                </Descriptions.Item>
                {/* <Descriptions.Item label={t.rejectedQty}>
                  {selectData?.rejected_qty}
                </Descriptions.Item> */}
                <Descriptions.Item label={t.uom}>
                  {' '}
                  {/* {selectData?.uom}{' '} */}
                  <Select
                    placeholder={t.uom}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.uom}
                    onSearch={(value) => setSearchTextUOM(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        uom: value,
                      };
                      setDataSource(newDataSource);
                    }}
                    options={uom?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.receivedStockQty}>
                  {selectData?.received_stock_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.stockQty}>
                  {selectData?.stock_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.returnedQty}>
                  {selectData?.returned_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.priceListRate}>
                  {selectData?.price_list_rate}
                </Descriptions.Item>
                <Descriptions.Item label={t.discountPercentage}>
                  {selectData?.discount_percentage}
                </Descriptions.Item>
                <Descriptions.Item label={t.discountAmount}>
                  {selectData?.discount_amount}
                </Descriptions.Item>
                <Descriptions.Item label={t.rate}>
                  {selectData?.rate}
                </Descriptions.Item>
                <Descriptions.Item label={t.amount}>
                  {selectData?.amount}
                </Descriptions.Item>
                <Descriptions.Item label={t.itemTaxTemplate}>
                  {selectData?.item_tax_template}
                </Descriptions.Item>
                <Descriptions.Item label={t.valuationRate}>
                  {selectData?.valuation_rate}
                </Descriptions.Item>
                <Descriptions.Item label={t.landedCostVoucherAmount}>
                  {selectData?.landed_cost_voucher_amount}
                </Descriptions.Item>
                <Descriptions.Item label={t.billedAmt}>
                  {selectData?.billed_amt}
                </Descriptions.Item>
                <Descriptions.Item label={t.warehouse}>
                  <Select
                    placeholder={t.warehouse}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.warehouse}
                    onSearch={(value) => setSearchText(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        warehouse: value,
                      };
                      setDataSource(newDataSource);
                    }}
                    options={Warehouse?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.materialRequest}>
                  {selectData?.material_request}
                </Descriptions.Item>
                <Descriptions.Item label={t.purchaseOrder}>
                  {selectData?.purchase_order}
                </Descriptions.Item>
                <Descriptions.Item label={t.scheduleDate}>
                  {selectData?.schedule_date}
                </Descriptions.Item>
                {/* <Descriptions.Item label={t.itemTaxRate}>
                  {selectData?.item_tax_rate}
                </Descriptions.Item> */}
                <Descriptions.Item label={t.expenseAccount}>
                  <Select
                    placeholder={t.expenseAccount}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.expense_account}
                    onSearch={(value) => setSearchTextIncomeAccount(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        expense_account: value,
                      };
                      setDataSource(newDataSource);
                      setSearchTextIncomeAccount('');
                    }}
                    options={incomeAccount?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.costCenter}>
                  <Select
                    placeholder={t.costCenter}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.cost_center}
                    onSearch={(value) => setSearchTextCostCenter(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        cost_center: value,
                      };
                      setDataSource(newDataSource);
                    }}
                    options={costCenter?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
              </>
            ) : type === 'Purchase Invoice' ? (
              <>
                <Descriptions.Item label={t.itemCode}>
                  {selectData?.item_code}
                </Descriptions.Item>
                <Descriptions.Item label={t.itemName}>
                  {selectData?.item_name}
                </Descriptions.Item>
                <Descriptions.Item label={t.description}>
                  {selectData?.description}
                </Descriptions.Item>
                <Descriptions.Item label={t.itemGroup}>
                  {selectData?.item_group}
                </Descriptions.Item>
                <Descriptions.Item label={t.quantity}>
                  {selectData?.qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.rejectedQty}>
                  {selectData?.rejected_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.stockQty}>
                  {selectData?.stock_qty}
                </Descriptions.Item>
                <Descriptions.Item label={t.discountPercentage}>
                  {selectData?.discount_percentage}
                </Descriptions.Item>
                <Descriptions.Item label={t.discountAmount}>
                  {selectData?.discount_amount}
                </Descriptions.Item>
                <Descriptions.Item label={t.rate}>
                  {selectData?.rate}
                </Descriptions.Item>
                <Descriptions.Item label={t.amount}>
                  {selectData?.amount}
                </Descriptions.Item>
                <Descriptions.Item label={t.itemTaxTemplate}>
                  {selectData?.item_tax_template}
                </Descriptions.Item>
                <Descriptions.Item label={t.valuationRate}>
                  {selectData?.valuation_rate}
                </Descriptions.Item>
                <Descriptions.Item label={t.itemTaxAmount}>
                  {selectData?.item_tax_amount}
                </Descriptions.Item>
                <Descriptions.Item label={t.landedCostVoucherAmount}>
                  {selectData?.landed_cost_voucher_amount}
                </Descriptions.Item>
                <Descriptions.Item label={t.warehouse}>
                  <Select
                    placeholder={t.warehouse}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.warehouse}
                    onSearch={(value) => setSearchText(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        warehouse: value,
                      };
                      setDataSource(newDataSource);
                    }}
                    options={Warehouse?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.expenseAccount}>
                  <Select
                    placeholder={t.expenseAccount}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.expense_account}
                    onSearch={(value) => setSearchTextIncomeAccount(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        expense_account: value,
                      };
                      setDataSource(newDataSource);
                      setSearchTextIncomeAccount('');
                    }}
                    options={incomeAccount?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.enableDeferredExpense}>
                  <Checkbox
                    checked={selectData?.enable_deferred_expense === 1}
                    onChange={(e) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        enable_deferred_expense: e.target.checked ? 1 : 0,
                      };
                      setDataSource(newDataSource);
                    }}
                  />
                </Descriptions.Item>
                {selectData?.enable_deferred_expense === 1 && (
                  <>
                    <Descriptions.Item label={t.serviceStartDate}>
                      {/* {selectData?.service_start_date} */}
                      <DatePicker
                        placeholder={t.serviceStartDate}
                        style={{ width: '100%' }}
                        value={dayjs(selectData?.service_start_date)}
                        onChange={(value) => {
                          const newDataSource = [...dataSource];
                          newDataSource[selectedIndex] = {
                            ...newDataSource[selectedIndex],
                            service_start_date:
                              dayjs(value).format('YYYY-MM-DD'),
                          };
                          setDataSource(newDataSource);
                        }}
                      />
                    </Descriptions.Item>
                    <Descriptions.Item label={t.serviceEndDate}>
                      {/* {selectData?.service_end_date} */}
                      <DatePicker
                        placeholder={t.serviceEndDate}
                        style={{ width: '100%' }}
                        value={dayjs(selectData?.service_end_date)}
                        onChange={(value) => {
                          const newDataSource = [...dataSource];
                          newDataSource[selectedIndex] = {
                            ...newDataSource[selectedIndex],
                            service_end_date: dayjs(value).format('YYYY-MM-DD'),
                          };
                          setDataSource(newDataSource);
                        }}
                      />
                    </Descriptions.Item>
                    <Descriptions.Item label={t.deferredExpenseAccount}>
                      <Select
                        placeholder={t.deferredExpenseAccount}
                        style={{ width: '100%' }}
                        showSearch
                        optionFilterProp="children"
                        filterOption={false}
                        popupMatchSelectWidth={false}
                        value={selectData?.deferredExpenseAccount}
                        onSearch={(value) => setSearchTextIncomeAccount(value)}
                        onChange={(value) => {
                          const newDataSource = [...dataSource];
                          newDataSource[selectedIndex] = {
                            ...newDataSource[selectedIndex],
                            deferred_expense_account: value,
                          };
                          setDataSource(newDataSource);
                          setSearchTextIncomeAccount('');
                        }}
                        options={incomeAccount?.message?.map((user) => ({
                          value: user.value,
                          label: user.value,
                        }))}
                      />
                    </Descriptions.Item>
                  </>
                )}
                <Descriptions.Item label={t.costCenter}>
                  <Select
                    placeholder={t.costCenter}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.cost_center}
                    onSearch={(value) => setSearchTextCostCenter(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        cost_center: value,
                      };
                      setDataSource(newDataSource);
                    }}
                    options={costCenter?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.uom}>
                  <Select
                    placeholder={t.uom}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.uom}
                    onSearch={(value) => setSearchTextUOM(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        uom: value,
                      };
                      setDataSource(newDataSource);
                    }}
                    options={uom?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
              </>
            ) : null}
          </Descriptions>
        </>
      </Modal>
    );
  }
);
export const ModalAppTaxesDetails = memo(({ t, open, setOpen, selectData }) => {
  return (
    <Modal
      title={t.taxesDetails}
      open={open}
      centered
      onCancel={() => {
        setOpen(false);
      }}
      footer={null}
      width={900}
    >
      <>
        <Descriptions column={2} bordered style={{ marginTop: '20px' }}>
          <Descriptions.Item label={t.Category}>
            {' '}
            {selectData?.category}
          </Descriptions.Item>
          <Descriptions.Item label={t.addDeductTax}>
            {' '}
            {selectData?.add_deduct_tax}{' '}
          </Descriptions.Item>
          <Descriptions.Item label={t.chargeType}>
            {' '}
            {selectData?.charge_type}{' '}
          </Descriptions.Item>
          <Descriptions.Item label={t.description}>
            {' '}
            {selectData?.description}{' '}
          </Descriptions.Item>
          <Descriptions.Item label={t.accountHead}>
            {' '}
            {selectData?.account_head}{' '}
          </Descriptions.Item>
          <Descriptions.Item label={t.costCenter}>
            {' '}
            {selectData?.cost_center}{' '}
          </Descriptions.Item>
          {/* <Descriptions.Item label={t.includedInPaidAmount}>
            {' '}
            {selectData?.included_in_paid_amount}{' '}
          </Descriptions.Item>
          <Descriptions.Item label={t.includedInPrintRate}>
            {' '}
            {selectData?.included_in_print_rate}{' '}
          </Descriptions.Item> */}
          <Descriptions.Item label={t.Rate}>
            {' '}
            {selectData?.rate}{' '}
          </Descriptions.Item>
          <Descriptions.Item label={t.Total}>
            {' '}
            {selectData?.total}{' '}
          </Descriptions.Item>
        </Descriptions>
      </>
    </Modal>
  );
});

export const ModalAddLeavePolicy = memo(
  ({ t, open, setOpen, editId, edit, setEdit, setEditId }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [selectName, setSelectName] = useState(null);
    const [submitButton, setSubmitButton] = useState(false);
    const [dataStatus, setDataStatus] = useState(null);
    const { mutate: onAddPolicy } = useMutation({
      mutationKey: ['addPolicy'],
      mutationFn: (body) =>
        edit ? updateLeavePolicy(body, editId) : addLeavePolicy(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        setSelectName(edit ? editId : data?.data?.name);
        setSubmitButton(true);
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getLeavePolicy] });
        edit && dataStatus !== 0 && form.resetFields();
        edit && dataStatus !== 0 && setOpen(false);
        edit && dataStatus !== 0 && setEditId(null);
        edit && dataStatus !== 0 && setLoadingAdd(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        // message.error(error.response.data._server_messages);
        const serverMessages = JSON.parse(error.response.data._server_messages);
        const messageData = JSON.parse(serverMessages[0]);
        const title = messageData.title || 'Error';
        const messageContent = messageData.message || 'An error occurred';
        message.error({
          content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
          duration: 5,
        });
        console.log('error:', error);
      },
    });
    const handleSubmit = useMutation({
      mutationFn: (id) => submitMaterialRequest('Leave Policy', id),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message || 'Submitted successfully');
        client.invalidateQueries({ queryKey: [queryKeys.getLeavePolicy] });
        setOpen(false);
        setLoadingAdd(false);
        form.resetFields();
      },
      onError: () => {
        message.error('Something went wrong');
      },
    });
    const {
      data: leavePolicyDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getLeavePolicy, editId],
      queryFn: () => getLeavePolicyDetails(editId),
      enabled: !!edit && !!editId,
    });
    const { data: leaveType } = useQuery({
      queryKey: [queryKeys.getLeaveTypeSearch],
      queryFn: () => getSearchApi('Leave Type'),
      keepPreviousData: true,
    });
    // useEffect(() => {
    //   if (edit) {
    //     refetch();
    //   }
    // }, [edit, refetch]);

    useEffect(() => {
      if (edit && leavePolicyDetails) {
        setDataStatus(leavePolicyDetails?.data?.docstatus);
        form.setFieldsValue({
          ...leavePolicyDetails?.data,
        });
      } else {
        form.resetFields();
      }
    }, [edit, leavePolicyDetails, form]);
    const onFinish = (values) => {
      setLoadingAdd(true);
      onAddPolicy({
        ...values,
      });
    };

    return (
      <Modal
        title={edit ? t.EditLeavePolicy : t.AddLeavePolicy}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
          setEditId(null);
        }}
        footer={null}
        width={600}
      >
        <Form
          form={form}
          name="add-unit-measure"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
          initialValues={{
            leave_policy_details: [{}],
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '40vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Form.Item
                name="title"
                label={t.title}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.title} />
              </Form.Item>
              <Form.List name="leave_policy_details" style={{ width: '100%' }}>
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <>
                        <Flex
                          key={key}
                          justify="space-between"
                          align="center"
                          gap="5px"
                          style={{
                            width: '100%',
                          }}
                        >
                          <Form.Item
                            name={[name, 'leave_type']}
                            label={t.LeaveType}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                          >
                            <Select
                              placeholder={t.LeaveType}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? '')
                                  .toLocaleLowerCase()
                                  .includes(input)
                              }
                              filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '')
                                  .toLowerCase()
                                  .localeCompare(
                                    (optionB?.label ?? '').toLowerCase()
                                  )
                              }
                              options={leaveType?.message?.map((user) => ({
                                value: user.value,
                                label: user.value,
                              }))}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, 'annual_allocation']}
                            label={t.annualAllocation}
                            style={{
                              width: '100%',
                              marginBottom: '0px',
                            }}
                            {...restField}
                          >
                            <Input
                              placeholder={t.annualAllocation}
                              type="number"
                            />
                          </Form.Item>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              fontSize: '15px',
                              margin: '0 10px',
                            }}
                          >
                            {fields.length > 1 && (
                              <Button
                                type="text"
                                onClick={() => remove(name)}
                                danger
                                icon={<MdDelete color="red" />}
                              />
                            )}
                            <Button
                              type="text"
                              onClick={() => add()}
                              icon={<PlusOutlined color="#1890ff" />}
                            />
                          </div>
                        </Flex>
                      </>
                    ))}
                  </>
                )}
              </Form.List>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
                setEditId(null);
              }}
            >
              {t.cancel}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (submitButton) {
                  setLoadingAdd(true);
                  handleSubmit.mutate(selectName);
                } else {
                  form.submit();
                }
              }}
              loading={loadingAdd}
            >
              {/* {edit ? t.edit : t.submit} */}
              {submitButton ? t.submit : edit ? t.edit : t.Save}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);

export const ModalAddLeavePolicyAssign = memo(
  ({ t, open, setOpen, editId, edit, setEdit }) => {
    const client = useQueryClient();
    const [searchTextItems, setSearchTextItems] = useState('');
    const [searchText, setSearchText] = useState('');
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [selectName, setSelectName] = useState(null);
    const [dataStatus, setDataStatus] = useState(null);
    const [submitButton, setSubmitButton] = useState(false);

    const { mutate: onAddPolicy } = useMutation({
      mutationKey: ['addLeavePolicyAssign'],
      mutationFn: (body) =>
        edit
          ? updateLeavePolicyAssign(body, editId)
          : addLeavePolicyAssign(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        setSelectName(edit ? editId : data?.data?.name);
        setSubmitButton(true);
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({
          queryKey: [queryKeys.getLeavePolicyAssign],
        });
        edit && dataStatus !== 0 && form.resetFields();
        edit && dataStatus !== 0 && setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        // message.error(error.response.data._server_messages);
        const serverMessages = JSON.parse(error.response.data._server_messages);
        const messageData = JSON.parse(serverMessages[0]);
        const title = messageData.title || 'Error';
        const messageContent = messageData.message || 'An error occurred';
        message.error({
          content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
          duration: 5,
        });
        console.log('error:', error);
      },
    });
    const handleSubmit = useMutation({
      mutationFn: (id) => submitMaterialRequest('Leave Policy Assignment', id),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        submitButton && setOpen(false);
        message.success(data?.message?.message || 'Submitted successfully');
        client.invalidateQueries({
          queryKey: [queryKeys.getLeavePolicyAssign],
        });
        setLoadingAdd(false);
        form.resetFields();
      },
      onError: () => {
        message.error('Something went wrong');
      },
    });
    const {
      data: leavePolicyDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getLeavePolicyAssign, editId],
      queryFn: () => getLeavePolicyAssignDetails(editId),
      enabled: !!edit && !!editId,
    });
    // const { data: employee } = useQuery({
    //   queryKey: [queryKeys.getEmployee],
    //   queryFn: () => getEmployee(),
    // });
    // const { data: LeavePolicy } = useQuery({
    //   queryKey: [queryKeys.getLeavePolicySearch],
    //   queryFn: () => getSearchApi('Leave Policy'),
    //   keepPreviousData: true,
    // });
    useEffect(() => {
      if (edit) {
        refetch();
      }
    }, [edit, refetch]);
    const { data: employeeList } = useQuery({
      queryKey: [queryKeys.getSearchPatientsEmployee, searchTextItems],
      queryFn: () => getSearchPatients('Employee', searchTextItems),
      keepPreviousData: true,
      enabled: searchTextItems?.length >= 3 || searchTextItems?.length === 0,
    });
    const { data: leavePolicy } = useQuery({
      queryKey: [queryKeys.getSearchPatientsLeavePolicy, searchText],
      queryFn: () => getSearchPatients('Leave Policy', searchText),
      keepPreviousData: true,
      enabled: searchText?.length >= 3 || searchText?.length === 0,
    });
    useEffect(() => {
      if (edit && leavePolicyDetails) {
        setDataStatus(leavePolicyDetails?.data?.docstatus);
        form.setFieldsValue({
          ...leavePolicyDetails?.data,
          effective_from: dayjs(leavePolicyDetails?.data?.effective_from),
          effective_to: dayjs(leavePolicyDetails?.data?.effective_to),
        });
      } else {
        form.resetFields();
      }
    }, [edit, leavePolicyDetails, form]);
    const onFinish = (values) => {
      setLoadingAdd(true);
      onAddPolicy({
        ...values,
        effective_from: dayjs(values?.effective_from).format('YYYY-MM-DD'),
        effective_to: dayjs(values?.effective_to).format('YYYY-MM-DD'),
        carry_forward: values?.carry_forward ? 1 : 0,
      });
    };

    return (
      <Modal
        title={edit ? t.EditLeavePolicy : t.AddLeavePolicy}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
        }}
        footer={null}
        width={600}
      >
        <Form
          form={form}
          name="add-unit-measure"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
          initialValues={{
            leave_policy_details: [{}],
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '40vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Row gutter={[10, 10]}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="employee"
                  label={t.Employee}
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder={t.Employee}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    // filterOption={(input, option) =>
                    //   (option?.label ?? '').toLocaleLowerCase().includes(input)
                    // }
                    onChange={(value, option) => {
                      console.log(option, 'option');
                      form.setFieldsValue({
                        employee_name: option?.option?.description,
                        // department: option?.option?.department,
                      });
                    }}
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? '')
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                    // options={employee?.data?.map((user) => ({
                    //   value: user.name,
                    //   label: user.name,
                    //   option: user,
                    // }))}
                    onSearch={(value) => setSearchTextItems(value)}
                    options={employeeList?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                      option: user,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="employee_name"
                  label={t.employeeName}
                  rules={[{ required: true }]}
                >
                  <Input placeholder={t.employeeName} disabled />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="leave_policy"
                  label={t.leavePolicy}
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder={t.leavePolicy}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    // options={LeavePolicy?.message?.map((user) => ({
                    //   value: user.value,
                    //   label: user.value,
                    // }))}
                    onSearch={(value) => setSearchText(value)}
                    options={leavePolicy?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                      option: user,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="effective_from"
                  label={t.effectiveFrom}
                  rules={[{ required: true }]}
                  initialValue={dayjs()}
                >
                  <DatePicker
                    placeholder={t.effectiveFrom}
                    format="YYYY-MM-DD"
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="effective_to"
                  label={t.effectiveTo}
                  rules={[{ required: true }]}
                  initialValue={dayjs().add(1, 'year')}
                >
                  <DatePicker
                    placeholder={t.effectiveTo}
                    format="YYYY-MM-DD"
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="leaves_allocated"
                  label={t.leavesAllocated}
                  hidden={!edit}
                >
                  <Input placeholder={t.leavesAllocated} disabled />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="carry_forward" valuePropName="checked">
                  <Checkbox>{t.carryForward}</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
              }}
            >
              {t.cancel}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (submitButton) {
                  setLoadingAdd(true);
                  handleSubmit.mutate(selectName);
                } else {
                  form.submit();
                }
              }}
              loading={loadingAdd}
            >
              {/* {edit ? t.edit : t.submit} */}
              {submitButton ? t.submit : edit ? t.edit : t.Save}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);

export const ModalAddHolidayList = memo(
  ({ t, open, setOpen, editId, edit, setEdit }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);

    const { mutate: onAddHoliday } = useMutation({
      mutationKey: ['addHolidayList'],
      mutationFn: (body) =>
        edit ? updateHolidayList(body, editId) : addHolidayList(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getHolidayList] });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        // message.error(error.response.data._server_messages);
        const serverMessages = JSON.parse(error.response.data._server_messages);
        const messageData = JSON.parse(serverMessages[0]);
        const title = messageData.title || 'Error';
        const messageContent = messageData.message || 'An error occurred';
        message.error({
          content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
          duration: 5,
        });
        console.log('error:', error);
      },
    });
    const {
      data: holidayListDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getHolidayList, editId],
      queryFn: () => getHolidayListDetails(editId),
      enabled: !!edit && !!editId,
    });
    useEffect(() => {
      if (edit) {
        refetch();
      }
    }, [edit, refetch]);

    useEffect(() => {
      if (edit && holidayListDetails) {
        form.setFieldsValue({
          ...holidayListDetails?.data,
          from_date: dayjs(holidayListDetails?.data?.from_date),
          to_date: dayjs(holidayListDetails?.data?.to_date),
          holidays: holidayListDetails?.data?.holidays?.length
            ? holidayListDetails?.data?.holidays?.map((holiday) => ({
                ...holiday,
                holiday_date: dayjs(holiday?.holiday_date),
              }))
            : [{}],
        });
      } else {
        form.resetFields();
      }
    }, [edit, holidayListDetails, form]);
    const onFinish = (values) => {
      setLoadingAdd(true);
      onAddHoliday({
        ...values,
        from_date: dayjs(values?.from_date).format('YYYY-MM-DD'),
        to_date: dayjs(values?.to_date).format('YYYY-MM-DD'),
        holidays: values?.holidays?.map((holiday) => ({
          ...holiday,
          holiday_date: dayjs(holiday?.holiday_date).format('YYYY-MM-DD'),
        })),
      });
    };

    return (
      <Modal
        title={edit ? t.EditHoliday : t.AddHoliday}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
        }}
        footer={null}
        width={600}
      >
        <Form
          form={form}
          name="add-unit-measure"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
          initialValues={{
            holidays: [{}],
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '40vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="holiday_list_name"
                    label={t.holidayListName}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.holidayListName} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="from_date"
                    label={t.fromDate}
                    rules={[{ required: true }]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      placeholder={t.fromDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="to_date"
                    label={t.ToDate}
                    rules={[{ required: true }]}
                    initialValue={dayjs().add(1, 'year')}
                  >
                    <DatePicker
                      placeholder={t.ToDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.List name="holidays" style={{ width: '100%' }}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <>
                            <Flex
                              key={key}
                              justify="space-between"
                              align="center"
                              gap="5px"
                              style={{
                                width: '100%',
                              }}
                            >
                              <Form.Item
                                name={[name, 'holiday_date']}
                                label={t.holidayDate}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                                initialValue={dayjs()}
                              >
                                <DatePicker
                                  format="DD-MM-YYYY"
                                  style={{ width: '100%' }}
                                  placeholder={t.holidayDate}
                                />
                              </Form.Item>
                              <Form.Item
                                name={[name, 'weekly_off']}
                                label={t.weeklyOff}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                              >
                                <Input
                                  placeholder={t.weeklyOff}
                                  type="number"
                                />
                              </Form.Item>
                              <Form.Item
                                name={[name, 'description']}
                                label={t.description}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                              >
                                <Input placeholder={t.description} />
                              </Form.Item>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  fontSize: '15px',
                                  margin: '0 10px',
                                }}
                              >
                                {fields.length > 1 && (
                                  <Button
                                    type="text"
                                    onClick={() => remove(name)}
                                    danger
                                    icon={<MdDelete color="red" />}
                                  />
                                )}
                                <Button
                                  type="text"
                                  onClick={() => add()}
                                  icon={<PlusOutlined color="#1890ff" />}
                                />
                              </div>
                            </Flex>
                          </>
                        ))}
                      </>
                    )}
                  </Form.List>
                </Col>
              </Row>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
              }}
            >
              {t.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalAddExpenseClaim = memo(
  ({ t, open, setOpen, editId, edit, setEdit }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const { companyName } = useSelector((state) => state.user);
    const [loadingAdd, setLoadingAdd] = useState(false);

    const { mutate: onAddExpenseClaim } = useMutation({
      mutationKey: ['addExpenseClaim'],
      mutationFn: (body) =>
        edit ? updateExpenseClaim(body, editId) : addExpenseClaim(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getExpenseClaim] });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        const serverMessages = JSON.parse(error.response.data._server_messages);
        const messageData = JSON.parse(serverMessages[0]);
        const title = messageData.title || 'Error';
        const messageContent = messageData.message || 'An error occurred';
        message.error({
          content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
          duration: 5,
        });
        console.log('error:', error);
      },
    });
    const {
      data: expenseClaimDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getExpenseClaim, editId],
      queryFn: () => getExpenseClaimDetails(editId),
      enabled: !!edit && !!editId,
    });
    useEffect(() => {
      if (edit) {
        refetch();
      }
    }, [edit, refetch]);
    const { data: accounts } = useQuery({
      queryKey: [queryKeys.getSearchApiAccount],
      queryFn: () => getSearchApi('Account'),
      keepPreviousData: true,
    });
    useEffect(() => {
      if (edit && expenseClaimDetails) {
        form.setFieldsValue({
          ...expenseClaimDetails?.data,
          accounts: expenseClaimDetails?.data?.accounts?.length
            ? expenseClaimDetails?.data?.accounts
            : [{}],
        });
      } else {
        form.resetFields();
      }
    }, [edit, expenseClaimDetails, form]);
    const onFinish = (values) => {
      setLoadingAdd(true);
      onAddExpenseClaim({
        ...values,
      });
    };

    return (
      <Modal
        title={edit ? t.EditExpenseClaim : t.addExpenseClaim}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
        }}
        footer={null}
        width={600}
      >
        <Form
          form={form}
          name="add-expense-claim-form"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
          initialValues={{
            accounts: [{}],
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '40vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Row gutter={[16, 0]}>
                <Col span={24}>
                  <Form.Item
                    name="expense_type"
                    label={t.expenseType}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.expenseType} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.List name="accounts" style={{ width: '100%' }}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <>
                            <Flex
                              key={key}
                              justify="space-between"
                              align="center"
                              gap="5px"
                              style={{
                                width: '100%',
                              }}
                            >
                              {/* <Form.Item
                                name={[name, 'company']}
                                label={t.company}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                                initialValue={companyName}
                              >
                                <Input placeholder={t.company} disabled />
                              </Form.Item> */}
                              <Form.Item
                                name={[name, 'default_account']}
                                label={t.DefaultAccount}
                                // rules={[
                                //   {
                                //     required: true,
                                //   },
                                // ]}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                              >
                                <Select
                                  placeholder={t.DefaultAccount}
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.label ?? '')
                                      .toLocaleLowerCase()
                                      .includes(input)
                                  }
                                  filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '')
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? '').toLowerCase()
                                      )
                                  }
                                  options={accounts?.message?.map((item) => ({
                                    value: item?.value,
                                    label: item?.value,
                                  }))}
                                />
                              </Form.Item>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  fontSize: '15px',
                                  margin: '0 10px',
                                }}
                              >
                                {fields.length > 1 && (
                                  <Button
                                    type="text"
                                    onClick={() => remove(name)}
                                    danger
                                    icon={<MdDelete color="red" />}
                                  />
                                )}
                                <Button
                                  type="text"
                                  onClick={() => add()}
                                  icon={<PlusOutlined color="#1890ff" />}
                                />
                              </div>
                            </Flex>
                          </>
                        ))}
                      </>
                    )}
                  </Form.List>
                </Col>
              </Row>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
              }}
            >
              {t.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalAddDesignationHr = memo(
  ({ t, open, setOpen, editId, edit, setEdit }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);

    const { mutate: onAddDesignationHr } = useMutation({
      mutationKey: ['addDesignationHr'],
      mutationFn: (body) =>
        edit ? updateDesignationHr(body, editId) : addDesignationHr(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getDesignationHr] });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        const serverMessages = JSON.parse(error.response.data._server_messages);
        const messageData = JSON.parse(serverMessages[0]);
        const title = messageData.title || 'Error';
        const messageContent = messageData.message || 'An error occurred';
        message.error({
          content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
          duration: 5,
        });
        console.log('error:', error);
      },
    });
    const {
      data: designationHrDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getDesignationHr, editId],
      queryFn: () => getDesignationHrDetails(editId),
      enabled: !!edit && !!editId,
    });
    useEffect(() => {
      if (edit) {
        refetch();
      }
    }, [edit, refetch]);
    useEffect(() => {
      if (edit && designationHrDetails) {
        form.setFieldsValue({
          ...designationHrDetails?.data,
        });
      } else {
        form.resetFields();
      }
    }, [edit, designationHrDetails, form]);
    const onFinish = (values) => {
      setLoadingAdd(true);
      onAddDesignationHr({
        ...values,
      });
    };

    return (
      <Modal
        title={edit ? t.EditDesignation : t.addDesignation}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
        }}
        footer={null}
        width={600}
      >
        <Form
          form={form}
          name="add-expense-claim-form"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '40vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Row gutter={[16, 0]}>
                <Col span={24}>
                  <Form.Item
                    name="designation_name"
                    label={t.designation}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.designation} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="description" label={t.description}>
                    <Input.TextArea rows={4} placeholder={t.description} />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
              }}
            >
              {t.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalAddBranch = memo(
  ({ t, open, setOpen, editId, edit, setEdit }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [searchTxtAddress, setSearchTxtAddress] = useState('');
    const { companyName } = useSelector((state) => state.user);
    const { mutate: onAddBranch } = useMutation({
      mutationKey: ['addBranchHr'],
      mutationFn: (body) =>
        edit ? updateBranchHr(body, editId) : addBranchHr(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getBranchHr] });
        form.resetFields();
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        const serverMessages = JSON.parse(error.response.data._server_messages);
        const messageData = JSON.parse(serverMessages[0]);
        const title = messageData.title || 'Error';
        const messageContent = messageData.message || 'An error occurred';
        message.error({
          content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
          duration: 5,
        });
        console.log('error:', error);
      },
    });
    const { data: addressList, isLoading: isLoadingAddress } = useQuery({
      queryKey: [queryKeys.getSearchAddress, searchTxtAddress],
      queryFn: () => getSearchPatients('Address', searchTxtAddress),
      enabled: searchTxtAddress?.length >= 2 || searchTxtAddress?.length === 0,
      keepPreviousData: true,
    });
    const {
      data: branchDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getBranchHr, editId],
      queryFn: () => getBranchHrDetails(editId),
      enabled: !!edit && !!editId,
    });
    useEffect(() => {
      if (edit) {
        refetch();
      }
    }, [edit, refetch]);
    useEffect(() => {
      if (edit && branchDetails) {
        form.setFieldsValue({
          ...branchDetails?.data,
        });
      } else {
        form.resetFields();
      }
    }, [edit, branchDetails, form]);
    const onFinish = (values) => {
      setLoadingAdd(true);
      onAddBranch({
        ...values,
        company: companyName,
      });
    };

    return (
      <Modal
        title={edit ? t.EditBranch : t.addBranch}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
        }}
        footer={null}
        width={600}
      >
        <Form
          form={form}
          name="add-branch-form"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
          initialValues={{
            custom_branch_ids: [
              {
                type_name: 'Commercial Registration Number',
                type_code: 'CRN',
              },
            ],
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '40vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Row gutter={[16, 0]}>
                <Col span={24}>
                  <Form.Item
                    name="branch"
                    label={t.Branch}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.Branch} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="custom_company_address"
                    label={t.company_address}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.company_address}
                      showSearch
                      popupMatchSelectWidth={false}
                      onSearch={(value) => {
                        setSearchTxtAddress(value);
                      }}
                      filterOption={false}
                      loading={isLoadingAddress}
                    >
                      {addressList?.message?.map((item) => (
                        <Select.Option key={item?.value} value={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.List name="custom_branch_ids" style={{ width: '100%' }}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <>
                            <Flex
                              key={key}
                              justify="space-between"
                              align="center"
                              gap="5px"
                              style={{
                                width: '100%',
                              }}
                            >
                              <Form.Item
                                name={[name, 'type_name']}
                                label={t.typeName}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                                rules={[
                                  {
                                    required: true,
                                  },
                                ]}
                              >
                                <Input placeholder={t.typeName} disabled />
                              </Form.Item>
                              <Form.Item
                                name={[name, 'type_code']}
                                label={t.typeCode}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                                rules={[
                                  {
                                    required: true,
                                  },
                                ]}
                              >
                                <Input placeholder={t.typeCode} disabled />
                              </Form.Item>
                              <Form.Item
                                name={[name, 'value']}
                                label={t.value}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                                rules={[
                                  {
                                    required: true,
                                  },
                                ]}
                              >
                                <Input
                                  type="number"
                                  min={0}
                                  placeholder={t.value}
                                />
                              </Form.Item>
                              {/* <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  fontSize: '15px',
                                  margin: '0 10px',
                                }}
                              >
                                {fields.length > 1 && (
                                  <Button
                                    type="text"
                                    onClick={() => remove(name)}
                                    danger
                                    icon={<MdDelete color="red" />}
                                  />
                                )}
                                <Button
                                  type="text"
                                  onClick={() => add()}
                                  icon={<PlusOutlined color="#1890ff" />}
                                />
                              </div> */}
                            </Flex>
                          </>
                        ))}
                      </>
                    )}
                  </Form.List>
                </Col>
              </Row>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
              }}
            >
              {t.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalAppPdfData = memo(
  ({
    t,
    open,
    setOpen,
    pdfData,
    nameInvoice,
    onGetPDF,
    type,
    setLoadingPdf,
    loadingPdf,
  }) => {
    const [imageUrl, setImageUrl] = useState(null);
    const { currentLang } = useSelector((state) => state.user);
    const [selectLang, setSelectLang] = useState(currentLang);
    const [selectFormat, setSelectFormat] = useState();
    // const [loadingPdf, setLoadingPdf] = useState(false);
    const languages = [
      {
        key: 'en',
        label: 'English',
        icon: '🇬🇧',
      },
      {
        key: 'ar',
        label: 'العربية',
        icon: '🇸🇦',
      },
    ];
    const languageMenu = (
      <Menu
        selectable
        selectedKeys={[currentLang]}
        defaultValue={currentLang}
        // defaultValue={currentLang}
        onSelect={({ key }) => {
          setSelectLang(key);
          setLoadingPdf(true);
          onGetPDF({
            type: type,
            name: nameInvoice,
            lang: key,
            format: selectFormat || '',
          });
        }}
      >
        {languages?.map((lang) => (
          <Menu.Item key={lang?.key}>
            <Space>
              <span style={{ fontSize: '16px' }}>{lang.icon}</span>
              <span>{lang.label}</span>
              {selectLang === lang.key && (
                <CheckOutlined style={{ color: '#079661' }} />
              )}
            </Space>
          </Menu.Item>
        ))}
      </Menu>
    );
    const { data: printFormat, isLoading: isLoadingPrintFormat } = useQuery({
      queryKey: [queryKeys.getPrintFormat],
      queryFn: () => getPrintFormat(type),
      keepPreviousData: true,
    });
    // console.log(imageUrl,"imageUrlimageUrl");
    const pdfBlobRef = useRef(null);
    const { message } = App.useApp();
    useEffect(() => {
      const renderPdf = async () => {
        if (pdfData?.data) {
          setLoadingPdf(false);
          try {
            const url = URL.createObjectURL(pdfData?.data);
            pdfBlobRef.current = url;
            setImageUrl(url);
          } catch (error) {
            setImageUrl(null);
            setLoadingPdf(false);
            message.error('Error rendering PDF.');
          }
        }
      };
      renderPdf();
    }, [pdfData]);
    const downloadPDF = () => {
      if (pdfData) {
        const blob = new Blob([pdfData.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `invoice(${nameInvoice}).pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setImageUrl(null);
        setLoadingPdf(false);
        setOpen(false);
      }
    };

    return (
      <Modal
        title={
          <div className="flex items-center gap-3">
            {t.downloadPdf}
            {/* <Dropdown
              overlay={languageMenu}
              trigger={['click']}
              placement="bottomRight"
            >
              <Space className="language-selector cursor-pointer ">
                <MdLanguage className="icon-style" />
                <span className="language-code">
                  {selectLang?.toUpperCase() || 'EN'}
                </span>
              </Space>
            </Dropdown> */}
            <Select
              // style={{ width: 250 }}
              popupMatchSelectWidth={false}
              placeholder={t.selectLanguage}
              loading={false}
              value={selectLang}
              onChange={(value) => {
                setSelectLang(value);
                setLoadingPdf(true);
                onGetPDF({
                  type: type,
                  name: nameInvoice,
                  lang: value,
                  format: selectFormat || '',
                });
              }}
              options={languages?.map((item) => ({
                value: item?.key,
                label: (
                  <Space>
                    <span style={{ fontSize: '16px' }}>{item?.icon}</span>
                    <span>{item?.label}</span>
                  </Space>
                ),
              }))}
            />
            <Select
              allowClear
              style={{ width: 250 }}
              placeholder={t.selectTypeFormat}
              loading={isLoadingPrintFormat}
              onChange={(value) => {
                setSelectFormat(value);
                setLoadingPdf(true);
                onGetPDF({
                  type: type,
                  name: nameInvoice,
                  lang: selectLang,
                  format: value,
                });
              }}
              options={printFormat?.data?.map((item) => ({
                value: item?.name,
                label: item?.name,
              }))}
            />
          </div>
        }
        open={open}
        centered
        onCancel={() => {
          setImageUrl(null);
          setOpen(false);
          setLoadingPdf(false);
        }}
        footer={null}
        width={700}
      >
        {loadingPdf ? (
          <div className="flex items-center justify-center h-[40vh]">
            <Spin size="large" />
          </div>
        ) : (
          <>
            <div style={{ textAlign: 'center' }}>
              {imageUrl ? (
                <>
                  <iframe
                    src={imageUrl}
                    width="100%"
                    height="550px"
                    title="PDF Preview"
                    style={{ border: 'none' }}
                  ></iframe>
                </>
              ) : (
                <div
                  style={{
                    width: '100%',
                    height: '40vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Spin size="large" />
                </div>
              )}
            </div>
            <div className="form-btns">
              <Button
                type="primary"
                ghost
                onClick={() => {
                  setOpen(false);
                  setImageUrl(null);
                  setLoadingPdf(false);
                }}
              >
                {t.cancel}
              </Button>
              <Button type="primary" onClick={downloadPDF}>
                {t.download}
              </Button>
            </div>
          </>
        )}
      </Modal>
    );
  }
);

export const ModalAddBankTransfer = memo(
  ({ t, open, setOpen, editId, edit, setEdit }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [searchTxt, setSearchTxt] = useState('');
    const [loadingAdd, setLoadingAdd] = useState(false);

    const { mutate: onAddBankTransfer } = useMutation({
      mutationKey: ['addBankTransfer'],
      mutationFn: ({ ac, pe }) => addBankTransfer({ ac, pe }),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({
          queryKey: [queryKeys.getPaymentEntries, editId],
        });
        setOpen(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        const serverMessages = JSON.parse(error.response.data._server_messages);
        const messageData = JSON.parse(serverMessages[0]);
        const title = messageData.title || 'Error';
        const messageContent = messageData.message || 'An error occurred';
        message.error({
          content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
          duration: 5,
        });
        console.log('error:', error);
      },
    });
    const { data: account } = useQuery({
      queryKey: [queryKeys.getSearchApiAccount, searchTxt],
      queryFn: () =>
        getSearchApiSearchText({ type: 'Bank Account', searchTxt: searchTxt }),
      enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
      keepPreviousData: true,
    });
    const onFinish = (values) => {
      setLoadingAdd(true);
      onAddBankTransfer({ ac: values.ac, pe: editId });
    };
    useEffect(() => {
      if (editId) {
        form.setFieldsValue({
          name: editId,
        });
      }
    }, [editId, form]);
    return (
      <Modal
        title={t.addBankTransfer}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          // setEdit(false);
        }}
        footer={null}
        // width={600}
      >
        <Form
          form={form}
          name="add-bank-transfer-form"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          <Form.Item
            name="name"
            label={t.Name}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input placeholder={t.Name} disabled />
          </Form.Item>
          <Form.Item
            name="ac"
            label={t.Account}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              placeholder={t.Account}
              style={{ width: '100%' }}
              onSearch={(value) => {
                setSearchTxt(value);
              }}
              showSearch
              filterOption={false}
              allowClear
              onClear={() => {
                setSearchTxt('');
              }}
              onChange={() => {
                setSearchTxt('');
              }}
              options={account?.message?.map((item) => ({
                value: item?.value,
                label: item?.value,
              }))}
            />
          </Form.Item>
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
              }}
            >
              {t.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalAddAmount = memo(
  ({ t, open, setOpen, id, setTotalValue, totalValue }) => {
    const navigate = useNavigate();
    const [form] = Form.useForm();

    const onFinish = ({ amount }) => {
      navigate(`/sales-order/sales-invoice/${id}/${amount}`);
    };
    return (
      <Modal
        title={t.CreateDownPaymentInvoice}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          // setEdit(false);
        }}
        footer={null}
        // width={600}
      >
        <Form
          form={form}
          name="add-bank-transfer-form"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          <Form.Item
            name="amount"
            label={t.amount}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input placeholder={t.amount} type="number" max={totalValue} />
          </Form.Item>
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
              }}
            >
              {t.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={false}>
              {t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);

export const ModalAppItemDetailsSalesInvoice = memo(
  ({ t, open, setOpen, dataSource, selectedIndex, setDataSource }) => {
    // console.log(dataSource, 'dataSource');
    const [selectData, setSelectData] = useState(null);
    console.log(selectData, 'selectData');

    const [searchTextIncomeAccount, setSearchTextIncomeAccount] = useState('');
    const [searchText, setSearchText] = useState('');
    const [searchTextCostCenter, setSearchTextCostCenter] = useState('');
    const [searchTextUOM, setSearchTextUOM] = useState('');
    const { data: Warehouse } = useQuery({
      queryKey: [queryKeys.getSearchWarehouse, searchText],
      queryFn: () => getSearchPatients('Warehouse', searchText),
      keepPreviousData: true,
      enabled: searchText?.length >= 3 || searchText?.length === 0,
    });
    const { data: uom } = useQuery({
      queryKey: [queryKeys.getSearchuom, searchTextUOM],
      queryFn: () => getSearchPatients('UOM', searchTextUOM),
      keepPreviousData: true,
      enabled: searchTextUOM?.length >= 3 || searchTextUOM?.length === 0,
    });
    const { data: costCenter } = useQuery({
      queryKey: [queryKeys.getSearchCostCenter, searchTextCostCenter],
      queryFn: () => getSearchPatients('Cost Center', searchTextUOM),
      keepPreviousData: true,
      enabled:
        searchTextCostCenter?.length >= 3 || searchTextCostCenter?.length === 0,
    });
    const { data: incomeAccount } = useQuery({
      queryKey: [queryKeys.getSearchIncomeAccount, searchTextIncomeAccount],
      queryFn: () => getSearchPatients('Account', searchTextIncomeAccount),
      keepPreviousData: true,
      enabled:
        searchTextIncomeAccount?.length >= 3 ||
        searchTextIncomeAccount?.length === 0,
    });
    useEffect(() => {
      if (open && dataSource) {
        setSelectData(dataSource[selectedIndex]);
      } else {
        setSelectData(null);
      }
    }, [dataSource, selectedIndex, open, selectData]);
    return (
      <Modal
        title={t.itemDetails}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
        }}
        footer={null}
        width={900}
      >
        <>
          <Descriptions column={2} bordered style={{ marginTop: '20px' }}>
            <Descriptions.Item label={t.itemCode}>
              {' '}
              {selectData?.item_code}
            </Descriptions.Item>
            <Descriptions.Item label={t.itemName}>
              {' '}
              {selectData?.item_name}{' '}
            </Descriptions.Item>
            <Descriptions.Item label={t.itemGroup}>
              {' '}
              {selectData?.item_group}{' '}
            </Descriptions.Item>
            <Descriptions.Item label={t.description}>
              {' '}
              {selectData?.description}{' '}
            </Descriptions.Item>
            <Descriptions.Item label={t.warehouse}>
              <Select
                placeholder={t.warehouse}
                style={{ width: '100%' }}
                showSearch
                optionFilterProp="children"
                filterOption={false}
                popupMatchSelectWidth={false}
                value={selectData?.warehouse}
                onSearch={(value) => setSearchText(value)}
                onChange={(value) => {
                  const newDataSource = [...dataSource];
                  newDataSource[selectedIndex] = {
                    ...newDataSource[selectedIndex],
                    warehouse: value,
                  };
                  setDataSource(newDataSource);
                }}
                options={Warehouse?.message?.map((user) => ({
                  value: user.value,
                  label: user.value,
                }))}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t.expenseAccount}>
              <Select
                placeholder={t.expenseAccount}
                style={{ width: '100%' }}
                showSearch
                optionFilterProp="children"
                filterOption={false}
                popupMatchSelectWidth={false}
                value={selectData?.expense_account}
                onSearch={(value) => setSearchTextIncomeAccount(value)}
                onChange={(value) => {
                  const newDataSource = [...dataSource];
                  newDataSource[selectedIndex] = {
                    ...newDataSource[selectedIndex],
                    expense_account: value,
                  };
                  setDataSource(newDataSource);
                  setSearchTextIncomeAccount('');
                }}
                options={incomeAccount?.message?.map((user) => ({
                  value: user.value,
                  label: user.value,
                }))}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t.costCenter}>
              <Select
                placeholder={t.costCenter}
                style={{ width: '100%' }}
                showSearch
                optionFilterProp="children"
                filterOption={false}
                popupMatchSelectWidth={false}
                value={selectData?.cost_center}
                onSearch={(value) => setSearchTextCostCenter(value)}
                onChange={(value) => {
                  const newDataSource = [...dataSource];
                  newDataSource[selectedIndex] = {
                    ...newDataSource[selectedIndex],
                    cost_center: value,
                  };
                  setDataSource(newDataSource);
                }}
                options={costCenter?.message?.map((user) => ({
                  value: user.value,
                  label: user.value,
                }))}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t.incomeAccount}>
              <Select
                placeholder={t.incomeAccount}
                style={{ width: '100%' }}
                showSearch
                optionFilterProp="children"
                filterOption={false}
                popupMatchSelectWidth={false}
                value={selectData?.income_account}
                onSearch={(value) => setSearchTextIncomeAccount(value)}
                onChange={(value) => {
                  const newDataSource = [...dataSource];
                  newDataSource[selectedIndex] = {
                    ...newDataSource[selectedIndex],
                    income_account: value,
                  };
                  setDataSource(newDataSource);
                  setSearchTextIncomeAccount('');
                }}
                options={incomeAccount?.message?.map((user) => ({
                  value: user.value,
                  label: user.value,
                }))}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t.enableDeferredRevenue}>
              {' '}
              {/* {selectData?.enable_deferred_revenue}{' '} */}
              <Checkbox
                defaultChecked={selectData?.enable_deferred_revenue}
                onChange={(e) => {
                  const newDataSource = [...dataSource];
                  newDataSource[selectedIndex] = {
                    ...newDataSource[selectedIndex],
                    enable_deferred_revenue: e.target.checked,
                  };
                  setDataSource(newDataSource);
                }}
              />
            </Descriptions.Item>
            {selectData?.enable_deferred_revenue ? (
              <>
                <Descriptions.Item label={t.deferredRevenueAccount}>
                  <Select
                    placeholder={t.deferredRevenueAccount}
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={false}
                    popupMatchSelectWidth={false}
                    value={selectData?.deferred_revenue_account}
                    onSearch={(value) => setSearchTextIncomeAccount(value)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        deferred_revenue_account: value,
                      };
                      setDataSource(newDataSource);
                      setSearchTextIncomeAccount('');
                    }}
                    options={incomeAccount?.message?.map((user) => ({
                      value: user.value,
                      label: user.value,
                    }))}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.serviceStartDate}>
                  {/* service_start_date */}
                  <DatePicker
                    placeholder={t.serviceStartDate}
                    style={{ width: '100%' }}
                    value={dayjs(selectData?.service_start_date)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        service_start_date: dayjs(value).format('YYYY-MM-DD'),
                      };
                      setDataSource(newDataSource);
                    }}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={t.serviceEndDate}>
                  {/* service_end_date */}
                  <DatePicker
                    placeholder={t.serviceEndDate}
                    style={{ width: '100%' }}
                    value={dayjs(selectData?.service_end_date)}
                    onChange={(value) => {
                      const newDataSource = [...dataSource];
                      newDataSource[selectedIndex] = {
                        ...newDataSource[selectedIndex],
                        service_end_date: dayjs(value).format('YYYY-MM-DD'),
                      };
                      setDataSource(newDataSource);
                    }}
                  />
                </Descriptions.Item>
              </>
            ) : null}
            <Descriptions.Item label={t.conversionFactor}>
              {' '}
              {selectData?.conversion_factor}{' '}
            </Descriptions.Item>
            <Descriptions.Item label={t.quantity}>
              {' '}
              {selectData?.qty}{' '}
            </Descriptions.Item>
            <Descriptions.Item label={t.uom}>
              {' '}
              {/* {selectData?.uom}{' '} */}
              <Select
                placeholder={t.uom}
                style={{ width: '100%' }}
                showSearch
                optionFilterProp="children"
                filterOption={false}
                popupMatchSelectWidth={false}
                value={selectData?.uom}
                onSearch={(value) => setSearchTextUOM(value)}
                onChange={(value) => {
                  const newDataSource = [...dataSource];
                  newDataSource[selectedIndex] = {
                    ...newDataSource[selectedIndex],
                    uom: value,
                  };
                  setDataSource(newDataSource);
                }}
                options={uom?.message?.map((user) => ({
                  value: user.value,
                  label: user.value,
                }))}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t.rate}>
              {' '}
              {selectData?.rate}{' '}
            </Descriptions.Item>
            <Descriptions.Item label={t.amount}>
              {' '}
              {selectData?.amount}{' '}
            </Descriptions.Item>
            <Descriptions.Item label={t.stockQty}>
              {' '}
              {selectData?.stock_qty}{' '}
            </Descriptions.Item>
            <Descriptions.Item label={t.actualQty}>
              {' '}
              {selectData?.actual_qty}{' '}
            </Descriptions.Item>
          </Descriptions>
        </>
      </Modal>
    );
  }
);

export const ModalAppStatementOfAccount = memo(
  ({ t, edit, record, open, setOpen, setEditId, setEdit }) => {
    const [form] = Form.useForm();
    const client = useQueryClient();
    const { message } = App.useApp();
    const [searchtextCustomer, setSearchtextCustomer] = useState('');
    const [loadingAdd, setLoadingAdd] = useState(false);
    // console.log('render modal');
    const { mutate: onAddStatementOfAccount } = useMutation({
      mutationKey: ['addStatementOfAccount'],
      mutationFn: (body) =>
        edit
          ? updateStatementOfAccount(body, record)
          : addStatementOfAccount(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        // console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({
          queryKey: [queryKeys.getStatementOfAccount],
        });
        form.resetFields();
        setOpen(false);
        setEditId(null);
        setEdit(false);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
        // message.error(error);
      },
    });
    const { data: customer } = useQuery({
      queryKey: [queryKeys.getSearchApiAccountList, searchtextCustomer],
      queryFn: () =>
        getSearchApiSearchText({
          type: 'Customer',
          searchTxt: searchtextCustomer,
        }),
      keepPreviousData: true,

      enabled:
        searchtextCustomer?.length >= 3 || searchtextCustomer?.length === 0,
    });
    const { data: fiscalDetails, isLoading: loadingDetailsFiscal } = useQuery({
      queryKey: [queryKeys.getStatementOfAccount, record],
      queryFn: () => getStatementOfAccountById(record),
      keepPreviousData: true,
      enabled: !!edit && !!record,
    });
    useEffect(() => {
      if (fiscalDetails?.data) {
        form.setFieldsValue({
          ...fiscalDetails?.data,
          from_date: dayjs(fiscalDetails?.data?.from_date),
          to_date: dayjs(fiscalDetails?.data?.to_date),
        });
      }
    }, [fiscalDetails, form]);
    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddStatementOfAccount({
        ...values,
        from_date: dayjs(values.from_date).format('YYYY-MM-DD'),
        to_date: dayjs(values.to_date).format('YYYY-MM-DD'),
        customers: values?.customers[0]?.customer ? values?.customers : [],
        show_remarks: values?.show_remarks ? 1 : 0,
      });
    };

    return (
      <Modal
        title={edit ? t.EditStatementOfAccount : t.addStatementOfAccount}
        open={open}
        onCancel={() => {
          setOpen(false);
          setEditId(null);
          setEdit(false);
          // form.resetFields();
        }}
        footer={null}
      >
        {loadingDetailsFiscal ? (
          <div className="h-[400px] flex justify-center items-center">
            <Spin size="large" />
          </div>
        ) : (
          <Form
            form={form}
            name="addGeneralLedger"
            layout="vertical"
            onFinish={onFinish}
            style={{
              marginTop: '25px',
            }}
            initialValues={{
              customers: [{}],
            }}
          >
            <Form.Item
              name="name"
              label={t.Name}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder={t.Name} />
            </Form.Item>
            <Form.Item
              name="from_date"
              label={t.fromDate}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                placeholder={t.fromDate}
                format="YYYY-MM-DD"
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item
              name="to_date"
              label={t.ToDate}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                placeholder={t.ToDate}
                format="YYYY-MM-DD"
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item name="show_remarks" valuePropName="checked">
              <Checkbox>{t.showRemarks}</Checkbox>
            </Form.Item>
            <Form.List name="customers" style={{ width: '100%' }}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <>
                      <Flex
                        key={key}
                        justify="space-between"
                        align="center"
                        gap="5px"
                        style={{
                          width: '100%',
                        }}
                      >
                        <Form.Item
                          name={[name, 'customer']}
                          label={t.Customer}
                          style={{
                            width: '100%',
                            marginBottom: '0px',
                          }}
                          {...restField}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <Select
                            placeholder={t.Customer}
                            style={{ width: '100%' }}
                            showSearch
                            filterOption={false}
                            popupMatchSelectWidth={false}
                            options={customer?.message?.map((item) => ({
                              value: item?.value,
                              label: item?.value,
                            }))}
                            onSearch={(value) => setSearchtextCustomer(value)}
                          />
                        </Form.Item>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '15px',
                            margin: '0 10px',
                          }}
                        >
                          {fields.length > 1 && (
                            <Button
                              type="text"
                              onClick={() => remove(name)}
                              danger
                              icon={<MdDelete color="red" />}
                            />
                          )}
                          <Button
                            type="text"
                            onClick={() => add()}
                            icon={<PlusOutlined color="#1890ff" />}
                          />
                        </div>
                      </Flex>
                    </>
                  ))}
                </>
              )}
            </Form.List>
            <div className="form-btns">
              <Button
                type="primary"
                ghost
                onClick={() => {
                  setOpen(false);
                  setEdit(false);
                  setEditId(null);
                  form.resetFields();
                }}
              >
                {t.Cancel}
              </Button>
              <Button type="primary" htmlType="submit" loading={loadingAdd}>
                {edit ? t.edit : t.submit}
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    );
  }
);
export const ModalAddItemGroup = memo(
  ({ t, open, setOpen, editId, edit, setEdit, setEditId }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [searchText, setSearchText] = useState('');
    const [loadingAdd, setLoadingAdd] = useState(false);

    const { mutate: onAddUnitMeasure } = useMutation({
      mutationKey: ['addItemGroup'],
      mutationFn: (body) =>
        edit ? updateItemGroup(body, editId) : addItemGroup(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getItemGroup] });
        // form.resetFields();
        setOpen(false);
        setEditId(null);
      },
    });
    const { data: itemGroup } = useQuery({
      queryKey: [queryKeys.getItemGroupSearch],
      queryFn: () =>
        getSearchApiSearchText({ type: 'Item Group', searchTxt: searchText }),
      keepPreviousData: true,
    });
    const {
      data: unitMeasureDetails,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getItemGroup, editId],
      queryFn: () => getItemGroupById(editId),
      enabled: !!edit && !!editId,
    });

    // useEffect(() => {
    //   if (edit) {
    //     refetch();
    //   } else {
    //     form.resetFields();
    //   }
    // }, [edit, refetch]);

    useEffect(() => {
      if (edit && unitMeasureDetails) {
        form.setFieldsValue({
          ...unitMeasureDetails?.data,
        });
      } else {
        form.resetFields();
      }
    }, [edit, unitMeasureDetails, form]);

    const onFinish = (values) => {
      setLoadingAdd(true);
      onAddUnitMeasure({
        ...values,
        is_group: values?.is_group ? 1 : 0,
      });
    };

    return (
      <Modal
        title={edit ? t.editItemGroup : t.addItemGroup}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
          setEdit(false);
          setEditId(null);
        }}
        footer={null}
        // width={600}
      >
        <Form
          form={form}
          name="add-unit-measure"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '40vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <Form.Item
                name="item_group_name"
                label={t.itemGroupName}
                rules={[{ required: true }]}
              >
                <Input placeholder={t.itemGroupName} />
              </Form.Item>
              <Form.Item
                name="custom_item_group_id"
                label={t.customItemGroupId}
                // rules={[{ required: true }]}
              >
                <Input placeholder={t.customItemGroupId} />
              </Form.Item>
              <Form.Item
                name="parent_item_group"
                label={t.parentItemGroup}
                // rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  placeholder={t.itemGroup}
                  optionFilterProp="children"
                  filterOption={false}
                  options={itemGroup?.message?.map((item) => ({
                    value: item?.value,
                    label: item?.value,
                  }))}
                  onSearch={(value) => {
                    setSearchText(value);
                  }}
                />
              </Form.Item>
              <Form.Item
                name="is_group"
                // label={t.isGroup}
                // className="custom_plus_riyal"
                valuePropName="checked"
              >
                <Checkbox>{t.isgroup}</Checkbox>
              </Form.Item>
            </>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
                setEditId(null);
              }}
            >
              {t.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);
export const ModalAppEditUser = memo(({ t, open, setOpen }) => {
  const { data } = useSelector((state) => state.user);
  const client = useQueryClient();
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddUnitMeasure } = useMutation({
    mutationKey: ['addItemGroup'],
    mutationFn: (body) => editUser(body, data?.email),
    onSuccess: (data) => {
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({
        queryKey: [queryKeys.getUserDetails, data?.email],
      });
      // form.resetFields();
      setOpen(false);
    },
  });
  const { data: user, isLoading } = useQuery({
    queryKey: [queryKeys.getUserDetails],
    queryFn: () => getUserDetails(data?.email),
  });
  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        ...user?.data,
      });
    }
  }, [user, form]);
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddUnitMeasure({
      ...values,
    });
  };

  return (
    <Modal
      title="Edit User Information"
      open={open}
      onCancel={() => {
        setOpen(false);
      }}
      footer={null}
    >
      {isLoading ? (
        <div
          style={{
            width: '100%',
            height: '40vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Flex gap={20} className="w-full">
            <Form.Item
              label={t.firstName}
              name="first_name"
              rules={[{ required: true }]}
              className="w-full"
            >
              <Input placeholder={t.firstName} />
            </Form.Item>
            <Form.Item
              label={t.lastName}
              name="last_name"
              // rules={[{ required: true }]}
              className="w-full"
            >
              <Input placeholder={t.lastName} />
            </Form.Item>
          </Flex>
          <Form.Item label="Language" name="language">
            <Select>
              <Select.Option value="en">English</Select.Option>
              <Select.Option value="ar">العربية</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Gender" name="gender">
            <Select>
              <Select.Option value="Male">Male</Select.Option>
              <Select.Option value="Female">Female</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label={t.deskTheme} name="desk_theme">
            <Select>
              <Select.Option value="Light">Light</Select.Option>
              <Select.Option value="Dark">Dark</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label={t.newPassword} name="new_password">
            <Input.Password placeholder={t.newPassword} />
          </Form.Item>
          <Form.Item name="logout_all_sessions" valuePropName="checked">
            <Checkbox>{t.logoutAllSessions}</Checkbox>
          </Form.Item>
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
              }}
            >
              {t.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {t.edit}
            </Button>
          </div>
        </Form>
      )}
    </Modal>
  );
});
export const ModalTodoList = memo(({ t, open, setOpen, editId, doctype }) => {
  const { data } = useSelector((state) => state.user);
  const client = useQueryClient();
  const [searchTxtAccountManager, setSearchTxtAccountManager] = useState('');
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  console.log('render modal');
  const { mutate: onAddWarehouse } = useMutation({
    mutationKey: ['addWarehouse'],
    mutationFn: (body) => addToDo(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({
        queryKey: [queryKeys.getToDo, data?.email],
      });
      form.resetFields();
      setOpen(false);
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
    },
  });
  // const {
  //   data: warehouseDetails,
  //   isLoading,
  //   refetch,
  // } = useQuery({
  //   queryKey: [queryKeys.getToDo, editId],
  //   queryFn: () => getToDoDetails(editId),
  //   enabled: !!edit,
  // });
  const { data: accountManager } = useQuery({
    queryKey: [queryKeys.getSearchAccountManager, searchTxtAccountManager],
    queryFn: () => getSearchPatients('User', searchTxtAccountManager),
    enabled:
      searchTxtAccountManager?.length >= 2 ||
      searchTxtAccountManager?.length === 0,
    keepPreviousData: true,
  });
  // useEffect(() => {
  //   if (edit) {
  //     refetch();
  //   }
  // }, [edit, refetch]);

  // useEffect(() => {
  //   if (edit && warehouseDetails) {
  //     form.setFieldsValue({
  //       ...warehouseDetails?.data,
  //     });
  //   } else {
  //     form.resetFields();
  //   }
  // }, [edit, warehouseDetails, form]);
  const onFinish = (values) => {
    console.log('Success:', values);
    setLoadingAdd(true);
    onAddWarehouse({
      ...values,
      assinged_by: data?.email,
      name: editId,
      doctype: doctype,
    });
  };

  return (
    <Modal
      // title={edit ? t.EditTask : t.AssignTask}
      title={t.EditTask}
      open={open}
      centered
      onCancel={() => {
        setOpen(false);
        // setEdit(false);
      }}
      footer={null}
      width={800}
    >
      <Form
        form={form}
        name="add-supplier"
        layout="vertical"
        onFinish={onFinish}
        style={{
          marginTop: '20px',
        }}
      >
        {false ? (
          <div
            style={{
              width: '100%',
              height: '20vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <>
            <Form.Item
              name="assign_to"
              label={t.AssignTo}
              rules={[{ required: true }]}
            >
              <Select
                showSearch
                placeholder={t.AssignTo}
                filterOption={false}
                onSearch={(value) => setSearchTxtAccountManager(value)}
                mode="multiple"
              >
                {accountManager?.message?.map((item) => (
                  <Select.Option key={item?.value} value={item?.value}>
                    <Flex gap={1} vertical>
                      <span>{item?.value}</span>
                      <span
                        className="item-description"
                        style={{ fontSize: '11px', color: 'gray' }}
                      >
                        {item?.description}
                      </span>
                    </Flex>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="description" label={t.description}>
              <Input.TextArea
                autoSize={{ minRows: 3, maxRows: 5 }}
                placeholder={t.description}
              />
            </Form.Item>
          </>
        )}
        <div className="form-btns">
          <Button
            type="primary"
            ghost
            onClick={() => {
              setOpen(false);
              // setEdit(false);
            }}
          >
            {t.Cancel}
          </Button>
          <Button type="primary" htmlType="submit" loading={loadingAdd}>
            {t.submit}
          </Button>
        </div>
      </Form>
    </Modal>
  );
});
export const ModalTodoListShow = memo(({ t, open, setOpen, editId }) => {
  const {
    data: warehouseDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.getToDo, editId],
    queryFn: () => getToDoDetails(editId),
  });

  return (
    <Modal
      title={t.showTask}
      open={open}
      centered
      onCancel={() => {
        setOpen(false);
      }}
      footer={null}
      width={1000}
    >
      <>
        {isLoading ? (
          <div
            style={{
              width: '100%',
              height: '20vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <>
            <Descriptions
              bordered
              column={{
                xs: 1,
                sm: 2,
                md: 2,
              }}
            >
              <Descriptions.Item label={t.Name}>
                {warehouseDetails?.data.name}
              </Descriptions.Item>
              <Descriptions.Item label={t.owner}>
                {warehouseDetails?.data.owner}
              </Descriptions.Item>
              <Descriptions.Item label={t.CreationDate}>
                {warehouseDetails?.data.creation}
              </Descriptions.Item>
              <Descriptions.Item label={t.LastModified}>
                {dayjs(warehouseDetails).format('YYYY-MM-DD')}
              </Descriptions.Item>
              <Descriptions.Item label={t.modifiedBy}>
                {warehouseDetails?.data.modified_by}
              </Descriptions.Item>
              <Descriptions.Item label={t.status}>
                {warehouseDetails?.data.status}
              </Descriptions.Item>
              <Descriptions.Item label={t.priority}>
                {warehouseDetails?.data.priority}
              </Descriptions.Item>
              <Descriptions.Item label={t.Date}>
                {warehouseDetails?.data.date}
              </Descriptions.Item>
              <Descriptions.Item label={t.AllocatedTo}>
                {warehouseDetails?.data.allocated_to}
              </Descriptions.Item>
              <Descriptions.Item label={t.AssignedByFullName}>
                {warehouseDetails?.data.assigned_by_full_name}
              </Descriptions.Item>
              <Descriptions.Item label={t.AssignedBy}>
                {warehouseDetails?.data.assigned_by}
              </Descriptions.Item>
              <Descriptions.Item label={t.ReferenceType}>
                {warehouseDetails?.data.reference_type}
              </Descriptions.Item>
              <Descriptions.Item label={t.ReferenceName}>
                {warehouseDetails?.data.reference_name}
              </Descriptions.Item>
              <Descriptions.Item label={t.description} span={2}>
                {warehouseDetails?.data.description}
              </Descriptions.Item>
            </Descriptions>
          </>
        )}
      </>
    </Modal>
  );
});

export const ModalAppAddress = memo(
  ({ t, open, setOpen, editId, edit, setEdit, setIdEdit }) => {
    const client = useQueryClient();
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const SupplierId = searchParams.get('Supplier');
    console.log(SupplierId, 'SupplierId');

    const customerId = searchParams.get('customer');
    const WatchLinkDoctype = Form.useWatch('link_doctype', form);
    const { data: dataCustomer, isLoadin: isLoadingCustomer } = useQuery({
      queryKey: [queryKeys.getCustomer],
      queryFn: () =>
        getCustomer({
          key: '',
          value: '',
        }),
      keepPreviousData: true,
    });
    const { data: dataSupplier, isLoading: isLoadingSupplier } = useQuery({
      queryKey: [queryKeys.getSuppliers],
      queryFn: () =>
        getSupplier({
          key: '',
          value: '',
        }),
      keepPreviousData: true,
    });
    // console.log('render modal');
    const { mutate: onAddAddress } = useMutation({
      mutationKey: ['addAddress'],
      mutationFn: (body) =>
        edit ? updateAddress(body, editId) : addAddress(body),
      onSuccess: (data) => {
        setLoadingAdd(false);
        console.log(data?.message, 'datawwww');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(
          data?.message?.message ? data?.message?.message : 'Added successfully'
        );
        client.invalidateQueries({ queryKey: [queryKeys.getAddress] });
        form.resetFields();
        setOpen(false);
        setEdit(false);
        setIdEdit(null);
        searchParams.delete('open');
        searchParams.delete('customer');
        searchParams.delete('Supplier');
        setSearchParams(searchParams);
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log('error:', error);
      },
    });
    const {
      data: costCenter,
      isLoading,
      refetch,
    } = useQuery({
      queryKey: [queryKeys.getAddress, editId],
      queryFn: () => getAddressDetails(editId),
      enabled: !!edit && !!editId,
    });

    const onFinish = (values) => {
      console.log('Success:', values);
      setLoadingAdd(true);
      onAddAddress({
        ...values,
        address_type: 'Billing',
        country: 'Saudi Arabia',
        county: 'SA',
        links: [
          {
            link_doctype: values.link_doctype,
            link_name: values?.customer,
            link_title: values?.customer,
            parentfield: 'Links',
            parenttype: 'Address',
            doctype: 'Dynamic Link',
          },
        ],
      });
    };
    // useEffect(() => {
    //   if (edit) {
    //     refetch();
    //   }
    // }, [edit]);

    useEffect(() => {
      if (edit && costCenter) {
        form.setFieldsValue({
          ...costCenter?.data,
          link_doctype: costCenter?.data?.links[0]?.link_doctype,
          customer: costCenter?.data?.links[0]?.link_name,
        });
      } else {
        form.resetFields();
      }
    }, [edit, costCenter, form]);
    // email_id
    // phone
    return (
      <Modal
        title={edit ? t.EditAddress : t.addAddress}
        open={open}
        onCancel={() => {
          setOpen(false);
          setEdit(false);
          setIdEdit(null);
          searchParams.delete('open');
          searchParams.delete('customer');
          searchParams.delete('Supplier');
          setSearchParams(searchParams);
        }}
        footer={null}
        width={600}
      >
        <Form
          form={form}
          name="add-address"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
        >
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: '50vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Row gutter={[16, 0]}>
              <Divider orientation="left">{t.Party}</Divider>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="link_doctype"
                  label={t.type}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                  initialValue={SupplierId ? 'Supplier' : 'Customer'}
                >
                  <Select
                    showSearch
                    placeholder={t.type}
                    options={[
                      {
                        label: t.Customer,
                        value: 'Customer',
                      },
                      {
                        label: t.Supplier,
                        value: 'Supplier',
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              {WatchLinkDoctype === 'Supplier' ? (
                <Col xs={24} md={12} xxl={12}>
                  <Form.Item
                    name="customer"
                    label={t.Supplier}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={SupplierId}
                  >
                    <Select
                      showSearch
                      placeholder={t.Supplier}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      loading={isLoadingSupplier}
                      options={dataSupplier?.data?.map((item) => ({
                        value: item?.name,
                        label: item?.customer_name,
                      }))}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <Col xs={24} md={12} xxl={12}>
                  <Form.Item
                    name="customer"
                    label={t.customers}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={customerId}
                  >
                    <Select
                      showSearch
                      placeholder={t.customers}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      loading={isLoadingCustomer}
                      options={dataCustomer?.data?.map((item) => ({
                        value: item?.name,
                        label: item?.customer_name,
                      }))}
                    />
                  </Form.Item>
                </Col>
              )}
              <Divider orientation="left">{t.Name}</Divider>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="address_title"
                  label={t.addressName}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input placeholder={t.addressName} />
                </Form.Item>
              </Col>
              <Divider orientation="left">{t.addressDetails}</Divider>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="address_line1"
                  label={t.street}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input placeholder={t.street} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="address_line2"
                  label={t.nieghborhood}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input placeholder={t.nieghborhood} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="custom_building_number"
                  label={t.custom_buiding_number}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input placeholder={t.custom_buiding_number} type="number" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="city"
                  label={t.city}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input placeholder={t.city} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="country"
                  label={t.country}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input placeholder={t.country} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="custom_area"
                  label={t.custom_area}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input placeholder={t.custom_area} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="state"
                  label={t.state}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input placeholder={t.state} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="pincode"
                  label={t.pincode}
                  rules={[
                    {
                      required: true,
                    },
                    {
                      pattern: /^\d{5}$/,
                      message: 'يجب أن يكون مكون من 5 أرقام',
                    },
                  ]}
                >
                  <Input placeholder={t.pincode} />
                </Form.Item>
              </Col>
              {/* <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="address_in_arabic"
                  label={t.address_in_arabic}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input placeholder={t.address_in_arabic} />
                </Form.Item>
              </Col> */}
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="email_id"
                  label={t.email}
                  rules={[
                    // {
                    //   required: true,
                    // },
                    {
                      type: 'email',
                    },
                  ]}
                >
                  <Input placeholder={t.email} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="phone"
                  label={t.Phone}
                  className="w-full"
                  rules={[
                    // {
                    //   required: true,
                    // },
                    {
                      validator: (rule, value) => {
                        console.log(value, 'value');
                        if (isValidPhoneNumber(value)) {
                          return Promise.resolve();
                        }
                        return Promise.reject('رقم الجوال غير صالح');
                      },
                    },
                  ]}
                  hasFeedback
                >
                  <PhoneInputWithCountrySelect
                    defaultCountry="SA"
                    className="w-full"
                    name="phone"
                    label={t.mobile}
                    international
                    hasFeedback
                    limitMaxLength={true}
                  />
                </Form.Item>
              </Col>

              <Col
                xs={24}
                md={12}
                xxl={12}
                className="flex items-center justify-start"
              >
                <Form.Item
                  name="disabled"
                  // label={t.disabled}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                  valuePropName="checked"
                  className="margin-bottom-0"
                >
                  <Checkbox>{t.disabled}</Checkbox>
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="is_primary_address"
                  // label={t.disabled}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                  valuePropName="checked"
                >
                  <Checkbox>{t.is_primary_address}</Checkbox>
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xxl={12}>
                <Form.Item
                  name="is_shipping_address"
                  // label={t.disabled}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                  valuePropName="checked"
                >
                  <Checkbox>{t.is_shipping_address}</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          )}
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
                setEdit(false);
                setIdEdit(null);
                searchParams.delete('open');
                searchParams.delete('customer');
                searchParams.delete('Supplier');
                setSearchParams(searchParams);
              }}
            >
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
);

export const ModalAppItemDetailsJournal = memo(
  ({ t, open, setOpen, dataSource, selectedIndex, setDataSource }) => {
    const [selectData, setSelectData] = useState(null);
    const [searchTextCostCenter, setSearchTextCostCenter] = useState('');
    const [searchTxtAll, setSearchTxtAll] = useState('');
    const duning = [];
    const { data: journalEntry } = useQuery({
      queryKey: [queryKeys.getSearchApiJournalEntry, searchTxtAll],
      queryFn: () =>
        getSearchApiSearchText({
          type: 'Journal Entry',
          searchTxt: searchTxtAll,
        }),
      enabled: searchTxtAll?.length >= 3 || searchTxtAll?.length === 0,
      keepPreviousData: true,
    });
    const { data: costCenter } = useQuery({
      queryKey: [queryKeys.getSearchCostCenter, searchTextCostCenter],
      queryFn: () => getSearchPatients('Cost Center', searchTextCostCenter),
      keepPreviousData: true,
      enabled:
        searchTextCostCenter?.length >= 3 || searchTextCostCenter?.length === 0,
    });
    const { data: salesInvoice } = useQuery({
      queryKey: [queryKeys.getSearchApiSalesInvoice, searchTxtAll],
      queryFn: () =>
        getSearchApiSearchText({
          type: 'Sales Invoice',
          searchTxt: searchTxtAll,
        }),
      enabled: searchTxtAll?.length >= 3 || searchTxtAll?.length === 0,
      keepPreviousData: true,
    });

    const { data: salesOrder } = useQuery({
      queryKey: [queryKeys.getSearchApiSalesOrder, searchTxtAll],
      queryFn: () =>
        getSearchApiSearchText({
          type: 'Sales Order',
          searchTxt: searchTxtAll,
        }),
      enabled: searchTxtAll?.length >= 3 || searchTxtAll?.length === 0,
      keepPreviousData: true,
    });
    useEffect(() => {
      if (open && dataSource) {
        setSelectData(dataSource[selectedIndex]);
      } else {
        setSelectData(null);
      }
    }, [dataSource, selectedIndex, open, selectData]);
    return (
      <Modal
        title={t.accountDetails}
        open={open}
        centered
        onCancel={() => {
          setOpen(false);
        }}
        footer={null}
        width={900}
      >
        <>
          <Descriptions column={2} bordered style={{ marginTop: '20px' }}>
            <Descriptions.Item label={t.Account}>
              {' '}
              {selectData?.account}
            </Descriptions.Item>
            <Descriptions.Item label={t.PartyType}>
              {' '}
              {selectData?.party_type}{' '}
            </Descriptions.Item>
            <Descriptions.Item label={t.Party}>
              {' '}
              {selectData?.party}{' '}
            </Descriptions.Item>
            <Descriptions.Item label={t.costCenter}>
              <Select
                placeholder={t.costCenter}
                style={{ width: '100%' }}
                showSearch
                optionFilterProp="children"
                filterOption={false}
                popupMatchSelectWidth={false}
                value={selectData?.cost_center}
                onSearch={(value) => setSearchTextCostCenter(value)}
                onChange={(value) => {
                  const newDataSource = [...dataSource];
                  newDataSource[selectedIndex] = {
                    ...newDataSource[selectedIndex],
                    cost_center: value,
                  };
                  setDataSource(newDataSource);
                }}
                options={costCenter?.message?.map((user) => ({
                  value: user.value,
                  label: user.value,
                }))}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t.reference_type}>
              <Select
                placeholder={t.reference_type}
                style={{ width: '100%' }}
                showSearch
                optionFilterProp="children"
                filterOption={false}
                popupMatchSelectWidth={false}
                value={selectData?.reference_type}
                onChange={(value) => {
                  const newDataSource = [...dataSource];
                  newDataSource[selectedIndex] = {
                    ...newDataSource[selectedIndex],
                    reference_type: value,
                  };
                  setDataSource(newDataSource);
                }}
                options={[
                  { value: 'Sales Invoice', label: t.salesInvoice },
                  {
                    value: 'Sales Order',
                    label: t.SalesOrder,
                  },
                  {
                    value: 'Duning',
                    label: t.Duning,
                  },
                  {
                    value: 'Journal Entry',
                    label: t.JournalEntry,
                  },
                ]}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t.reference_name}>
              <Select
                placeholder={t.reference_name}
                style={{ width: '100%' }}
                showSearch
                optionFilterProp="children"
                filterOption={false}
                popupMatchSelectWidth={false}
                value={selectData?.reference_name}
                onSearch={(value) => setSearchTextCostCenter(value)}
                onChange={(value) => {
                  setSearchTxtAll('');
                  const newDataSource = [...dataSource];
                  newDataSource[selectedIndex] = {
                    ...newDataSource[selectedIndex],
                    reference_name: value,
                  };
                  setDataSource(newDataSource);
                }}
                options={
                  dataSource[selectedIndex]?.reference_type === 'Journal Entry'
                    ? journalEntry?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))
                    : dataSource[selectedIndex]?.reference_type ===
                      'Sales Invoice'
                    ? salesInvoice?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))
                    : dataSource[selectedIndex]?.reference_type ===
                      'Sales Order'
                    ? salesOrder?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))
                    : duning?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))
                }
              />
            </Descriptions.Item>
          </Descriptions>
        </>
      </Modal>
    );
  }
);
